"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Arteco Extranet API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantRestControllerApiFactory = exports.ApplicantRestControllerApiFp = exports.ApplicantRestControllerApiAxiosParamCreator = exports.AdminSharedRestControllerApi = exports.AdminSharedRestControllerApiFactory = exports.AdminSharedRestControllerApiFp = exports.AdminSharedRestControllerApiAxiosParamCreator = exports.AdminBackupRestControllerApi = exports.AdminBackupRestControllerApiFactory = exports.AdminBackupRestControllerApiFp = exports.AdminBackupRestControllerApiAxiosParamCreator = exports.WorkCenterListCalendarEnum = exports.WorkCenterCalendarEnum = exports.WikiPageListTypeEnum = exports.WikiPageTypeEnum = exports.VacationRequestTypeEnum = exports.VacationRequestStateEnum = exports.VacationListCalendarEnum = exports.VacationListTypeEnum = exports.VacationListStateEnum = exports.VacationCalendarEnum = exports.VacationTypeEnum = exports.VacationStateEnum = exports.UserAuthItemTypeEnum = exports.SalaryListRoleLevelEnum = exports.SalaryListRoleEnum = exports.SalaryRoleLevelEnum = exports.SalaryRoleEnum = exports.RecruitmentListStatusEnum = exports.RecruitmentStatusEnum = exports.PersonListCalendarEnum = exports.PersonCalendarEnum = exports.PermissionListRolEnum = exports.PermissionRolEnum = exports.PayrollPackListTypeEnum = exports.PayrollPackTypeEnum = exports.HolidayListCalendarEnum = exports.HolidayCalendarEnum = exports.CandidateListWorkTypeEnum = exports.CandidateListCountryEnum = exports.CandidateFormWorkTypeEnum = exports.CandidateFormCountryEnum = exports.CandidateEventListTypeEnum = exports.CandidateEventTypeEnum = exports.CandidateWorkTypeEnum = exports.CandidateCountryEnum = exports.BackupListFrequencyEnum = exports.BackupListTypeEnum = exports.BackupFrequencyEnum = exports.BackupTypeEnum = void 0;
exports.CandidateTestRestControllerApiAxiosParamCreator = exports.CandidateStateRestControllerApi = exports.CandidateStateRestControllerApiFactory = exports.CandidateStateRestControllerApiFp = exports.CandidateStateRestControllerApiAxiosParamCreator = exports.CandidateSourceRestControllerApi = exports.CandidateSourceRestControllerApiFactory = exports.CandidateSourceRestControllerApiFp = exports.CandidateSourceRestControllerApiAxiosParamCreator = exports.CandidateRestControllerApi = exports.CandidateRestControllerApiFactory = exports.CandidateRestControllerApiFp = exports.CandidateRestControllerApiAxiosParamCreator = exports.CandidateRequestRestControllerApi = exports.CandidateRequestRestControllerApiFactory = exports.CandidateRequestRestControllerApiFp = exports.CandidateRequestRestControllerApiAxiosParamCreator = exports.CandidateLevelTestRestControllerApi = exports.CandidateLevelTestRestControllerApiFactory = exports.CandidateLevelTestRestControllerApiFp = exports.CandidateLevelTestRestControllerApiAxiosParamCreator = exports.CandidateLevelSolutionRestControllerApi = exports.CandidateLevelSolutionRestControllerApiFactory = exports.CandidateLevelSolutionRestControllerApiFp = exports.CandidateLevelSolutionRestControllerApiAxiosParamCreator = exports.CandidateEventRestControllerApi = exports.CandidateEventRestControllerApiFactory = exports.CandidateEventRestControllerApiFp = exports.CandidateEventRestControllerApiAxiosParamCreator = exports.CandidateDocumentRestControllerApi = exports.CandidateDocumentRestControllerApiFactory = exports.CandidateDocumentRestControllerApiFp = exports.CandidateDocumentRestControllerApiAxiosParamCreator = exports.BudgetRestControllerApi = exports.BudgetRestControllerApiFactory = exports.BudgetRestControllerApiFp = exports.BudgetRestControllerApiAxiosParamCreator = exports.BillRestControllerApi = exports.BillRestControllerApiFactory = exports.BillRestControllerApiFp = exports.BillRestControllerApiAxiosParamCreator = exports.BillDiscountRestControllerApi = exports.BillDiscountRestControllerApiFactory = exports.BillDiscountRestControllerApiFp = exports.BillDiscountRestControllerApiAxiosParamCreator = exports.ApplicantStateRestControllerApi = exports.ApplicantStateRestControllerApiFactory = exports.ApplicantStateRestControllerApiFp = exports.ApplicantStateRestControllerApiAxiosParamCreator = exports.ApplicantRestControllerApi = void 0;
exports.EmployeeRestControllerApiFactory = exports.EmployeeRestControllerApiFp = exports.EmployeeRestControllerApiAxiosParamCreator = exports.EmpVacationRestControllerApi = exports.EmpVacationRestControllerApiFactory = exports.EmpVacationRestControllerApiFp = exports.EmpVacationRestControllerApiAxiosParamCreator = exports.EmpUploadRestControllerApi = exports.EmpUploadRestControllerApiFactory = exports.EmpUploadRestControllerApiFp = exports.EmpUploadRestControllerApiAxiosParamCreator = exports.EmpStatsRestControllerApi = exports.EmpStatsRestControllerApiFactory = exports.EmpStatsRestControllerApiFp = exports.EmpStatsRestControllerApiAxiosParamCreator = exports.EmpManagerRestControllerApi = exports.EmpManagerRestControllerApiFactory = exports.EmpManagerRestControllerApiFp = exports.EmpManagerRestControllerApiAxiosParamCreator = exports.EmpLearningRestControllerApi = exports.EmpLearningRestControllerApiFactory = exports.EmpLearningRestControllerApiFp = exports.EmpLearningRestControllerApiAxiosParamCreator = exports.EmpEvaluationRestControllerApi = exports.EmpEvaluationRestControllerApiFactory = exports.EmpEvaluationRestControllerApiFp = exports.EmpEvaluationRestControllerApiAxiosParamCreator = exports.EmpDocumentRestControllerApi = exports.EmpDocumentRestControllerApiFactory = exports.EmpDocumentRestControllerApiFp = exports.EmpDocumentRestControllerApiAxiosParamCreator = exports.DocumentRestControllerApi = exports.DocumentRestControllerApiFactory = exports.DocumentRestControllerApiFp = exports.DocumentRestControllerApiAxiosParamCreator = exports.DedicationRestControllerApi = exports.DedicationRestControllerApiFactory = exports.DedicationRestControllerApiFp = exports.DedicationRestControllerApiAxiosParamCreator = exports.CustomerRestControllerApi = exports.CustomerRestControllerApiFactory = exports.CustomerRestControllerApiFp = exports.CustomerRestControllerApiAxiosParamCreator = exports.CandidateTypeRestControllerApi = exports.CandidateTypeRestControllerApiFactory = exports.CandidateTypeRestControllerApiFp = exports.CandidateTypeRestControllerApiAxiosParamCreator = exports.CandidateTestRestControllerApi = exports.CandidateTestRestControllerApiFactory = exports.CandidateTestRestControllerApiFp = void 0;
exports.PersonDocumentTypeRestControllerApiAxiosParamCreator = exports.PersonDocumentRestControllerApi = exports.PersonDocumentRestControllerApiFactory = exports.PersonDocumentRestControllerApiFp = exports.PersonDocumentRestControllerApiAxiosParamCreator = exports.PayrollRestControllerApi = exports.PayrollRestControllerApiFactory = exports.PayrollRestControllerApiFp = exports.PayrollRestControllerApiAxiosParamCreator = exports.PayrollPackRestControllerApi = exports.PayrollPackRestControllerApiFactory = exports.PayrollPackRestControllerApiFp = exports.PayrollPackRestControllerApiAxiosParamCreator = exports.OrganizationUnitRestControllerApi = exports.OrganizationUnitRestControllerApiFactory = exports.OrganizationUnitRestControllerApiFp = exports.OrganizationUnitRestControllerApiAxiosParamCreator = exports.OrganizationUnitMemberRestControllerApi = exports.OrganizationUnitMemberRestControllerApiFactory = exports.OrganizationUnitMemberRestControllerApiFp = exports.OrganizationUnitMemberRestControllerApiAxiosParamCreator = exports.OccupationRestControllerApi = exports.OccupationRestControllerApiFactory = exports.OccupationRestControllerApiFp = exports.OccupationRestControllerApiAxiosParamCreator = exports.InterviewRestControllerApi = exports.InterviewRestControllerApiFactory = exports.InterviewRestControllerApiFp = exports.InterviewRestControllerApiAxiosParamCreator = exports.HolidayRestControllerApi = exports.HolidayRestControllerApiFactory = exports.HolidayRestControllerApiFp = exports.HolidayRestControllerApiAxiosParamCreator = exports.EvaluationResultRestControllerApi = exports.EvaluationResultRestControllerApiFactory = exports.EvaluationResultRestControllerApiFp = exports.EvaluationResultRestControllerApiAxiosParamCreator = exports.EvaluationRestControllerApi = exports.EvaluationRestControllerApiFactory = exports.EvaluationRestControllerApiFp = exports.EvaluationRestControllerApiAxiosParamCreator = exports.EvaluationPointRestControllerApi = exports.EvaluationPointRestControllerApiFactory = exports.EvaluationPointRestControllerApiFp = exports.EvaluationPointRestControllerApiAxiosParamCreator = exports.EmployeeStatsRestControllerApi = exports.EmployeeStatsRestControllerApiFactory = exports.EmployeeStatsRestControllerApiFp = exports.EmployeeStatsRestControllerApiAxiosParamCreator = exports.EmployeeRestControllerApi = void 0;
exports.SkillRestControllerApiFactory = exports.SkillRestControllerApiFp = exports.SkillRestControllerApiAxiosParamCreator = exports.SkillLevelRestControllerApi = exports.SkillLevelRestControllerApiFactory = exports.SkillLevelRestControllerApiFp = exports.SkillLevelRestControllerApiAxiosParamCreator = exports.SalaryRestControllerApi = exports.SalaryRestControllerApiFactory = exports.SalaryRestControllerApiFp = exports.SalaryRestControllerApiAxiosParamCreator = exports.RedmineMappingRestControllerApi = exports.RedmineMappingRestControllerApiFactory = exports.RedmineMappingRestControllerApiFp = exports.RedmineMappingRestControllerApiAxiosParamCreator = exports.RecruitmentStatsRestControllerApi = exports.RecruitmentStatsRestControllerApiFactory = exports.RecruitmentStatsRestControllerApiFp = exports.RecruitmentStatsRestControllerApiAxiosParamCreator = exports.RecruitmentRestControllerApi = exports.RecruitmentRestControllerApiFactory = exports.RecruitmentRestControllerApiFp = exports.RecruitmentRestControllerApiAxiosParamCreator = exports.RecruitmentDocumentRestControllerApi = exports.RecruitmentDocumentRestControllerApiFactory = exports.RecruitmentDocumentRestControllerApiFp = exports.RecruitmentDocumentRestControllerApiAxiosParamCreator = exports.PublicContactRestControllerApi = exports.PublicContactRestControllerApiFactory = exports.PublicContactRestControllerApiFp = exports.PublicContactRestControllerApiAxiosParamCreator = exports.PubCustomerSupportRestControllerApi = exports.PubCustomerSupportRestControllerApiFactory = exports.PubCustomerSupportRestControllerApiFp = exports.PubCustomerSupportRestControllerApiAxiosParamCreator = exports.PersonRestControllerApi = exports.PersonRestControllerApiFactory = exports.PersonRestControllerApiFp = exports.PersonRestControllerApiAxiosParamCreator = exports.PersonReminderRestControllerApi = exports.PersonReminderRestControllerApiFactory = exports.PersonReminderRestControllerApiFp = exports.PersonReminderRestControllerApiAxiosParamCreator = exports.PersonEventRestControllerApi = exports.PersonEventRestControllerApiFactory = exports.PersonEventRestControllerApiFp = exports.PersonEventRestControllerApiAxiosParamCreator = exports.PersonDocumentTypeRestControllerApi = exports.PersonDocumentTypeRestControllerApiFactory = exports.PersonDocumentTypeRestControllerApiFp = void 0;
exports.WorkAuditControllerApiAxiosParamCreator = exports.WikiPageRestControllerApi = exports.WikiPageRestControllerApiFactory = exports.WikiPageRestControllerApiFp = exports.WikiPageRestControllerApiAxiosParamCreator = exports.VacationRestControllerApi = exports.VacationRestControllerApiFactory = exports.VacationRestControllerApiFp = exports.VacationRestControllerApiAxiosParamCreator = exports.UserRestControllerApi = exports.UserRestControllerApiFactory = exports.UserRestControllerApiFp = exports.UserRestControllerApiAxiosParamCreator = exports.TrainingLevelRestControllerApi = exports.TrainingLevelRestControllerApiFactory = exports.TrainingLevelRestControllerApiFp = exports.TrainingLevelRestControllerApiAxiosParamCreator = exports.TemplateRestControllerApi = exports.TemplateRestControllerApiFactory = exports.TemplateRestControllerApiFp = exports.TemplateRestControllerApiAxiosParamCreator = exports.SupportResultRestControllerApi = exports.SupportResultRestControllerApiFactory = exports.SupportResultRestControllerApiFp = exports.SupportResultRestControllerApiAxiosParamCreator = exports.SupportRestControllerApi = exports.SupportRestControllerApiFactory = exports.SupportRestControllerApiFp = exports.SupportRestControllerApiAxiosParamCreator = exports.SupportPointRestControllerApi = exports.SupportPointRestControllerApiFactory = exports.SupportPointRestControllerApiFp = exports.SupportPointRestControllerApiAxiosParamCreator = exports.SupportLinkRestControllerApi = exports.SupportLinkRestControllerApiFactory = exports.SupportLinkRestControllerApiFp = exports.SupportLinkRestControllerApiAxiosParamCreator = exports.SupportGroupRestControllerApi = exports.SupportGroupRestControllerApiFactory = exports.SupportGroupRestControllerApiFp = exports.SupportGroupRestControllerApiAxiosParamCreator = exports.SuperUserRestControllerApi = exports.SuperUserRestControllerApiFactory = exports.SuperUserRestControllerApiFp = exports.SuperUserRestControllerApiAxiosParamCreator = exports.SuperParamRestControllerApi = exports.SuperParamRestControllerApiFactory = exports.SuperParamRestControllerApiFp = exports.SuperParamRestControllerApiAxiosParamCreator = exports.SkillRestControllerApi = void 0;
exports.WorkCenterRestControllerApi = exports.WorkCenterRestControllerApiFactory = exports.WorkCenterRestControllerApiFp = exports.WorkCenterRestControllerApiAxiosParamCreator = exports.WorkBookingRestControllerApi = exports.WorkBookingRestControllerApiFactory = exports.WorkBookingRestControllerApiFp = exports.WorkBookingRestControllerApiAxiosParamCreator = exports.WorkAuditControllerApi = exports.WorkAuditControllerApiFactory = exports.WorkAuditControllerApiFp = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.BackupTypeEnum = {
    DB_MYSQL: 'DB_MYSQL',
    K8S_FILE_SYSTEM: 'K8S_FILE_SYSTEM'
};
exports.BackupFrequencyEnum = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
};
exports.BackupListTypeEnum = {
    DB_MYSQL: 'DB_MYSQL',
    K8S_FILE_SYSTEM: 'K8S_FILE_SYSTEM'
};
exports.BackupListFrequencyEnum = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
};
exports.CandidateCountryEnum = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    GZ: 'GZ',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    XK: 'XK',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};
exports.CandidateWorkTypeEnum = {
    FULL_DAY: 'FULL_DAY',
    PART_DAY: 'PART_DAY',
    PRACTICE: 'PRACTICE'
};
exports.CandidateEventTypeEnum = {
    NOTE: 'NOTE',
    EMAIL: 'EMAIL',
    CALL: 'CALL',
    INTERVIEW: 'INTERVIEW',
    LEVEL_TEST: 'LEVEL_TEST',
    PROFILE_UPDATE: 'PROFILE_UPDATE'
};
exports.CandidateEventListTypeEnum = {
    NOTE: 'NOTE',
    EMAIL: 'EMAIL',
    CALL: 'CALL',
    INTERVIEW: 'INTERVIEW',
    LEVEL_TEST: 'LEVEL_TEST',
    PROFILE_UPDATE: 'PROFILE_UPDATE'
};
exports.CandidateFormCountryEnum = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    GZ: 'GZ',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    XK: 'XK',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};
exports.CandidateFormWorkTypeEnum = {
    FULL_DAY: 'FULL_DAY',
    PART_DAY: 'PART_DAY',
    PRACTICE: 'PRACTICE'
};
exports.CandidateListCountryEnum = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    GZ: 'GZ',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    XK: 'XK',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};
exports.CandidateListWorkTypeEnum = {
    FULL_DAY: 'FULL_DAY',
    PART_DAY: 'PART_DAY',
    PRACTICE: 'PRACTICE'
};
exports.HolidayCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.HolidayListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.PayrollPackTypeEnum = {
    PLA: 'PLA',
    OTHER: 'OTHER'
};
exports.PayrollPackListTypeEnum = {
    PLA: 'PLA',
    OTHER: 'OTHER'
};
exports.PermissionRolEnum = {
    SUPERADMIN: 'SUPERADMIN',
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
exports.PermissionListRolEnum = {
    SUPERADMIN: 'SUPERADMIN',
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
exports.PersonCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.PersonListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.RecruitmentStatusEnum = {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED',
    DESISTED: 'DESISTED'
};
exports.RecruitmentListStatusEnum = {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED',
    DESISTED: 'DESISTED'
};
exports.SalaryRoleEnum = {
    DEVELOPER: 'DEVELOPER',
    TEAM_LEAD: 'TEAM_LEAD',
    TECH_LEAD: 'TECH_LEAD',
    ARCHITECT: 'ARCHITECT',
    PROJECT_MANAGER: 'PROJECT_MANAGER',
    SUPPORT: 'SUPPORT'
};
exports.SalaryRoleLevelEnum = {
    PRACTICE: 'PRACTICE',
    JUNIOR: 'JUNIOR',
    MID: 'MID',
    SENIOR: 'SENIOR'
};
exports.SalaryListRoleEnum = {
    DEVELOPER: 'DEVELOPER',
    TEAM_LEAD: 'TEAM_LEAD',
    TECH_LEAD: 'TECH_LEAD',
    ARCHITECT: 'ARCHITECT',
    PROJECT_MANAGER: 'PROJECT_MANAGER',
    SUPPORT: 'SUPPORT'
};
exports.SalaryListRoleLevelEnum = {
    PRACTICE: 'PRACTICE',
    JUNIOR: 'JUNIOR',
    MID: 'MID',
    SENIOR: 'SENIOR'
};
exports.UserAuthItemTypeEnum = {
    SUPERADMIN: 'SUPERADMIN',
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
exports.VacationStateEnum = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
exports.VacationTypeEnum = {
    HOLIDAY: 'HOLIDAY',
    SICK_LEAVE: 'SICK_LEAVE',
    PATERNITY_LEAVE: 'PATERNITY_LEAVE',
    ERTE: 'ERTE',
    ERTE_50: 'ERTE_50',
    GIFT: 'GIFT',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    UNPAID_LEAVE: 'UNPAID_LEAVE',
    FAMILIAR_HOSPITALIZATION: 'FAMILIAR_HOSPITALIZATION'
};
exports.VacationCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.VacationListStateEnum = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
exports.VacationListTypeEnum = {
    HOLIDAY: 'HOLIDAY',
    SICK_LEAVE: 'SICK_LEAVE',
    PATERNITY_LEAVE: 'PATERNITY_LEAVE',
    ERTE: 'ERTE',
    ERTE_50: 'ERTE_50',
    GIFT: 'GIFT',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    UNPAID_LEAVE: 'UNPAID_LEAVE',
    FAMILIAR_HOSPITALIZATION: 'FAMILIAR_HOSPITALIZATION'
};
exports.VacationListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.VacationRequestStateEnum = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
exports.VacationRequestTypeEnum = {
    HOLIDAY: 'HOLIDAY',
    SICK_LEAVE: 'SICK_LEAVE',
    PATERNITY_LEAVE: 'PATERNITY_LEAVE',
    ERTE: 'ERTE',
    ERTE_50: 'ERTE_50',
    GIFT: 'GIFT',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    UNPAID_LEAVE: 'UNPAID_LEAVE',
    FAMILIAR_HOSPITALIZATION: 'FAMILIAR_HOSPITALIZATION'
};
exports.WikiPageTypeEnum = {
    PLAIN_TEXT: 'PLAIN_TEXT',
    MARKDOWN: 'MARKDOWN'
};
exports.WikiPageListTypeEnum = {
    PLAIN_TEXT: 'PLAIN_TEXT',
    MARKDOWN: 'MARKDOWN'
};
exports.WorkCenterCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
exports.WorkCenterListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
/**
 * AdminBackupRestControllerApi - axios parameter creator
 * @export
 */
const AdminBackupRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBackup: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/system/backup/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBackup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissBackup', 'id', id);
            const localVarPath = `/api/admin/system/backup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBackup: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchBackup', 'ids', ids);
            const localVarPath = `/api/admin/system/backup/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} backupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBackup: (backupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'backupId' is not null or undefined
            (0, common_1.assertParamExists)('duplicateBackup', 'backupId', backupId);
            const localVarPath = `/api/admin/system/backup/{backupId}/duplicate`
                .replace(`{${"backupId"}}`, encodeURIComponent(String(backupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeBackup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('executeBackup', 'id', id);
            const localVarPath = `/api/admin/system/backup/execute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBackup', 'id', id);
            const localVarPath = `/api/admin/system/backup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackup: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/system/backup/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBackup: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/system/backup/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Backup} backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBackup: (backup, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'backup' is not null or undefined
            (0, common_1.assertParamExists)('saveBackup', 'backup', backup);
            const localVarPath = `/api/admin/system/backup/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(backup, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdminBackupRestControllerApiAxiosParamCreator = AdminBackupRestControllerApiAxiosParamCreator;
/**
 * AdminBackupRestControllerApi - functional programming interface
 * @export
 */
const AdminBackupRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminBackupRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBackup(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countBackup(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.countBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBackup(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissBackup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.deleteOrDismissBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBackup(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchBackup(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.deleteOrDismissInBatchBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} backupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBackup(backupId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.duplicateBackup(backupId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.duplicateBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeBackup(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.executeBackup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.executeBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackup(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBackup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.getBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackup(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBackup(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.listBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBackup(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageBackup(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.pageBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Backup} backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBackup(backup, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveBackup(backup, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminBackupRestControllerApi.saveBackup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AdminBackupRestControllerApiFp = AdminBackupRestControllerApiFp;
/**
 * AdminBackupRestControllerApi - factory interface
 * @export
 */
const AdminBackupRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminBackupRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBackup(term, showDismissed, options) {
            return localVarFp.countBackup(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBackup(id, options) {
            return localVarFp.deleteOrDismissBackup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBackup(ids, options) {
            return localVarFp.deleteOrDismissInBatchBackup(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} backupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBackup(backupId, options) {
            return localVarFp.duplicateBackup(backupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeBackup(id, options) {
            return localVarFp.executeBackup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackup(id, options) {
            return localVarFp.getBackup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBackup(term, showDismissed, options) {
            return localVarFp.listBackup(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBackup(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageBackup(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Backup} backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBackup(backup, options) {
            return localVarFp.saveBackup(backup, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdminBackupRestControllerApiFactory = AdminBackupRestControllerApiFactory;
/**
 * AdminBackupRestControllerApi - object-oriented interface
 * @export
 * @class AdminBackupRestControllerApi
 * @extends {BaseAPI}
 */
class AdminBackupRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    countBackup(term, showDismissed, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).countBackup(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    deleteOrDismissBackup(id, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).deleteOrDismissBackup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    deleteOrDismissInBatchBackup(ids, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).deleteOrDismissInBatchBackup(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} backupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    duplicateBackup(backupId, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).duplicateBackup(backupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    executeBackup(id, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).executeBackup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    getBackup(id, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).getBackup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    listBackup(term, showDismissed, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).listBackup(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    pageBackup(page, size, sort, term, showDismissed, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).pageBackup(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Backup} backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBackupRestControllerApi
     */
    saveBackup(backup, options) {
        return (0, exports.AdminBackupRestControllerApiFp)(this.configuration).saveBackup(backup, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminBackupRestControllerApi = AdminBackupRestControllerApi;
/**
 * AdminSharedRestControllerApi - axios parameter creator
 * @export
 */
const AdminSharedRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomers: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/shared/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePeople: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/shared/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdminSharedRestControllerApiAxiosParamCreator = AdminSharedRestControllerApiAxiosParamCreator;
/**
 * AdminSharedRestControllerApi - functional programming interface
 * @export
 */
const AdminSharedRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminSharedRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomers(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveCustomers(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminSharedRestControllerApi.retrieveCustomers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePeople(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePeople(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminSharedRestControllerApi.retrievePeople']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AdminSharedRestControllerApiFp = AdminSharedRestControllerApiFp;
/**
 * AdminSharedRestControllerApi - factory interface
 * @export
 */
const AdminSharedRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminSharedRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomers(term, showDismissed, options) {
            return localVarFp.retrieveCustomers(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePeople(term, showDismissed, options) {
            return localVarFp.retrievePeople(term, showDismissed, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdminSharedRestControllerApiFactory = AdminSharedRestControllerApiFactory;
/**
 * AdminSharedRestControllerApi - object-oriented interface
 * @export
 * @class AdminSharedRestControllerApi
 * @extends {BaseAPI}
 */
class AdminSharedRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSharedRestControllerApi
     */
    retrieveCustomers(term, showDismissed, options) {
        return (0, exports.AdminSharedRestControllerApiFp)(this.configuration).retrieveCustomers(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSharedRestControllerApi
     */
    retrievePeople(term, showDismissed, options) {
        return (0, exports.AdminSharedRestControllerApiFp)(this.configuration).retrievePeople(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminSharedRestControllerApi = AdminSharedRestControllerApi;
/**
 * ApplicantRestControllerApi - axios parameter creator
 * @export
 */
const ApplicantRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} applicationId
         * @param {number} targetRecruitmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyApplicant: (applicationId, targetRecruitmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applicationId' is not null or undefined
            (0, common_1.assertParamExists)('copyApplicant', 'applicationId', applicationId);
            // verify required parameter 'targetRecruitmentId' is not null or undefined
            (0, common_1.assertParamExists)('copyApplicant', 'targetRecruitmentId', targetRecruitmentId);
            const localVarPath = `/api/admin/recruitment/applicant/copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (applicationId !== undefined) {
                localVarQueryParameter['applicationId'] = applicationId;
            }
            if (targetRecruitmentId !== undefined) {
                localVarQueryParameter['targetRecruitmentId'] = targetRecruitmentId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicant: (candidateId, recruitmentId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/applicant/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicant: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissApplicant', 'id', id);
            const localVarPath = `/api/admin/recruitment/applicant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicant: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchApplicant', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/applicant/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getApplicant', 'id', id);
            const localVarPath = `/api/admin/recruitment/applicant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicant: (candidateId, recruitmentId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/applicant/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicant: (page, size, sort, candidateId, recruitmentId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/applicant/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicant: (applicant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applicant' is not null or undefined
            (0, common_1.assertParamExists)('saveApplicant', 'applicant', applicant);
            const localVarPath = `/api/admin/recruitment/applicant/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applicant, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ApplicantRestControllerApiAxiosParamCreator = ApplicantRestControllerApiAxiosParamCreator;
/**
 * ApplicantRestControllerApi - functional programming interface
 * @export
 */
const ApplicantRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ApplicantRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} applicationId
         * @param {number} targetRecruitmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyApplicant(applicationId, targetRecruitmentId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.copyApplicant(applicationId, targetRecruitmentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.copyApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countApplicant(candidateId, recruitmentId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.countApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicant(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissApplicant(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.deleteOrDismissApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicant(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchApplicant(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.deleteOrDismissInBatchApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicant(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.getApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApplicant(candidateId, recruitmentId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.listApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.pageApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicant(applicant, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveApplicant(applicant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantRestControllerApi.saveApplicant']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ApplicantRestControllerApiFp = ApplicantRestControllerApiFp;
/**
 * ApplicantRestControllerApi - factory interface
 * @export
 */
const ApplicantRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ApplicantRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} applicationId
         * @param {number} targetRecruitmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyApplicant(applicationId, targetRecruitmentId, options) {
            return localVarFp.copyApplicant(applicationId, targetRecruitmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            return localVarFp.countApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicant(id, options) {
            return localVarFp.deleteOrDismissApplicant(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicant(ids, options) {
            return localVarFp.deleteOrDismissInBatchApplicant(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant(id, options) {
            return localVarFp.getApplicant(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            return localVarFp.listApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options) {
            return localVarFp.pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicant(applicant, options) {
            return localVarFp.saveApplicant(applicant, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ApplicantRestControllerApiFactory = ApplicantRestControllerApiFactory;
/**
 * ApplicantRestControllerApi - object-oriented interface
 * @export
 * @class ApplicantRestControllerApi
 * @extends {BaseAPI}
 */
class ApplicantRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} applicationId
     * @param {number} targetRecruitmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    copyApplicant(applicationId, targetRecruitmentId, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).copyApplicant(applicationId, targetRecruitmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [candidateId]
     * @param {number} [recruitmentId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    countApplicant(candidateId, recruitmentId, term, showDismissed, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).countApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    deleteOrDismissApplicant(id, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).deleteOrDismissApplicant(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    deleteOrDismissInBatchApplicant(ids, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).deleteOrDismissInBatchApplicant(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    getApplicant(id, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).getApplicant(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [candidateId]
     * @param {number} [recruitmentId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    listApplicant(candidateId, recruitmentId, term, showDismissed, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).listApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [candidateId]
     * @param {number} [recruitmentId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Applicant} applicant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    saveApplicant(applicant, options) {
        return (0, exports.ApplicantRestControllerApiFp)(this.configuration).saveApplicant(applicant, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ApplicantRestControllerApi = ApplicantRestControllerApi;
/**
 * ApplicantStateRestControllerApi - axios parameter creator
 * @export
 */
const ApplicantStateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicantState: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/state/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicantState: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissApplicantState', 'id', id);
            const localVarPath = `/api/admin/recruitment/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicantState: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchApplicantState', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/state/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantState: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getApplicantState', 'id', id);
            const localVarPath = `/api/admin/recruitment/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicantState: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/state/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicantState: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/state/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApplicantState} applicantState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicantState: (applicantState, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applicantState' is not null or undefined
            (0, common_1.assertParamExists)('saveApplicantState', 'applicantState', applicantState);
            const localVarPath = `/api/admin/recruitment/state/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applicantState, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ApplicantStateRestControllerApiAxiosParamCreator = ApplicantStateRestControllerApiAxiosParamCreator;
/**
 * ApplicantStateRestControllerApi - functional programming interface
 * @export
 */
const ApplicantStateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ApplicantStateRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicantState(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countApplicantState(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.countApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicantState(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissApplicantState(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.deleteOrDismissApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicantState(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchApplicantState(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.deleteOrDismissInBatchApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantState(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicantState(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.getApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicantState(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApplicantState(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.listApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicantState(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageApplicantState(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.pageApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ApplicantState} applicantState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicantState(applicantState, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveApplicantState(applicantState, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicantStateRestControllerApi.saveApplicantState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ApplicantStateRestControllerApiFp = ApplicantStateRestControllerApiFp;
/**
 * ApplicantStateRestControllerApi - factory interface
 * @export
 */
const ApplicantStateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ApplicantStateRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicantState(term, showDismissed, options) {
            return localVarFp.countApplicantState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicantState(id, options) {
            return localVarFp.deleteOrDismissApplicantState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicantState(ids, options) {
            return localVarFp.deleteOrDismissInBatchApplicantState(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantState(id, options) {
            return localVarFp.getApplicantState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicantState(term, showDismissed, options) {
            return localVarFp.listApplicantState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicantState(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageApplicantState(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApplicantState} applicantState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicantState(applicantState, options) {
            return localVarFp.saveApplicantState(applicantState, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ApplicantStateRestControllerApiFactory = ApplicantStateRestControllerApiFactory;
/**
 * ApplicantStateRestControllerApi - object-oriented interface
 * @export
 * @class ApplicantStateRestControllerApi
 * @extends {BaseAPI}
 */
class ApplicantStateRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    countApplicantState(term, showDismissed, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).countApplicantState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    deleteOrDismissApplicantState(id, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).deleteOrDismissApplicantState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    deleteOrDismissInBatchApplicantState(ids, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).deleteOrDismissInBatchApplicantState(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    getApplicantState(id, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).getApplicantState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    listApplicantState(term, showDismissed, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).listApplicantState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    pageApplicantState(page, size, sort, term, showDismissed, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).pageApplicantState(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApplicantState} applicantState
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    saveApplicantState(applicantState, options) {
        return (0, exports.ApplicantStateRestControllerApiFp)(this.configuration).saveApplicantState(applicantState, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ApplicantStateRestControllerApi = ApplicantStateRestControllerApi;
/**
 * BillDiscountRestControllerApi - axios parameter creator
 * @export
 */
const BillDiscountRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} discountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendLineBillDiscount: (discountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'discountId' is not null or undefined
            (0, common_1.assertParamExists)('appendLineBillDiscount', 'discountId', discountId);
            const localVarPath = `/api/admin/billing/discount/{discountId}/appendLine`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBillDiscount: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/discount/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBillDiscount: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissBillDiscount', 'id', id);
            const localVarPath = `/api/admin/billing/discount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBillDiscount: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchBillDiscount', 'ids', ids);
            const localVarPath = `/api/admin/billing/discount/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDiscount: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBillDiscount', 'id', id);
            const localVarPath = `/api/admin/billing/discount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryBillDiscount: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('getSummaryBillDiscount', 'year', year);
            const localVarPath = `/api/admin/billing/discount/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillDiscount: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/discount/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillDiscount: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/discount/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} discountId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBillDiscount: (discountId, lineIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'discountId' is not null or undefined
            (0, common_1.assertParamExists)('removeLinesBillDiscount', 'discountId', discountId);
            // verify required parameter 'lineIds' is not null or undefined
            (0, common_1.assertParamExists)('removeLinesBillDiscount', 'lineIds', lineIds);
            const localVarPath = `/api/admin/billing/discount/{discountId}/removeLines`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (lineIds) {
                localVarQueryParameter['lineIds'] = lineIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BillDiscount} billDiscount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillDiscount: (billDiscount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billDiscount' is not null or undefined
            (0, common_1.assertParamExists)('saveBillDiscount', 'billDiscount', billDiscount);
            const localVarPath = `/api/admin/billing/discount/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(billDiscount, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BillDiscountRestControllerApiAxiosParamCreator = BillDiscountRestControllerApiAxiosParamCreator;
/**
 * BillDiscountRestControllerApi - functional programming interface
 * @export
 */
const BillDiscountRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BillDiscountRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} discountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendLineBillDiscount(discountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appendLineBillDiscount(discountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.appendLineBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBillDiscount(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countBillDiscount(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.countBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBillDiscount(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissBillDiscount(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.deleteOrDismissBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBillDiscount(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchBillDiscount(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.deleteOrDismissInBatchBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDiscount(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillDiscount(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.getBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryBillDiscount(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSummaryBillDiscount(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.getSummaryBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillDiscount(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBillDiscount(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.listBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillDiscount(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageBillDiscount(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.pageBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} discountId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBillDiscount(discountId, lineIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeLinesBillDiscount(discountId, lineIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.removeLinesBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {BillDiscount} billDiscount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillDiscount(billDiscount, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveBillDiscount(billDiscount, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillDiscountRestControllerApi.saveBillDiscount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.BillDiscountRestControllerApiFp = BillDiscountRestControllerApiFp;
/**
 * BillDiscountRestControllerApi - factory interface
 * @export
 */
const BillDiscountRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BillDiscountRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} discountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendLineBillDiscount(discountId, options) {
            return localVarFp.appendLineBillDiscount(discountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBillDiscount(term, showDismissed, options) {
            return localVarFp.countBillDiscount(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBillDiscount(id, options) {
            return localVarFp.deleteOrDismissBillDiscount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBillDiscount(ids, options) {
            return localVarFp.deleteOrDismissInBatchBillDiscount(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDiscount(id, options) {
            return localVarFp.getBillDiscount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryBillDiscount(year, options) {
            return localVarFp.getSummaryBillDiscount(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillDiscount(term, showDismissed, options) {
            return localVarFp.listBillDiscount(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillDiscount(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageBillDiscount(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} discountId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBillDiscount(discountId, lineIds, options) {
            return localVarFp.removeLinesBillDiscount(discountId, lineIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BillDiscount} billDiscount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillDiscount(billDiscount, options) {
            return localVarFp.saveBillDiscount(billDiscount, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BillDiscountRestControllerApiFactory = BillDiscountRestControllerApiFactory;
/**
 * BillDiscountRestControllerApi - object-oriented interface
 * @export
 * @class BillDiscountRestControllerApi
 * @extends {BaseAPI}
 */
class BillDiscountRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} discountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    appendLineBillDiscount(discountId, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).appendLineBillDiscount(discountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    countBillDiscount(term, showDismissed, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).countBillDiscount(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    deleteOrDismissBillDiscount(id, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).deleteOrDismissBillDiscount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    deleteOrDismissInBatchBillDiscount(ids, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).deleteOrDismissInBatchBillDiscount(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    getBillDiscount(id, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).getBillDiscount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    getSummaryBillDiscount(year, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).getSummaryBillDiscount(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    listBillDiscount(term, showDismissed, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).listBillDiscount(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    pageBillDiscount(page, size, sort, term, showDismissed, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).pageBillDiscount(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} discountId
     * @param {Array<number>} lineIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    removeLinesBillDiscount(discountId, lineIds, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).removeLinesBillDiscount(discountId, lineIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillDiscount} billDiscount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    saveBillDiscount(billDiscount, options) {
        return (0, exports.BillDiscountRestControllerApiFp)(this.configuration).saveBillDiscount(billDiscount, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BillDiscountRestControllerApi = BillDiscountRestControllerApi;
/**
 * BillRestControllerApi - axios parameter creator
 * @export
 */
const BillRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryBill: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('annualSummaryBill', 'year', year);
            const localVarPath = `/api/admin/billing/bill/annual-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} bills
         * @param {boolean} sent
         * @param {string} [separator]
         * @param {boolean} [simulate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCreateBill: (bills, sent, separator, simulate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bills' is not null or undefined
            (0, common_1.assertParamExists)('batchCreateBill', 'bills', bills);
            // verify required parameter 'sent' is not null or undefined
            (0, common_1.assertParamExists)('batchCreateBill', 'sent', sent);
            const localVarPath = `/api/admin/billing/bill/batch-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (bills !== undefined) {
                localVarQueryParameter['bills'] = bills;
            }
            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }
            if (sent !== undefined) {
                localVarQueryParameter['sent'] = sent;
            }
            if (simulate !== undefined) {
                localVarQueryParameter['simulate'] = simulate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} budgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetLinesBill: (budgetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'budgetId' is not null or undefined
            (0, common_1.assertParamExists)('budgetLinesBill', 'budgetId', budgetId);
            const localVarPath = `/api/admin/billing/bill/budget-lines/{budgetId}`
                .replace(`{${"budgetId"}}`, encodeURIComponent(String(budgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBill: (advanced, pending, budgetId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/bill/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBill: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissBill', 'id', id);
            const localVarPath = `/api/admin/billing/bill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBill: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchBill', 'ids', ids);
            const localVarPath = `/api/admin/billing/bill/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBill: (billId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billId' is not null or undefined
            (0, common_1.assertParamExists)('duplicateBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/duplicate`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBill', 'id', id);
            const localVarPath = `/api/admin/billing/bill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBill: (advanced, pending, budgetId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/bill/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBill: (page, size, sort, advanced, pending, budgetId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/bill/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} billId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBill: (billId, lineIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billId' is not null or undefined
            (0, common_1.assertParamExists)('removeLinesBill', 'billId', billId);
            // verify required parameter 'lineIds' is not null or undefined
            (0, common_1.assertParamExists)('removeLinesBill', 'lineIds', lineIds);
            const localVarPath = `/api/admin/billing/bill/{billId}/removeLines`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (lineIds) {
                localVarQueryParameter['lineIds'] = lineIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBill: (bill, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bill' is not null or undefined
            (0, common_1.assertParamExists)('saveBill', 'bill', bill);
            const localVarPath = `/api/admin/billing/bill/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bill, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} billId
         * @param {BillLine} billLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineBill: (billId, billLine, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billId' is not null or undefined
            (0, common_1.assertParamExists)('saveLineBill', 'billId', billId);
            // verify required parameter 'billLine' is not null or undefined
            (0, common_1.assertParamExists)('saveLineBill', 'billLine', billLine);
            const localVarPath = `/api/admin/billing/bill/{billId}/saveLine`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(billLine, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryBill: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/bill/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFacturaEBill: (billId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billId' is not null or undefined
            (0, common_1.assertParamExists)('viewFacturaEBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/facturae`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPdfBill: (billId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billId' is not null or undefined
            (0, common_1.assertParamExists)('viewPdfBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/pdf`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BillRestControllerApiAxiosParamCreator = BillRestControllerApiAxiosParamCreator;
/**
 * BillRestControllerApi - functional programming interface
 * @export
 */
const BillRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BillRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryBill(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.annualSummaryBill(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.annualSummaryBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} bills
         * @param {boolean} sent
         * @param {string} [separator]
         * @param {boolean} [simulate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCreateBill(bills, sent, separator, simulate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchCreateBill(bills, sent, separator, simulate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.batchCreateBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} budgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetLinesBill(budgetId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.budgetLinesBill(budgetId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.budgetLinesBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBill(advanced, pending, budgetId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countBill(advanced, pending, budgetId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.countBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBill(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissBill(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.deleteOrDismissBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBill(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchBill(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.deleteOrDismissInBatchBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBill(billId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.duplicateBill(billId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.duplicateBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBill(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.getBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBill(advanced, pending, budgetId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBill(advanced, pending, budgetId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.listBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBill(page, size, sort, advanced, pending, budgetId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageBill(page, size, sort, advanced, pending, budgetId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.pageBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} billId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBill(billId, lineIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeLinesBill(billId, lineIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.removeLinesBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBill(bill, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveBill(bill, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.saveBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} billId
         * @param {BillLine} billLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineBill(billId, billLine, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveLineBill(billId, billLine, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.saveLineBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryBill(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.summaryBill(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.summaryBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFacturaEBill(billId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewFacturaEBill(billId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.viewFacturaEBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPdfBill(billId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewPdfBill(billId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillRestControllerApi.viewPdfBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.BillRestControllerApiFp = BillRestControllerApiFp;
/**
 * BillRestControllerApi - factory interface
 * @export
 */
const BillRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BillRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryBill(year, options) {
            return localVarFp.annualSummaryBill(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} bills
         * @param {boolean} sent
         * @param {string} [separator]
         * @param {boolean} [simulate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCreateBill(bills, sent, separator, simulate, options) {
            return localVarFp.batchCreateBill(bills, sent, separator, simulate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} budgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetLinesBill(budgetId, options) {
            return localVarFp.budgetLinesBill(budgetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBill(advanced, pending, budgetId, term, showDismissed, options) {
            return localVarFp.countBill(advanced, pending, budgetId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBill(id, options) {
            return localVarFp.deleteOrDismissBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBill(ids, options) {
            return localVarFp.deleteOrDismissInBatchBill(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBill(billId, options) {
            return localVarFp.duplicateBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill(id, options) {
            return localVarFp.getBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBill(advanced, pending, budgetId, term, showDismissed, options) {
            return localVarFp.listBill(advanced, pending, budgetId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {number} [budgetId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBill(page, size, sort, advanced, pending, budgetId, term, showDismissed, options) {
            return localVarFp.pageBill(page, size, sort, advanced, pending, budgetId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBill(billId, lineIds, options) {
            return localVarFp.removeLinesBill(billId, lineIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBill(bill, options) {
            return localVarFp.saveBill(bill, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {BillLine} billLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineBill(billId, billLine, options) {
            return localVarFp.saveLineBill(billId, billLine, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryBill(options) {
            return localVarFp.summaryBill(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFacturaEBill(billId, options) {
            return localVarFp.viewFacturaEBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPdfBill(billId, options) {
            return localVarFp.viewPdfBill(billId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BillRestControllerApiFactory = BillRestControllerApiFactory;
/**
 * BillRestControllerApi - object-oriented interface
 * @export
 * @class BillRestControllerApi
 * @extends {BaseAPI}
 */
class BillRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    annualSummaryBill(year, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).annualSummaryBill(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} bills
     * @param {boolean} sent
     * @param {string} [separator]
     * @param {boolean} [simulate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    batchCreateBill(bills, sent, separator, simulate, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).batchCreateBill(bills, sent, separator, simulate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} budgetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    budgetLinesBill(budgetId, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).budgetLinesBill(budgetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {number} [budgetId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    countBill(advanced, pending, budgetId, term, showDismissed, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).countBill(advanced, pending, budgetId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    deleteOrDismissBill(id, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).deleteOrDismissBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    deleteOrDismissInBatchBill(ids, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).deleteOrDismissInBatchBill(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    duplicateBill(billId, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).duplicateBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    getBill(id, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).getBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {number} [budgetId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    listBill(advanced, pending, budgetId, term, showDismissed, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).listBill(advanced, pending, budgetId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {number} [budgetId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    pageBill(page, size, sort, advanced, pending, budgetId, term, showDismissed, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).pageBill(page, size, sort, advanced, pending, budgetId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {Array<number>} lineIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    removeLinesBill(billId, lineIds, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).removeLinesBill(billId, lineIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Bill} bill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    saveBill(bill, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).saveBill(bill, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {BillLine} billLine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    saveLineBill(billId, billLine, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).saveLineBill(billId, billLine, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    summaryBill(options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).summaryBill(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    viewFacturaEBill(billId, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).viewFacturaEBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    viewPdfBill(billId, options) {
        return (0, exports.BillRestControllerApiFp)(this.configuration).viewPdfBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BillRestControllerApi = BillRestControllerApi;
/**
 * BudgetRestControllerApi - axios parameter creator
 * @export
 */
const BudgetRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudget: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/budget/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudget: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissBudget', 'id', id);
            const localVarPath = `/api/admin/billing/budget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudget: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchBudget', 'ids', ids);
            const localVarPath = `/api/admin/billing/budget/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSummariesBudget: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/budget/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudget: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBudget', 'id', id);
            const localVarPath = `/api/admin/billing/budget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitStatsBudget: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/budget/units-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudget: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/budget/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStatsBudget: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/budget/manager-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudget: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/budget/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Budget} budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudget: (budget, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'budget' is not null or undefined
            (0, common_1.assertParamExists)('saveBudget', 'budget', budget);
            const localVarPath = `/api/admin/billing/budget/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(budget, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BudgetRestControllerApiAxiosParamCreator = BudgetRestControllerApiAxiosParamCreator;
/**
 * BudgetRestControllerApi - functional programming interface
 * @export
 */
const BudgetRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BudgetRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudget(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countBudget(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.countBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudget(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissBudget(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.deleteOrDismissBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudget(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchBudget(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.deleteOrDismissInBatchBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSummariesBudget(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveSummariesBudget(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.getActiveSummariesBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudget(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBudget(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.getBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitStatsBudget(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUnitStatsBudget(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.getUnitStatsBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudget(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBudget(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.listBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStatsBudget(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.managerStatsBudget(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.managerStatsBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudget(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageBudget(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.pageBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Budget} budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudget(budget, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveBudget(budget, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BudgetRestControllerApi.saveBudget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.BudgetRestControllerApiFp = BudgetRestControllerApiFp;
/**
 * BudgetRestControllerApi - factory interface
 * @export
 */
const BudgetRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BudgetRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudget(term, showDismissed, options) {
            return localVarFp.countBudget(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudget(id, options) {
            return localVarFp.deleteOrDismissBudget(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudget(ids, options) {
            return localVarFp.deleteOrDismissInBatchBudget(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSummariesBudget(options) {
            return localVarFp.getActiveSummariesBudget(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudget(id, options) {
            return localVarFp.getBudget(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitStatsBudget(year, options) {
            return localVarFp.getUnitStatsBudget(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudget(term, showDismissed, options) {
            return localVarFp.listBudget(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStatsBudget(year, options) {
            return localVarFp.managerStatsBudget(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudget(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageBudget(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Budget} budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudget(budget, options) {
            return localVarFp.saveBudget(budget, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BudgetRestControllerApiFactory = BudgetRestControllerApiFactory;
/**
 * BudgetRestControllerApi - object-oriented interface
 * @export
 * @class BudgetRestControllerApi
 * @extends {BaseAPI}
 */
class BudgetRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    countBudget(term, showDismissed, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).countBudget(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    deleteOrDismissBudget(id, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).deleteOrDismissBudget(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    deleteOrDismissInBatchBudget(ids, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).deleteOrDismissInBatchBudget(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    getActiveSummariesBudget(options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).getActiveSummariesBudget(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    getBudget(id, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).getBudget(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    getUnitStatsBudget(year, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).getUnitStatsBudget(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    listBudget(term, showDismissed, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).listBudget(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    managerStatsBudget(year, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).managerStatsBudget(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    pageBudget(page, size, sort, term, showDismissed, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).pageBudget(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Budget} budget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    saveBudget(budget, options) {
        return (0, exports.BudgetRestControllerApiFp)(this.configuration).saveBudget(budget, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BudgetRestControllerApi = BudgetRestControllerApi;
/**
 * CandidateDocumentRestControllerApi - axios parameter creator
 * @export
 */
const CandidateDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateDocument: (candidateId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('countCandidateDocument', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateDocument: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateDocument', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateDocument: (documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('downloadCandidateDocument', 'documentId', documentId);
            const localVarPath = `/api/admin/recruitment/candidate/document/{documentId}/attachment`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateDocument: (candidateId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('listCandidateDocument', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateDocument: (candidateId, page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('pageCandidateDocument', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateDocument} candidateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateDocument: (candidateDocument, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateDocument' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateDocument', 'candidateDocument', candidateDocument);
            const localVarPath = `/api/admin/recruitment/candidate/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateDocument, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateDocumentRestControllerApiAxiosParamCreator = CandidateDocumentRestControllerApiAxiosParamCreator;
/**
 * CandidateDocumentRestControllerApi - functional programming interface
 * @export
 */
const CandidateDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateDocumentRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateDocument(candidateId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateDocument(candidateId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.countCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.deleteOrDismissCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateDocument(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateDocument(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.deleteOrDismissInBatchCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateDocument(documentId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadCandidateDocument(documentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.downloadCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.getCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateDocument(candidateId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateDocument(candidateId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.listCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.pageCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateDocument} candidateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateDocument(candidateDocument, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateDocument(candidateDocument, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateDocumentRestControllerApi.saveCandidateDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateDocumentRestControllerApiFp = CandidateDocumentRestControllerApiFp;
/**
 * CandidateDocumentRestControllerApi - factory interface
 * @export
 */
const CandidateDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateDocumentRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateDocument(candidateId, term, showDismissed, options) {
            return localVarFp.countCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateDocument(id, options) {
            return localVarFp.deleteOrDismissCandidateDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateDocument(documentId, options) {
            return localVarFp.downloadCandidateDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateDocument(id, options) {
            return localVarFp.getCandidateDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateDocument(candidateId, term, showDismissed, options) {
            return localVarFp.listCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateDocument} candidateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateDocument(candidateDocument, options) {
            return localVarFp.saveCandidateDocument(candidateDocument, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateDocumentRestControllerApiFactory = CandidateDocumentRestControllerApiFactory;
/**
 * CandidateDocumentRestControllerApi - object-oriented interface
 * @export
 * @class CandidateDocumentRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateDocumentRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    countCandidateDocument(candidateId, term, showDismissed, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).countCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    deleteOrDismissCandidateDocument(id, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).deleteOrDismissCandidateDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    deleteOrDismissInBatchCandidateDocument(ids, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    downloadCandidateDocument(documentId, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).downloadCandidateDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    getCandidateDocument(id, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).getCandidateDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    listCandidateDocument(candidateId, term, showDismissed, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).listCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateDocument} candidateDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    saveCandidateDocument(candidateDocument, options) {
        return (0, exports.CandidateDocumentRestControllerApiFp)(this.configuration).saveCandidateDocument(candidateDocument, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateDocumentRestControllerApi = CandidateDocumentRestControllerApi;
/**
 * CandidateEventRestControllerApi - axios parameter creator
 * @export
 */
const CandidateEventRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateEvent: (candidateId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('countCandidateEvent', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/event/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateEvent: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateEvent', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateEvent: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateEvent', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateEvent: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateEvent', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateEvent: (candidateId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('listCandidateEvent', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/event/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateEvent: (candidateId, page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('pageCandidateEvent', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/event/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateEvent} candidateEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateEvent: (candidateEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateEvent' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateEvent', 'candidateEvent', candidateEvent);
            const localVarPath = `/api/admin/recruitment/candidate/event/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateEvent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateEventRestControllerApiAxiosParamCreator = CandidateEventRestControllerApiAxiosParamCreator;
/**
 * CandidateEventRestControllerApi - functional programming interface
 * @export
 */
const CandidateEventRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateEventRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateEvent(candidateId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateEvent(candidateId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.countCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateEvent(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateEvent(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.deleteOrDismissCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateEvent(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateEvent(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.deleteOrDismissInBatchCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateEvent(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateEvent(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.getCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateEvent(candidateId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateEvent(candidateId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.listCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.pageCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateEvent} candidateEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateEvent(candidateEvent, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateEvent(candidateEvent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateEventRestControllerApi.saveCandidateEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateEventRestControllerApiFp = CandidateEventRestControllerApiFp;
/**
 * CandidateEventRestControllerApi - factory interface
 * @export
 */
const CandidateEventRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateEventRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateEvent(candidateId, term, showDismissed, options) {
            return localVarFp.countCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateEvent(id, options) {
            return localVarFp.deleteOrDismissCandidateEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateEvent(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateEvent(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateEvent(id, options) {
            return localVarFp.getCandidateEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateEvent(candidateId, term, showDismissed, options) {
            return localVarFp.listCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateEvent} candidateEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateEvent(candidateEvent, options) {
            return localVarFp.saveCandidateEvent(candidateEvent, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateEventRestControllerApiFactory = CandidateEventRestControllerApiFactory;
/**
 * CandidateEventRestControllerApi - object-oriented interface
 * @export
 * @class CandidateEventRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateEventRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    countCandidateEvent(candidateId, term, showDismissed, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).countCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    deleteOrDismissCandidateEvent(id, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).deleteOrDismissCandidateEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    deleteOrDismissInBatchCandidateEvent(ids, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateEvent(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    getCandidateEvent(id, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).getCandidateEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    listCandidateEvent(candidateId, term, showDismissed, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).listCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateEvent} candidateEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    saveCandidateEvent(candidateEvent, options) {
        return (0, exports.CandidateEventRestControllerApiFp)(this.configuration).saveCandidateEvent(candidateEvent, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateEventRestControllerApi = CandidateEventRestControllerApi;
/**
 * CandidateLevelSolutionRestControllerApi - axios parameter creator
 * @export
 */
const CandidateLevelSolutionRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelSolution: (candidateId, pending, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelSolution: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateLevelSolution', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelSolution: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateLevelSolution', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} solutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelSolution: (solutionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'solutionId' is not null or undefined
            (0, common_1.assertParamExists)('downloadCandidateLevelSolution', 'solutionId', solutionId);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/{solutionId}/attachment`
                .replace(`{${"solutionId"}}`, encodeURIComponent(String(solutionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelSolution: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateLevelSolution', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelSolution: (candidateId, pending, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelSolution: (page, size, sort, candidateId, pending, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateLevelSolution} candidateLevelSolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelSolution: (candidateLevelSolution, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateLevelSolution' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateLevelSolution', 'candidateLevelSolution', candidateLevelSolution);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateLevelSolution, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateLevelSolutionRestControllerApiAxiosParamCreator = CandidateLevelSolutionRestControllerApiAxiosParamCreator;
/**
 * CandidateLevelSolutionRestControllerApi - functional programming interface
 * @export
 */
const CandidateLevelSolutionRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateLevelSolutionRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateLevelSolution(candidateId, pending, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.countCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelSolution(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateLevelSolution(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.deleteOrDismissCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelSolution(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateLevelSolution(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.deleteOrDismissInBatchCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} solutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelSolution(solutionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadCandidateLevelSolution(solutionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.downloadCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelSolution(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateLevelSolution(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.getCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateLevelSolution(candidateId, pending, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.listCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.pageCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateLevelSolution} candidateLevelSolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelSolution(candidateLevelSolution, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateLevelSolution(candidateLevelSolution, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelSolutionRestControllerApi.saveCandidateLevelSolution']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateLevelSolutionRestControllerApiFp = CandidateLevelSolutionRestControllerApiFp;
/**
 * CandidateLevelSolutionRestControllerApi - factory interface
 * @export
 */
const CandidateLevelSolutionRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateLevelSolutionRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            return localVarFp.countCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelSolution(id, options) {
            return localVarFp.deleteOrDismissCandidateLevelSolution(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelSolution(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateLevelSolution(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} solutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelSolution(solutionId, options) {
            return localVarFp.downloadCandidateLevelSolution(solutionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelSolution(id, options) {
            return localVarFp.getCandidateLevelSolution(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            return localVarFp.listCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options) {
            return localVarFp.pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateLevelSolution} candidateLevelSolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelSolution(candidateLevelSolution, options) {
            return localVarFp.saveCandidateLevelSolution(candidateLevelSolution, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateLevelSolutionRestControllerApiFactory = CandidateLevelSolutionRestControllerApiFactory;
/**
 * CandidateLevelSolutionRestControllerApi - object-oriented interface
 * @export
 * @class CandidateLevelSolutionRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateLevelSolutionRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [candidateId]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    countCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).countCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    deleteOrDismissCandidateLevelSolution(id, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).deleteOrDismissCandidateLevelSolution(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    deleteOrDismissInBatchCandidateLevelSolution(ids, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateLevelSolution(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} solutionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    downloadCandidateLevelSolution(solutionId, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).downloadCandidateLevelSolution(solutionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    getCandidateLevelSolution(id, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).getCandidateLevelSolution(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [candidateId]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    listCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).listCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [candidateId]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateLevelSolution} candidateLevelSolution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    saveCandidateLevelSolution(candidateLevelSolution, options) {
        return (0, exports.CandidateLevelSolutionRestControllerApiFp)(this.configuration).saveCandidateLevelSolution(candidateLevelSolution, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateLevelSolutionRestControllerApi = CandidateLevelSolutionRestControllerApi;
/**
 * CandidateLevelTestRestControllerApi - axios parameter creator
 * @export
 */
const CandidateLevelTestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelTest: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/level/test/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelTest: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateLevelTest', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelTest: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateLevelTest', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelTest: (testId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'testId' is not null or undefined
            (0, common_1.assertParamExists)('downloadCandidateLevelTest', 'testId', testId);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/{testId}/attachment`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelTest: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateLevelTest', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelTest: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/level/test/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelTest: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/level/test/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateLevelTest} candidateLevelTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelTest: (candidateLevelTest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateLevelTest' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateLevelTest', 'candidateLevelTest', candidateLevelTest);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateLevelTest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateLevelTestRestControllerApiAxiosParamCreator = CandidateLevelTestRestControllerApiAxiosParamCreator;
/**
 * CandidateLevelTestRestControllerApi - functional programming interface
 * @export
 */
const CandidateLevelTestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateLevelTestRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelTest(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateLevelTest(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.countCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelTest(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateLevelTest(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.deleteOrDismissCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelTest(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateLevelTest(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.deleteOrDismissInBatchCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelTest(testId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadCandidateLevelTest(testId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.downloadCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelTest(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateLevelTest(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.getCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelTest(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateLevelTest(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.listCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelTest(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateLevelTest(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.pageCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateLevelTest} candidateLevelTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelTest(candidateLevelTest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateLevelTest(candidateLevelTest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateLevelTestRestControllerApi.saveCandidateLevelTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateLevelTestRestControllerApiFp = CandidateLevelTestRestControllerApiFp;
/**
 * CandidateLevelTestRestControllerApi - factory interface
 * @export
 */
const CandidateLevelTestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateLevelTestRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelTest(term, showDismissed, options) {
            return localVarFp.countCandidateLevelTest(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelTest(id, options) {
            return localVarFp.deleteOrDismissCandidateLevelTest(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelTest(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateLevelTest(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelTest(testId, options) {
            return localVarFp.downloadCandidateLevelTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelTest(id, options) {
            return localVarFp.getCandidateLevelTest(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelTest(term, showDismissed, options) {
            return localVarFp.listCandidateLevelTest(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelTest(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateLevelTest(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateLevelTest} candidateLevelTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelTest(candidateLevelTest, options) {
            return localVarFp.saveCandidateLevelTest(candidateLevelTest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateLevelTestRestControllerApiFactory = CandidateLevelTestRestControllerApiFactory;
/**
 * CandidateLevelTestRestControllerApi - object-oriented interface
 * @export
 * @class CandidateLevelTestRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateLevelTestRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    countCandidateLevelTest(term, showDismissed, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).countCandidateLevelTest(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    deleteOrDismissCandidateLevelTest(id, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).deleteOrDismissCandidateLevelTest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    deleteOrDismissInBatchCandidateLevelTest(ids, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateLevelTest(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} testId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    downloadCandidateLevelTest(testId, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).downloadCandidateLevelTest(testId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    getCandidateLevelTest(id, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).getCandidateLevelTest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    listCandidateLevelTest(term, showDismissed, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).listCandidateLevelTest(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    pageCandidateLevelTest(page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).pageCandidateLevelTest(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateLevelTest} candidateLevelTest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    saveCandidateLevelTest(candidateLevelTest, options) {
        return (0, exports.CandidateLevelTestRestControllerApiFp)(this.configuration).saveCandidateLevelTest(candidateLevelTest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateLevelTestRestControllerApi = CandidateLevelTestRestControllerApi;
/**
 * CandidateRequestRestControllerApi - axios parameter creator
 * @export
 */
const CandidateRequestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CandidateDismissForm} candidateDismissForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCandidateForm: (candidateDismissForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateDismissForm' is not null or undefined
            (0, common_1.assertParamExists)('dismissCandidateForm', 'candidateDismissForm', candidateDismissForm);
            const localVarPath = `/api/pub/candidate/dismiss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateDismissForm, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateForm: (email, pass, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateForm', 'email', email);
            // verify required parameter 'pass' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateForm', 'pass', pass);
            const localVarPath = `/api/pub/candidate/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (pass !== undefined) {
                localVarQueryParameter['pass'] = pass;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSkills: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pub/candidate/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRecruitments: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pub/candidate/recruitments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRecruitmentDetails', 'id', id);
            const localVarPath = `/api/pub/candidate/recruitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverCandidateForm: (email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            (0, common_1.assertParamExists)('recoverCandidateForm', 'email', email);
            const localVarPath = `/api/pub/candidate/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCandidateCV: (email, pass, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            (0, common_1.assertParamExists)('retrieveCandidateCV', 'email', email);
            // verify required parameter 'pass' is not null or undefined
            (0, common_1.assertParamExists)('retrieveCandidateCV', 'pass', pass);
            const localVarPath = `/api/pub/candidate/cv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (pass !== undefined) {
                localVarQueryParameter['pass'] = pass;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateForm} candidateForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateForm: (candidateForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateForm' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateForm', 'candidateForm', candidateForm);
            const localVarPath = `/api/pub/candidate/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateForm, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateRequestRestControllerApiAxiosParamCreator = CandidateRequestRestControllerApiAxiosParamCreator;
/**
 * CandidateRequestRestControllerApi - functional programming interface
 * @export
 */
const CandidateRequestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateRequestRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CandidateDismissForm} candidateDismissForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCandidateForm(candidateDismissForm, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dismissCandidateForm(candidateDismissForm, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.dismissCandidateForm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateForm(email, pass, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateForm(email, pass, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.getCandidateForm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSkills(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateSkills(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.getCandidateSkills']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRecruitments(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicRecruitments(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.getPublicRecruitments']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDetails(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecruitmentDetails(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.getRecruitmentDetails']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverCandidateForm(email, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recoverCandidateForm(email, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.recoverCandidateForm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCandidateCV(email, pass, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveCandidateCV(email, pass, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.retrieveCandidateCV']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateForm} candidateForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateForm(candidateForm, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateForm(candidateForm, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRequestRestControllerApi.saveCandidateForm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateRequestRestControllerApiFp = CandidateRequestRestControllerApiFp;
/**
 * CandidateRequestRestControllerApi - factory interface
 * @export
 */
const CandidateRequestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateRequestRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {CandidateDismissForm} candidateDismissForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCandidateForm(candidateDismissForm, options) {
            return localVarFp.dismissCandidateForm(candidateDismissForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateForm(email, pass, options) {
            return localVarFp.getCandidateForm(email, pass, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSkills(options) {
            return localVarFp.getCandidateSkills(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRecruitments(options) {
            return localVarFp.getPublicRecruitments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDetails(id, options) {
            return localVarFp.getRecruitmentDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverCandidateForm(email, options) {
            return localVarFp.recoverCandidateForm(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCandidateCV(email, pass, options) {
            return localVarFp.retrieveCandidateCV(email, pass, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateForm} candidateForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateForm(candidateForm, options) {
            return localVarFp.saveCandidateForm(candidateForm, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateRequestRestControllerApiFactory = CandidateRequestRestControllerApiFactory;
/**
 * CandidateRequestRestControllerApi - object-oriented interface
 * @export
 * @class CandidateRequestRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateRequestRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {CandidateDismissForm} candidateDismissForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    dismissCandidateForm(candidateDismissForm, options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).dismissCandidateForm(candidateDismissForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {string} pass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getCandidateForm(email, pass, options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).getCandidateForm(email, pass, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getCandidateSkills(options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).getCandidateSkills(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getPublicRecruitments(options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).getPublicRecruitments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getRecruitmentDetails(id, options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).getRecruitmentDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    recoverCandidateForm(email, options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).recoverCandidateForm(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {string} pass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    retrieveCandidateCV(email, pass, options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).retrieveCandidateCV(email, pass, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateForm} candidateForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    saveCandidateForm(candidateForm, options) {
        return (0, exports.CandidateRequestRestControllerApiFp)(this.configuration).saveCandidateForm(candidateForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateRequestRestControllerApi = CandidateRequestRestControllerApi;
/**
 * CandidateRestControllerApi - axios parameter creator
 * @export
 */
const CandidateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidate: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidate: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidate', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidate: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidate', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCvCandidate: (candidateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('downloadCvCandidate', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/{candidateId}/cv`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPhotoCandidate: (candidateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateId' is not null or undefined
            (0, common_1.assertParamExists)('downloadPhotoCandidate', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/{candidateId}/photo`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCandidate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidate: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidate', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidate: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidate: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Candidate} candidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidate: (candidate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidate' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidate', 'candidate', candidate);
            const localVarPath = `/api/admin/recruitment/candidate/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateRestControllerApiAxiosParamCreator = CandidateRestControllerApiAxiosParamCreator;
/**
 * CandidateRestControllerApi - functional programming interface
 * @export
 */
const CandidateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidate(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidate(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.countCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidate(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidate(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.deleteOrDismissCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidate(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidate(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.deleteOrDismissInBatchCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCvCandidate(candidateId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadCvCandidate(candidateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.downloadCvCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPhotoCandidate(candidateId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadPhotoCandidate(candidateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.downloadPhotoCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCandidate(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportCandidate(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.exportCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidate(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidate(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.getCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidate(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidate(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.listCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidate(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidate(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.pageCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Candidate} candidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidate(candidate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidate(candidate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateRestControllerApi.saveCandidate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateRestControllerApiFp = CandidateRestControllerApiFp;
/**
 * CandidateRestControllerApi - factory interface
 * @export
 */
const CandidateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidate(term, showDismissed, options) {
            return localVarFp.countCandidate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidate(id, options) {
            return localVarFp.deleteOrDismissCandidate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidate(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidate(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCvCandidate(candidateId, options) {
            return localVarFp.downloadCvCandidate(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPhotoCandidate(candidateId, options) {
            return localVarFp.downloadPhotoCandidate(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCandidate(options) {
            return localVarFp.exportCandidate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidate(id, options) {
            return localVarFp.getCandidate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidate(term, showDismissed, options) {
            return localVarFp.listCandidate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidate(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidate(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Candidate} candidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidate(candidate, options) {
            return localVarFp.saveCandidate(candidate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateRestControllerApiFactory = CandidateRestControllerApiFactory;
/**
 * CandidateRestControllerApi - object-oriented interface
 * @export
 * @class CandidateRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    countCandidate(term, showDismissed, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).countCandidate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    deleteOrDismissCandidate(id, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).deleteOrDismissCandidate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    deleteOrDismissInBatchCandidate(ids, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidate(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    downloadCvCandidate(candidateId, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).downloadCvCandidate(candidateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    downloadPhotoCandidate(candidateId, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).downloadPhotoCandidate(candidateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    exportCandidate(options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).exportCandidate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    getCandidate(id, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).getCandidate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    listCandidate(term, showDismissed, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).listCandidate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    pageCandidate(page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).pageCandidate(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Candidate} candidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    saveCandidate(candidate, options) {
        return (0, exports.CandidateRestControllerApiFp)(this.configuration).saveCandidate(candidate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateRestControllerApi = CandidateRestControllerApi;
/**
 * CandidateSourceRestControllerApi - axios parameter creator
 * @export
 */
const CandidateSourceRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateSource: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/source/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateSource: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateSource', 'id', id);
            const localVarPath = `/api/admin/recruitment/source/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateSource: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateSource', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/source/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSource: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateSource', 'id', id);
            const localVarPath = `/api/admin/recruitment/source/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateSource: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/source/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateSource: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/source/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateSource} candidateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateSource: (candidateSource, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateSource' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateSource', 'candidateSource', candidateSource);
            const localVarPath = `/api/admin/recruitment/source/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateSource, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateSourceRestControllerApiAxiosParamCreator = CandidateSourceRestControllerApiAxiosParamCreator;
/**
 * CandidateSourceRestControllerApi - functional programming interface
 * @export
 */
const CandidateSourceRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateSourceRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateSource(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateSource(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.countCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateSource(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateSource(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.deleteOrDismissCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateSource(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateSource(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.deleteOrDismissInBatchCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSource(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateSource(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.getCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateSource(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateSource(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.listCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateSource(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateSource(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.pageCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateSource} candidateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateSource(candidateSource, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateSource(candidateSource, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateSourceRestControllerApi.saveCandidateSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateSourceRestControllerApiFp = CandidateSourceRestControllerApiFp;
/**
 * CandidateSourceRestControllerApi - factory interface
 * @export
 */
const CandidateSourceRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateSourceRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateSource(term, showDismissed, options) {
            return localVarFp.countCandidateSource(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateSource(id, options) {
            return localVarFp.deleteOrDismissCandidateSource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateSource(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateSource(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSource(id, options) {
            return localVarFp.getCandidateSource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateSource(term, showDismissed, options) {
            return localVarFp.listCandidateSource(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateSource(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateSource(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateSource} candidateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateSource(candidateSource, options) {
            return localVarFp.saveCandidateSource(candidateSource, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateSourceRestControllerApiFactory = CandidateSourceRestControllerApiFactory;
/**
 * CandidateSourceRestControllerApi - object-oriented interface
 * @export
 * @class CandidateSourceRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateSourceRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    countCandidateSource(term, showDismissed, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).countCandidateSource(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    deleteOrDismissCandidateSource(id, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).deleteOrDismissCandidateSource(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    deleteOrDismissInBatchCandidateSource(ids, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateSource(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    getCandidateSource(id, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).getCandidateSource(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    listCandidateSource(term, showDismissed, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).listCandidateSource(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    pageCandidateSource(page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).pageCandidateSource(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateSource} candidateSource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    saveCandidateSource(candidateSource, options) {
        return (0, exports.CandidateSourceRestControllerApiFp)(this.configuration).saveCandidateSource(candidateSource, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateSourceRestControllerApi = CandidateSourceRestControllerApi;
/**
 * CandidateStateRestControllerApi - axios parameter creator
 * @export
 */
const CandidateStateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateState: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/state/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateState: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateState', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateState: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateState', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/state/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateState: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateState', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateState: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/state/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateState: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/state/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateState} candidateState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateState: (candidateState, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateState' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateState', 'candidateState', candidateState);
            const localVarPath = `/api/admin/recruitment/candidate/state/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateState, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateStateRestControllerApiAxiosParamCreator = CandidateStateRestControllerApiAxiosParamCreator;
/**
 * CandidateStateRestControllerApi - functional programming interface
 * @export
 */
const CandidateStateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateStateRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateState(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateState(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.countCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateState(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateState(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.deleteOrDismissCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateState(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateState(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.deleteOrDismissInBatchCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateState(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateState(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.getCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateState(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateState(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.listCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateState(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateState(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.pageCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateState} candidateState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateState(candidateState, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateState(candidateState, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateStateRestControllerApi.saveCandidateState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateStateRestControllerApiFp = CandidateStateRestControllerApiFp;
/**
 * CandidateStateRestControllerApi - factory interface
 * @export
 */
const CandidateStateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateStateRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateState(term, showDismissed, options) {
            return localVarFp.countCandidateState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateState(id, options) {
            return localVarFp.deleteOrDismissCandidateState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateState(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateState(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateState(id, options) {
            return localVarFp.getCandidateState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateState(term, showDismissed, options) {
            return localVarFp.listCandidateState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateState(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateState(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateState} candidateState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateState(candidateState, options) {
            return localVarFp.saveCandidateState(candidateState, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateStateRestControllerApiFactory = CandidateStateRestControllerApiFactory;
/**
 * CandidateStateRestControllerApi - object-oriented interface
 * @export
 * @class CandidateStateRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateStateRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    countCandidateState(term, showDismissed, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).countCandidateState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    deleteOrDismissCandidateState(id, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).deleteOrDismissCandidateState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    deleteOrDismissInBatchCandidateState(ids, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateState(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    getCandidateState(id, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).getCandidateState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    listCandidateState(term, showDismissed, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).listCandidateState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    pageCandidateState(page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).pageCandidateState(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateState} candidateState
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    saveCandidateState(candidateState, options) {
        return (0, exports.CandidateStateRestControllerApiFp)(this.configuration).saveCandidateState(candidateState, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateStateRestControllerApi = CandidateStateRestControllerApi;
/**
 * CandidateTestRestControllerApi - axios parameter creator
 * @export
 */
const CandidateTestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateTest: (testId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'testId' is not null or undefined
            (0, common_1.assertParamExists)('downloadCandidateTest', 'testId', testId);
            const localVarPath = `/api/pub/candidate/test/{testId}/attachment`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTest: (testId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'testId' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateTest', 'testId', testId);
            const localVarPath = `/api/pub/candidate/test/{testId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateTestForm} candidateTestForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateTest: (candidateTestForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateTestForm' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateTest', 'candidateTestForm', candidateTestForm);
            const localVarPath = `/api/pub/candidate/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateTestForm, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateTestRestControllerApiAxiosParamCreator = CandidateTestRestControllerApiAxiosParamCreator;
/**
 * CandidateTestRestControllerApi - functional programming interface
 * @export
 */
const CandidateTestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateTestRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateTest(testId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadCandidateTest(testId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTestRestControllerApi.downloadCandidateTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTest(testId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateTest(testId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTestRestControllerApi.getCandidateTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateTestForm} candidateTestForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateTest(candidateTestForm, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateTest(candidateTestForm, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTestRestControllerApi.saveCandidateTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateTestRestControllerApiFp = CandidateTestRestControllerApiFp;
/**
 * CandidateTestRestControllerApi - factory interface
 * @export
 */
const CandidateTestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateTestRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateTest(testId, options) {
            return localVarFp.downloadCandidateTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTest(testId, options) {
            return localVarFp.getCandidateTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateTestForm} candidateTestForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateTest(candidateTestForm, options) {
            return localVarFp.saveCandidateTest(candidateTestForm, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateTestRestControllerApiFactory = CandidateTestRestControllerApiFactory;
/**
 * CandidateTestRestControllerApi - object-oriented interface
 * @export
 * @class CandidateTestRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateTestRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} testId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTestRestControllerApi
     */
    downloadCandidateTest(testId, options) {
        return (0, exports.CandidateTestRestControllerApiFp)(this.configuration).downloadCandidateTest(testId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} testId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTestRestControllerApi
     */
    getCandidateTest(testId, options) {
        return (0, exports.CandidateTestRestControllerApiFp)(this.configuration).getCandidateTest(testId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateTestForm} candidateTestForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTestRestControllerApi
     */
    saveCandidateTest(candidateTestForm, options) {
        return (0, exports.CandidateTestRestControllerApiFp)(this.configuration).saveCandidateTest(candidateTestForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateTestRestControllerApi = CandidateTestRestControllerApi;
/**
 * CandidateTypeRestControllerApi - axios parameter creator
 * @export
 */
const CandidateTypeRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateType: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/type/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateType: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCandidateType', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateType: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCandidateType', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/type/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateType: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCandidateType', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateType: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/type/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateType: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/candidate/type/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CandidateType} candidateType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateType: (candidateType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'candidateType' is not null or undefined
            (0, common_1.assertParamExists)('saveCandidateType', 'candidateType', candidateType);
            const localVarPath = `/api/admin/recruitment/candidate/type/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(candidateType, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CandidateTypeRestControllerApiAxiosParamCreator = CandidateTypeRestControllerApiAxiosParamCreator;
/**
 * CandidateTypeRestControllerApi - functional programming interface
 * @export
 */
const CandidateTypeRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CandidateTypeRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateType(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCandidateType(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.countCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateType(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCandidateType(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.deleteOrDismissCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateType(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCandidateType(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.deleteOrDismissInBatchCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateType(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCandidateType(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.getCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateType(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCandidateType(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.listCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateType(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCandidateType(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.pageCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CandidateType} candidateType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateType(candidateType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCandidateType(candidateType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CandidateTypeRestControllerApi.saveCandidateType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CandidateTypeRestControllerApiFp = CandidateTypeRestControllerApiFp;
/**
 * CandidateTypeRestControllerApi - factory interface
 * @export
 */
const CandidateTypeRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CandidateTypeRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateType(term, showDismissed, options) {
            return localVarFp.countCandidateType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateType(id, options) {
            return localVarFp.deleteOrDismissCandidateType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateType(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateType(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateType(id, options) {
            return localVarFp.getCandidateType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateType(term, showDismissed, options) {
            return localVarFp.listCandidateType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateType(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateType(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateType} candidateType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateType(candidateType, options) {
            return localVarFp.saveCandidateType(candidateType, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CandidateTypeRestControllerApiFactory = CandidateTypeRestControllerApiFactory;
/**
 * CandidateTypeRestControllerApi - object-oriented interface
 * @export
 * @class CandidateTypeRestControllerApi
 * @extends {BaseAPI}
 */
class CandidateTypeRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    countCandidateType(term, showDismissed, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).countCandidateType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    deleteOrDismissCandidateType(id, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).deleteOrDismissCandidateType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    deleteOrDismissInBatchCandidateType(ids, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCandidateType(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    getCandidateType(id, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).getCandidateType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    listCandidateType(term, showDismissed, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).listCandidateType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    pageCandidateType(page, size, sort, term, showDismissed, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).pageCandidateType(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateType} candidateType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    saveCandidateType(candidateType, options) {
        return (0, exports.CandidateTypeRestControllerApiFp)(this.configuration).saveCandidateType(candidateType, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CandidateTypeRestControllerApi = CandidateTypeRestControllerApi;
/**
 * CustomerRestControllerApi - axios parameter creator
 * @export
 */
const CustomerRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/customer/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCustomer: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissCustomer', 'id', id);
            const localVarPath = `/api/admin/billing/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCustomer: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchCustomer', 'ids', ids);
            const localVarPath = `/api/admin/billing/customer/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCustomer', 'id', id);
            const localVarPath = `/api/admin/billing/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomer: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/customer/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCustomer: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/customer/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Customer} customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer: (customer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customer' is not null or undefined
            (0, common_1.assertParamExists)('saveCustomer', 'customer', customer);
            const localVarPath = `/api/admin/billing/customer/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customer, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CustomerRestControllerApiAxiosParamCreator = CustomerRestControllerApiAxiosParamCreator;
/**
 * CustomerRestControllerApi - functional programming interface
 * @export
 */
const CustomerRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CustomerRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countCustomer(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.countCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCustomer(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissCustomer(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.deleteOrDismissCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCustomer(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchCustomer(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.deleteOrDismissInBatchCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomer(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.getCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomer(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCustomer(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.listCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCustomer(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageCustomer(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.pageCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Customer} customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer(customer, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCustomer(customer, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerRestControllerApi.saveCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CustomerRestControllerApiFp = CustomerRestControllerApiFp;
/**
 * CustomerRestControllerApi - factory interface
 * @export
 */
const CustomerRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CustomerRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer(term, showDismissed, options) {
            return localVarFp.countCustomer(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCustomer(id, options) {
            return localVarFp.deleteOrDismissCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCustomer(ids, options) {
            return localVarFp.deleteOrDismissInBatchCustomer(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(id, options) {
            return localVarFp.getCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomer(term, showDismissed, options) {
            return localVarFp.listCustomer(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCustomer(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCustomer(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Customer} customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer(customer, options) {
            return localVarFp.saveCustomer(customer, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CustomerRestControllerApiFactory = CustomerRestControllerApiFactory;
/**
 * CustomerRestControllerApi - object-oriented interface
 * @export
 * @class CustomerRestControllerApi
 * @extends {BaseAPI}
 */
class CustomerRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    countCustomer(term, showDismissed, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).countCustomer(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    deleteOrDismissCustomer(id, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).deleteOrDismissCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    deleteOrDismissInBatchCustomer(ids, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).deleteOrDismissInBatchCustomer(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    getCustomer(id, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).getCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    listCustomer(term, showDismissed, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).listCustomer(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    pageCustomer(page, size, sort, term, showDismissed, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).pageCustomer(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Customer} customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    saveCustomer(customer, options) {
        return (0, exports.CustomerRestControllerApiFp)(this.configuration).saveCustomer(customer, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CustomerRestControllerApi = CustomerRestControllerApi;
/**
 * DedicationRestControllerApi - axios parameter creator
 * @export
 */
const DedicationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBillingPendingDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('checkBillingPendingDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('checkBillingPendingDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDedication: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/dedication/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDedicationsDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('createDedicationsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('createDedicationsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/create-dedications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} bills
         * @param {string} [separator]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchCreateDedication: (bills, separator, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bills' is not null or undefined
            (0, common_1.assertParamExists)('dedicationBatchCreateDedication', 'bills', bills);
            const localVarPath = `/api/admin/billing/dedication/batch-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (bills !== undefined) {
                localVarQueryParameter['bills'] = bills;
            }
            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} dedications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchDeleteDedication: (dedications, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dedications' is not null or undefined
            (0, common_1.assertParamExists)('dedicationBatchDeleteDedication', 'dedications', dedications);
            const localVarPath = `/api/admin/billing/dedication/batch-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (dedications) {
                localVarQueryParameter['dedications'] = dedications;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillsDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('deleteBillsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('deleteBillsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDedication: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissDedication', 'id', id);
            const localVarPath = `/api/admin/billing/dedication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDedication: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchDedication', 'ids', ids);
            const localVarPath = `/api/admin/billing/dedication/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDedication: (year, month, dedicationsIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('duplicateDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('duplicateDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (dedicationsIds) {
                localVarQueryParameter['dedicationsIds'] = dedicationsIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportXlsDedication: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('exportXlsDedication', 'ids', ids);
            const localVarPath = `/api/admin/billing/dedication/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDedication: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getDedication', 'id', id);
            const localVarPath = `/api/admin/billing/dedication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('getRedmineDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('getRedmineDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/import-redmine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DedicationImportDto} dedicationImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFileDedication: (dedicationImportDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dedicationImportDto' is not null or undefined
            (0, common_1.assertParamExists)('importFileDedication', 'dedicationImportDto', dedicationImportDto);
            const localVarPath = `/api/admin/billing/dedication/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dedicationImportDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRedmineDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('importRedmineDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('importRedmineDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/import-redmine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDedication: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/dedication/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBillsDedication: (year, month, dedicationsIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('makeBillsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('makeBillsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (dedicationsIds) {
                localVarQueryParameter['dedicationsIds'] = dedicationsIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDedication: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/dedication/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfsDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('pdfsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('pdfsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRedmineDedication: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('removeRedmineDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('removeRedmineDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/import-redmine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDedication: (dedication, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dedication' is not null or undefined
            (0, common_1.assertParamExists)('saveDedication', 'dedication', dedication);
            const localVarPath = `/api/admin/billing/dedication/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dedication, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInBatchDedication: (ids, dedication, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('updateInBatchDedication', 'ids', ids);
            // verify required parameter 'dedication' is not null or undefined
            (0, common_1.assertParamExists)('updateInBatchDedication', 'dedication', dedication);
            const localVarPath = `/api/admin/billing/dedication/batch-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dedication, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInBatchDedication: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('validateInBatchDedication', 'ids', ids);
            const localVarPath = `/api/admin/billing/dedication/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DedicationRestControllerApiAxiosParamCreator = DedicationRestControllerApiAxiosParamCreator;
/**
 * DedicationRestControllerApi - functional programming interface
 * @export
 */
const DedicationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DedicationRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBillingPendingDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkBillingPendingDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.checkBillingPendingDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.countDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDedicationsDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDedicationsDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.createDedicationsDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} bills
         * @param {string} [separator]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchCreateDedication(bills, separator, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dedicationBatchCreateDedication(bills, separator, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.dedicationBatchCreateDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} dedications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchDeleteDedication(dedications, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dedicationBatchDeleteDedication(dedications, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.dedicationBatchDeleteDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillsDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBillsDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.deleteBillsDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDedication(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissDedication(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.deleteOrDismissDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDedication(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchDedication(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.deleteOrDismissInBatchDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDedication(year, month, dedicationsIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.duplicateDedication(year, month, dedicationsIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.duplicateDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportXlsDedication(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportXlsDedication(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.exportXlsDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDedication(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDedication(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.getDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRedmineDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.getRedmineDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DedicationImportDto} dedicationImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFileDedication(dedicationImportDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importFileDedication(dedicationImportDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.importFileDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRedmineDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importRedmineDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.importRedmineDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.listDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBillsDedication(year, month, dedicationsIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.makeBillsDedication(year, month, dedicationsIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.makeBillsDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.pageDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfsDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pdfsDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.pdfsDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRedmineDedication(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeRedmineDedication(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.removeRedmineDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDedication(dedication, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveDedication(dedication, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.saveDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInBatchDedication(ids, dedication, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateInBatchDedication(ids, dedication, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.updateInBatchDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInBatchDedication(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateInBatchDedication(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DedicationRestControllerApi.validateInBatchDedication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DedicationRestControllerApiFp = DedicationRestControllerApiFp;
/**
 * DedicationRestControllerApi - factory interface
 * @export
 */
const DedicationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DedicationRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBillingPendingDedication(year, month, options) {
            return localVarFp.checkBillingPendingDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDedicationsDedication(year, month, options) {
            return localVarFp.createDedicationsDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} bills
         * @param {string} [separator]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchCreateDedication(bills, separator, options) {
            return localVarFp.dedicationBatchCreateDedication(bills, separator, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} dedications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchDeleteDedication(dedications, options) {
            return localVarFp.dedicationBatchDeleteDedication(dedications, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillsDedication(year, month, options) {
            return localVarFp.deleteBillsDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDedication(id, options) {
            return localVarFp.deleteOrDismissDedication(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDedication(ids, options) {
            return localVarFp.deleteOrDismissInBatchDedication(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDedication(year, month, dedicationsIds, options) {
            return localVarFp.duplicateDedication(year, month, dedicationsIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportXlsDedication(ids, options) {
            return localVarFp.exportXlsDedication(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDedication(id, options) {
            return localVarFp.getDedication(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineDedication(year, month, options) {
            return localVarFp.getRedmineDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DedicationImportDto} dedicationImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFileDedication(dedicationImportDto, options) {
            return localVarFp.importFileDedication(dedicationImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRedmineDedication(year, month, options) {
            return localVarFp.importRedmineDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBillsDedication(year, month, dedicationsIds, options) {
            return localVarFp.makeBillsDedication(year, month, dedicationsIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfsDedication(year, month, options) {
            return localVarFp.pdfsDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRedmineDedication(year, month, options) {
            return localVarFp.removeRedmineDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDedication(dedication, options) {
            return localVarFp.saveDedication(dedication, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInBatchDedication(ids, dedication, options) {
            return localVarFp.updateInBatchDedication(ids, dedication, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInBatchDedication(ids, options) {
            return localVarFp.validateInBatchDedication(ids, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DedicationRestControllerApiFactory = DedicationRestControllerApiFactory;
/**
 * DedicationRestControllerApi - object-oriented interface
 * @export
 * @class DedicationRestControllerApi
 * @extends {BaseAPI}
 */
class DedicationRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    checkBillingPendingDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).checkBillingPendingDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    createDedicationsDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).createDedicationsDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} bills
     * @param {string} [separator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    dedicationBatchCreateDedication(bills, separator, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).dedicationBatchCreateDedication(bills, separator, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} dedications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    dedicationBatchDeleteDedication(dedications, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).dedicationBatchDeleteDedication(dedications, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    deleteBillsDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).deleteBillsDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    deleteOrDismissDedication(id, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).deleteOrDismissDedication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    deleteOrDismissInBatchDedication(ids, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).deleteOrDismissInBatchDedication(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {Array<number>} [dedicationsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    duplicateDedication(year, month, dedicationsIds, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).duplicateDedication(year, month, dedicationsIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    exportXlsDedication(ids, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).exportXlsDedication(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    getDedication(id, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).getDedication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    getRedmineDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).getRedmineDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DedicationImportDto} dedicationImportDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    importFileDedication(dedicationImportDto, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).importFileDedication(dedicationImportDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    importRedmineDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).importRedmineDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {Array<number>} [dedicationsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    makeBillsDedication(year, month, dedicationsIds, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).makeBillsDedication(year, month, dedicationsIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    pdfsDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).pdfsDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    removeRedmineDedication(year, month, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).removeRedmineDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Dedication} dedication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    saveDedication(dedication, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).saveDedication(dedication, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {Dedication} dedication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    updateInBatchDedication(ids, dedication, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).updateInBatchDedication(ids, dedication, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    validateInBatchDedication(ids, options) {
        return (0, exports.DedicationRestControllerApiFp)(this.configuration).validateInBatchDedication(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DedicationRestControllerApi = DedicationRestControllerApi;
/**
 * DocumentRestControllerApi - axios parameter creator
 * @export
 */
const DocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocument: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissDocument', 'id', id);
            const localVarPath = `/api/admin/employee/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocument: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchDocument', 'ids', ids);
            const localVarPath = `/api/admin/employee/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getDocument', 'id', id);
            const localVarPath = `/api/admin/employee/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocument: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocument: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument: (document, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'document' is not null or undefined
            (0, common_1.assertParamExists)('saveDocument', 'document', document);
            const localVarPath = `/api/admin/employee/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(document, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewDocument: (docId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'docId' is not null or undefined
            (0, common_1.assertParamExists)('viewDocument', 'docId', docId);
            const localVarPath = `/api/admin/employee/document/view/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DocumentRestControllerApiAxiosParamCreator = DocumentRestControllerApiAxiosParamCreator;
/**
 * DocumentRestControllerApi - functional programming interface
 * @export
 */
const DocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DocumentRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocument(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countDocument(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.countDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.deleteOrDismissDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocument(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchDocument(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.deleteOrDismissInBatchDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.getDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocument(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDocument(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.listDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocument(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageDocument(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.pageDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument(document, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveDocument(document, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.saveDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewDocument(docId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewDocument(docId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentRestControllerApi.viewDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DocumentRestControllerApiFp = DocumentRestControllerApiFp;
/**
 * DocumentRestControllerApi - factory interface
 * @export
 */
const DocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DocumentRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocument(term, showDismissed, options) {
            return localVarFp.countDocument(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocument(id, options) {
            return localVarFp.deleteOrDismissDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(id, options) {
            return localVarFp.getDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocument(term, showDismissed, options) {
            return localVarFp.listDocument(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocument(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageDocument(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument(document, options) {
            return localVarFp.saveDocument(document, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewDocument(docId, options) {
            return localVarFp.viewDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DocumentRestControllerApiFactory = DocumentRestControllerApiFactory;
/**
 * DocumentRestControllerApi - object-oriented interface
 * @export
 * @class DocumentRestControllerApi
 * @extends {BaseAPI}
 */
class DocumentRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    countDocument(term, showDismissed, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).countDocument(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    deleteOrDismissDocument(id, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).deleteOrDismissDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    deleteOrDismissInBatchDocument(ids, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).deleteOrDismissInBatchDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    getDocument(id, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).getDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    listDocument(term, showDismissed, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).listDocument(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    pageDocument(page, size, sort, term, showDismissed, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).pageDocument(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Document} document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    saveDocument(document, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).saveDocument(document, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    viewDocument(docId, options) {
        return (0, exports.DocumentRestControllerApiFp)(this.configuration).viewDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DocumentRestControllerApi = DocumentRestControllerApi;
/**
 * EmpDocumentRestControllerApi - axios parameter creator
 * @export
 */
const EmpDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeDocuments: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeDocument: (docId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'docId' is not null or undefined
            (0, common_1.assertParamExists)('viewEmployeeDocument', 'docId', docId);
            const localVarPath = `/api/employee/document/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpDocumentRestControllerApiAxiosParamCreator = EmpDocumentRestControllerApiAxiosParamCreator;
/**
 * EmpDocumentRestControllerApi - functional programming interface
 * @export
 */
const EmpDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpDocumentRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeDocuments(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEmployeeDocuments(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpDocumentRestControllerApi.listEmployeeDocuments']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeDocument(docId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewEmployeeDocument(docId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpDocumentRestControllerApi.viewEmployeeDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpDocumentRestControllerApiFp = EmpDocumentRestControllerApiFp;
/**
 * EmpDocumentRestControllerApi - factory interface
 * @export
 */
const EmpDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpDocumentRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeDocuments(options) {
            return localVarFp.listEmployeeDocuments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeDocument(docId, options) {
            return localVarFp.viewEmployeeDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpDocumentRestControllerApiFactory = EmpDocumentRestControllerApiFactory;
/**
 * EmpDocumentRestControllerApi - object-oriented interface
 * @export
 * @class EmpDocumentRestControllerApi
 * @extends {BaseAPI}
 */
class EmpDocumentRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpDocumentRestControllerApi
     */
    listEmployeeDocuments(options) {
        return (0, exports.EmpDocumentRestControllerApiFp)(this.configuration).listEmployeeDocuments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpDocumentRestControllerApi
     */
    viewEmployeeDocument(docId, options) {
        return (0, exports.EmpDocumentRestControllerApiFp)(this.configuration).viewEmployeeDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpDocumentRestControllerApi = EmpDocumentRestControllerApi;
/**
 * EmpEvaluationRestControllerApi - axios parameter creator
 * @export
 */
const EmpEvaluationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoints: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/evaluation/points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointResults: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/evaluation/point-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeEvaluation: (page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/evaluation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeEvaluation: (evaluation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'evaluation' is not null or undefined
            (0, common_1.assertParamExists)('saveEmployeeEvaluation', 'evaluation', evaluation);
            const localVarPath = `/api/employee/evaluation/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(evaluation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpEvaluationRestControllerApiAxiosParamCreator = EmpEvaluationRestControllerApiAxiosParamCreator;
/**
 * EmpEvaluationRestControllerApi - functional programming interface
 * @export
 */
const EmpEvaluationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpEvaluationRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoints(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEvaluationPoints(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpEvaluationRestControllerApi.getEvaluationPoints']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointResults(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPointResults(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpEvaluationRestControllerApi.getPointResults']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeEvaluation(page, size, sort, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageEmployeeEvaluation(page, size, sort, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpEvaluationRestControllerApi.pageEmployeeEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeEvaluation(evaluation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEmployeeEvaluation(evaluation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpEvaluationRestControllerApi.saveEmployeeEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpEvaluationRestControllerApiFp = EmpEvaluationRestControllerApiFp;
/**
 * EmpEvaluationRestControllerApi - factory interface
 * @export
 */
const EmpEvaluationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpEvaluationRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoints(options) {
            return localVarFp.getEvaluationPoints(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointResults(options) {
            return localVarFp.getPointResults(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeEvaluation(page, size, sort, options) {
            return localVarFp.pageEmployeeEvaluation(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeEvaluation(evaluation, options) {
            return localVarFp.saveEmployeeEvaluation(evaluation, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpEvaluationRestControllerApiFactory = EmpEvaluationRestControllerApiFactory;
/**
 * EmpEvaluationRestControllerApi - object-oriented interface
 * @export
 * @class EmpEvaluationRestControllerApi
 * @extends {BaseAPI}
 */
class EmpEvaluationRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    getEvaluationPoints(options) {
        return (0, exports.EmpEvaluationRestControllerApiFp)(this.configuration).getEvaluationPoints(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    getPointResults(options) {
        return (0, exports.EmpEvaluationRestControllerApiFp)(this.configuration).getPointResults(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    pageEmployeeEvaluation(page, size, sort, options) {
        return (0, exports.EmpEvaluationRestControllerApiFp)(this.configuration).pageEmployeeEvaluation(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Evaluation} evaluation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    saveEmployeeEvaluation(evaluation, options) {
        return (0, exports.EmpEvaluationRestControllerApiFp)(this.configuration).saveEmployeeEvaluation(evaluation, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpEvaluationRestControllerApi = EmpEvaluationRestControllerApi;
/**
 * EmpLearningRestControllerApi - axios parameter creator
 * @export
 */
const EmpLearningRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} code
         * @param {string} section
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLearning: (code, section, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'code' is not null or undefined
            (0, common_1.assertParamExists)('getPageLearning', 'code', code);
            // verify required parameter 'section' is not null or undefined
            (0, common_1.assertParamExists)('getPageLearning', 'section', section);
            const localVarPath = `/api/employee/learning/wiki/{section}/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"section"}}`, encodeURIComponent(String(section)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpLearningRestControllerApiAxiosParamCreator = EmpLearningRestControllerApiAxiosParamCreator;
/**
 * EmpLearningRestControllerApi - functional programming interface
 * @export
 */
const EmpLearningRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpLearningRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} section
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLearning(code, section, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPageLearning(code, section, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpLearningRestControllerApi.getPageLearning']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpLearningRestControllerApiFp = EmpLearningRestControllerApiFp;
/**
 * EmpLearningRestControllerApi - factory interface
 * @export
 */
const EmpLearningRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpLearningRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} section
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLearning(code, section, options) {
            return localVarFp.getPageLearning(code, section, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpLearningRestControllerApiFactory = EmpLearningRestControllerApiFactory;
/**
 * EmpLearningRestControllerApi - object-oriented interface
 * @export
 * @class EmpLearningRestControllerApi
 * @extends {BaseAPI}
 */
class EmpLearningRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} code
     * @param {string} section
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpLearningRestControllerApi
     */
    getPageLearning(code, section, options) {
        return (0, exports.EmpLearningRestControllerApiFp)(this.configuration).getPageLearning(code, section, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpLearningRestControllerApi = EmpLearningRestControllerApi;
/**
 * EmpManagerRestControllerApi - axios parameter creator
 * @export
 */
const EmpManagerRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<number>} vacationIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveManagedVacations: (vacationIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vacationIds' is not null or undefined
            (0, common_1.assertParamExists)('approveManagedVacations', 'vacationIds', vacationIds);
            const localVarPath = `/api/employee/manager/vacations/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (vacationIds) {
                localVarQueryParameter['vacationIds'] = vacationIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedPendingVacations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/manager/vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStats: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/manager/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpManagerRestControllerApiAxiosParamCreator = EmpManagerRestControllerApiAxiosParamCreator;
/**
 * EmpManagerRestControllerApi - functional programming interface
 * @export
 */
const EmpManagerRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpManagerRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<number>} vacationIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveManagedVacations(vacationIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveManagedVacations(vacationIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpManagerRestControllerApi.approveManagedVacations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedPendingVacations(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getManagedPendingVacations(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpManagerRestControllerApi.getManagedPendingVacations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStats(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.managerStats(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpManagerRestControllerApi.managerStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpManagerRestControllerApiFp = EmpManagerRestControllerApiFp;
/**
 * EmpManagerRestControllerApi - factory interface
 * @export
 */
const EmpManagerRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpManagerRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {Array<number>} vacationIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveManagedVacations(vacationIds, options) {
            return localVarFp.approveManagedVacations(vacationIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedPendingVacations(options) {
            return localVarFp.getManagedPendingVacations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStats(year, options) {
            return localVarFp.managerStats(year, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpManagerRestControllerApiFactory = EmpManagerRestControllerApiFactory;
/**
 * EmpManagerRestControllerApi - object-oriented interface
 * @export
 * @class EmpManagerRestControllerApi
 * @extends {BaseAPI}
 */
class EmpManagerRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {Array<number>} vacationIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpManagerRestControllerApi
     */
    approveManagedVacations(vacationIds, options) {
        return (0, exports.EmpManagerRestControllerApiFp)(this.configuration).approveManagedVacations(vacationIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpManagerRestControllerApi
     */
    getManagedPendingVacations(options) {
        return (0, exports.EmpManagerRestControllerApiFp)(this.configuration).getManagedPendingVacations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpManagerRestControllerApi
     */
    managerStats(year, options) {
        return (0, exports.EmpManagerRestControllerApiFp)(this.configuration).managerStats(year, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpManagerRestControllerApi = EmpManagerRestControllerApi;
/**
 * EmpStatsRestControllerApi - axios parameter creator
 * @export
 */
const EmpStatsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedBudgetsStats: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/stats/budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStats: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpStatsRestControllerApiAxiosParamCreator = EmpStatsRestControllerApiAxiosParamCreator;
/**
 * EmpStatsRestControllerApi - functional programming interface
 * @export
 */
const EmpStatsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpStatsRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedBudgetsStats(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAggregatedBudgetsStats(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpStatsRestControllerApi.getAggregatedBudgetsStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStats(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHomeStats(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpStatsRestControllerApi.getHomeStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpStatsRestControllerApiFp = EmpStatsRestControllerApiFp;
/**
 * EmpStatsRestControllerApi - factory interface
 * @export
 */
const EmpStatsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpStatsRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedBudgetsStats(options) {
            return localVarFp.getAggregatedBudgetsStats(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStats(options) {
            return localVarFp.getHomeStats(options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpStatsRestControllerApiFactory = EmpStatsRestControllerApiFactory;
/**
 * EmpStatsRestControllerApi - object-oriented interface
 * @export
 * @class EmpStatsRestControllerApi
 * @extends {BaseAPI}
 */
class EmpStatsRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpStatsRestControllerApi
     */
    getAggregatedBudgetsStats(options) {
        return (0, exports.EmpStatsRestControllerApiFp)(this.configuration).getAggregatedBudgetsStats(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpStatsRestControllerApi
     */
    getHomeStats(options) {
        return (0, exports.EmpStatsRestControllerApiFp)(this.configuration).getHomeStats(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpStatsRestControllerApi = EmpStatsRestControllerApi;
/**
 * EmpUploadRestControllerApi - axios parameter creator
 * @export
 */
const EmpUploadRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeUploadTypes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/upload/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeUpload: (page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeUpload: (personDocument, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personDocument' is not null or undefined
            (0, common_1.assertParamExists)('saveEmployeeUpload', 'personDocument', personDocument);
            const localVarPath = `/api/employee/upload/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(personDocument, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeEstimationHours: (year, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('viewEmployeeEstimationHours', 'year', year);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('viewEmployeeEstimationHours', 'month', month);
            const localVarPath = `/api/employee/upload/estimation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeUpload: (docId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'docId' is not null or undefined
            (0, common_1.assertParamExists)('viewEmployeeUpload', 'docId', docId);
            const localVarPath = `/api/employee/upload/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpUploadRestControllerApiAxiosParamCreator = EmpUploadRestControllerApiAxiosParamCreator;
/**
 * EmpUploadRestControllerApi - functional programming interface
 * @export
 */
const EmpUploadRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpUploadRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeUploadTypes(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeUploadTypes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpUploadRestControllerApi.getEmployeeUploadTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeUpload(page, size, sort, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageEmployeeUpload(page, size, sort, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpUploadRestControllerApi.pageEmployeeUpload']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeUpload(personDocument, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEmployeeUpload(personDocument, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpUploadRestControllerApi.saveEmployeeUpload']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeEstimationHours(year, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewEmployeeEstimationHours(year, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpUploadRestControllerApi.viewEmployeeEstimationHours']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeUpload(docId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewEmployeeUpload(docId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpUploadRestControllerApi.viewEmployeeUpload']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpUploadRestControllerApiFp = EmpUploadRestControllerApiFp;
/**
 * EmpUploadRestControllerApi - factory interface
 * @export
 */
const EmpUploadRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpUploadRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeUploadTypes(options) {
            return localVarFp.getEmployeeUploadTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeUpload(page, size, sort, options) {
            return localVarFp.pageEmployeeUpload(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeUpload(personDocument, options) {
            return localVarFp.saveEmployeeUpload(personDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeEstimationHours(year, month, options) {
            return localVarFp.viewEmployeeEstimationHours(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeUpload(docId, options) {
            return localVarFp.viewEmployeeUpload(docId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpUploadRestControllerApiFactory = EmpUploadRestControllerApiFactory;
/**
 * EmpUploadRestControllerApi - object-oriented interface
 * @export
 * @class EmpUploadRestControllerApi
 * @extends {BaseAPI}
 */
class EmpUploadRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    getEmployeeUploadTypes(options) {
        return (0, exports.EmpUploadRestControllerApiFp)(this.configuration).getEmployeeUploadTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    pageEmployeeUpload(page, size, sort, options) {
        return (0, exports.EmpUploadRestControllerApiFp)(this.configuration).pageEmployeeUpload(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocument} personDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    saveEmployeeUpload(personDocument, options) {
        return (0, exports.EmpUploadRestControllerApiFp)(this.configuration).saveEmployeeUpload(personDocument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    viewEmployeeEstimationHours(year, month, options) {
        return (0, exports.EmpUploadRestControllerApiFp)(this.configuration).viewEmployeeEstimationHours(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    viewEmployeeUpload(docId, options) {
        return (0, exports.EmpUploadRestControllerApiFp)(this.configuration).viewEmployeeUpload(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpUploadRestControllerApi = EmpUploadRestControllerApi;
/**
 * EmpVacationRestControllerApi - axios parameter creator
 * @export
 */
const EmpVacationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeVacations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VacationRequest} vacationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newEmployeeVacationRequest: (vacationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vacationRequest' is not null or undefined
            (0, common_1.assertParamExists)('newEmployeeVacationRequest', 'vacationRequest', vacationRequest);
            const localVarPath = `/api/employee/vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vacationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmpVacationRestControllerApiAxiosParamCreator = EmpVacationRestControllerApiAxiosParamCreator;
/**
 * EmpVacationRestControllerApi - functional programming interface
 * @export
 */
const EmpVacationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmpVacationRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeVacations(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeVacations(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpVacationRestControllerApi.getEmployeeVacations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {VacationRequest} vacationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newEmployeeVacationRequest(vacationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newEmployeeVacationRequest(vacationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmpVacationRestControllerApi.newEmployeeVacationRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmpVacationRestControllerApiFp = EmpVacationRestControllerApiFp;
/**
 * EmpVacationRestControllerApi - factory interface
 * @export
 */
const EmpVacationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmpVacationRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeVacations(options) {
            return localVarFp.getEmployeeVacations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VacationRequest} vacationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newEmployeeVacationRequest(vacationRequest, options) {
            return localVarFp.newEmployeeVacationRequest(vacationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmpVacationRestControllerApiFactory = EmpVacationRestControllerApiFactory;
/**
 * EmpVacationRestControllerApi - object-oriented interface
 * @export
 * @class EmpVacationRestControllerApi
 * @extends {BaseAPI}
 */
class EmpVacationRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpVacationRestControllerApi
     */
    getEmployeeVacations(options) {
        return (0, exports.EmpVacationRestControllerApiFp)(this.configuration).getEmployeeVacations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VacationRequest} vacationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpVacationRestControllerApi
     */
    newEmployeeVacationRequest(vacationRequest, options) {
        return (0, exports.EmpVacationRestControllerApiFp)(this.configuration).newEmployeeVacationRequest(vacationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmpVacationRestControllerApi = EmpVacationRestControllerApi;
/**
 * EmployeeRestControllerApi - axios parameter creator
 * @export
 */
const EmployeeRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} centerId
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeBookings: (centerId, month, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'centerId' is not null or undefined
            (0, common_1.assertParamExists)('getEmployeeBookings', 'centerId', centerId);
            // verify required parameter 'month' is not null or undefined
            (0, common_1.assertParamExists)('getEmployeeBookings', 'month', month);
            const localVarPath = `/api/employee/book`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (centerId !== undefined) {
                localVarQueryParameter['centerId'] = centerId;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDirectory: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeHolidays: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('getEmployeeHolidays', 'year', year);
            const localVarPath = `/api/employee/holiday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeePayrolls: (page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/payroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeReminders: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeTrainingLevels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/training-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkCenters: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/work-centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEvaluationDays: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/lastEvaluationDays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} centerId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeBooking: (centerId, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'centerId' is not null or undefined
            (0, common_1.assertParamExists)('saveEmployeeBooking', 'centerId', centerId);
            // verify required parameter 'date' is not null or undefined
            (0, common_1.assertParamExists)('saveEmployeeBooking', 'date', date);
            const localVarPath = `/api/employee/book`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (centerId !== undefined) {
                localVarQueryParameter['centerId'] = centerId;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substring(0, 10) :
                    date;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EmployeeData} employeeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeInfo: (employeeData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'employeeData' is not null or undefined
            (0, common_1.assertParamExists)('updateEmployeeInfo', 'employeeData', employeeData);
            const localVarPath = `/api/employee/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(employeeData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonLogData} personLogData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogData: (personLogData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personLogData' is not null or undefined
            (0, common_1.assertParamExists)('uploadLogData', 'personLogData', personLogData);
            const localVarPath = `/api/employee/uploadLogData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(personLogData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeInfo: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/employee/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePayroll: (payrollId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payrollId' is not null or undefined
            (0, common_1.assertParamExists)('viewEmployeePayroll', 'payrollId', payrollId);
            const localVarPath = `/api/employee/payroll/{payrollId}`
                .replace(`{${"payrollId"}}`, encodeURIComponent(String(payrollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePhoto: (personId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('viewEmployeePhoto', 'personId', personId);
            const localVarPath = `/api/employee/photo/{personId}`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmployeeRestControllerApiAxiosParamCreator = EmployeeRestControllerApiAxiosParamCreator;
/**
 * EmployeeRestControllerApi - functional programming interface
 * @export
 */
const EmployeeRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmployeeRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} centerId
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeBookings(centerId, month, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeBookings(centerId, month, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeeBookings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDirectory(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeDirectory(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeeDirectory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeHolidays(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeHolidays(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeeHolidays']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeePayrolls(page, size, sort, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeePayrolls(page, size, sort, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeePayrolls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeReminders(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeReminders(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeeReminders']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeTrainingLevels(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeTrainingLevels(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeeTrainingLevels']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkCenters(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeWorkCenters(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getEmployeeWorkCenters']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEvaluationDays(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLastEvaluationDays(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.getLastEvaluationDays']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} centerId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeBooking(centerId, date, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEmployeeBooking(centerId, date, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.saveEmployeeBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EmployeeData} employeeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeInfo(employeeData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEmployeeInfo(employeeData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.updateEmployeeInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PersonLogData} personLogData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogData(personLogData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadLogData(personLogData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.uploadLogData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeInfo(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewEmployeeInfo(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.viewEmployeeInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePayroll(payrollId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewEmployeePayroll(payrollId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.viewEmployeePayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePhoto(personId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewEmployeePhoto(personId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeRestControllerApi.viewEmployeePhoto']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmployeeRestControllerApiFp = EmployeeRestControllerApiFp;
/**
 * EmployeeRestControllerApi - factory interface
 * @export
 */
const EmployeeRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmployeeRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} centerId
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeBookings(centerId, month, options) {
            return localVarFp.getEmployeeBookings(centerId, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDirectory(options) {
            return localVarFp.getEmployeeDirectory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeHolidays(year, options) {
            return localVarFp.getEmployeeHolidays(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeePayrolls(page, size, sort, options) {
            return localVarFp.getEmployeePayrolls(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeReminders(options) {
            return localVarFp.getEmployeeReminders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeTrainingLevels(options) {
            return localVarFp.getEmployeeTrainingLevels(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkCenters(options) {
            return localVarFp.getEmployeeWorkCenters(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEvaluationDays(options) {
            return localVarFp.getLastEvaluationDays(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} centerId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeBooking(centerId, date, options) {
            return localVarFp.saveEmployeeBooking(centerId, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EmployeeData} employeeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeInfo(employeeData, options) {
            return localVarFp.updateEmployeeInfo(employeeData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonLogData} personLogData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogData(personLogData, options) {
            return localVarFp.uploadLogData(personLogData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeInfo(options) {
            return localVarFp.viewEmployeeInfo(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePayroll(payrollId, options) {
            return localVarFp.viewEmployeePayroll(payrollId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePhoto(personId, options) {
            return localVarFp.viewEmployeePhoto(personId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmployeeRestControllerApiFactory = EmployeeRestControllerApiFactory;
/**
 * EmployeeRestControllerApi - object-oriented interface
 * @export
 * @class EmployeeRestControllerApi
 * @extends {BaseAPI}
 */
class EmployeeRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} centerId
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeBookings(centerId, month, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeeBookings(centerId, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeDirectory(options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeeDirectory(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeHolidays(year, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeeHolidays(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeePayrolls(page, size, sort, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeePayrolls(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeReminders(options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeeReminders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeTrainingLevels(options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeeTrainingLevels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeWorkCenters(options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getEmployeeWorkCenters(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getLastEvaluationDays(options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).getLastEvaluationDays(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} centerId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    saveEmployeeBooking(centerId, date, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).saveEmployeeBooking(centerId, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EmployeeData} employeeData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    updateEmployeeInfo(employeeData, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).updateEmployeeInfo(employeeData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonLogData} personLogData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    uploadLogData(personLogData, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).uploadLogData(personLogData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    viewEmployeeInfo(options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).viewEmployeeInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    viewEmployeePayroll(payrollId, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).viewEmployeePayroll(payrollId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    viewEmployeePhoto(personId, options) {
        return (0, exports.EmployeeRestControllerApiFp)(this.configuration).viewEmployeePhoto(personId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmployeeRestControllerApi = EmployeeRestControllerApi;
/**
 * EmployeeStatsRestControllerApi - axios parameter creator
 * @export
 */
const EmployeeStatsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNotifications: (date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/stats/month-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substring(0, 10) :
                    date;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmployeeStatsRestControllerApiAxiosParamCreator = EmployeeStatsRestControllerApiAxiosParamCreator;
/**
 * EmployeeStatsRestControllerApi - functional programming interface
 * @export
 */
const EmployeeStatsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmployeeStatsRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNotifications(date, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkNotifications(date, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeStatsRestControllerApi.checkNotifications']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeStats(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EmployeeStatsRestControllerApi.getEmployeeStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EmployeeStatsRestControllerApiFp = EmployeeStatsRestControllerApiFp;
/**
 * EmployeeStatsRestControllerApi - factory interface
 * @export
 */
const EmployeeStatsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmployeeStatsRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNotifications(date, options) {
            return localVarFp.checkNotifications(date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats(options) {
            return localVarFp.getEmployeeStats(options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmployeeStatsRestControllerApiFactory = EmployeeStatsRestControllerApiFactory;
/**
 * EmployeeStatsRestControllerApi - object-oriented interface
 * @export
 * @class EmployeeStatsRestControllerApi
 * @extends {BaseAPI}
 */
class EmployeeStatsRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeStatsRestControllerApi
     */
    checkNotifications(date, options) {
        return (0, exports.EmployeeStatsRestControllerApiFp)(this.configuration).checkNotifications(date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeStatsRestControllerApi
     */
    getEmployeeStats(options) {
        return (0, exports.EmployeeStatsRestControllerApiFp)(this.configuration).getEmployeeStats(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmployeeStatsRestControllerApi = EmployeeStatsRestControllerApi;
/**
 * EvaluationPointRestControllerApi - axios parameter creator
 * @export
 */
const EvaluationPointRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationPoint: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/question/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationPoint: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissEvaluationPoint', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationPoint: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchEvaluationPoint', 'ids', ids);
            const localVarPath = `/api/admin/employee/evaluation/question/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoint: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getEvaluationPoint', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationPoint: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/question/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationPoint: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/question/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EvaluationPoint} evaluationPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationPoint: (evaluationPoint, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'evaluationPoint' is not null or undefined
            (0, common_1.assertParamExists)('saveEvaluationPoint', 'evaluationPoint', evaluationPoint);
            const localVarPath = `/api/admin/employee/evaluation/question/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(evaluationPoint, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EvaluationPointRestControllerApiAxiosParamCreator = EvaluationPointRestControllerApiAxiosParamCreator;
/**
 * EvaluationPointRestControllerApi - functional programming interface
 * @export
 */
const EvaluationPointRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EvaluationPointRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationPoint(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countEvaluationPoint(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.countEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationPoint(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissEvaluationPoint(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.deleteOrDismissEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationPoint(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchEvaluationPoint(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.deleteOrDismissInBatchEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoint(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEvaluationPoint(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.getEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationPoint(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEvaluationPoint(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.listEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationPoint(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageEvaluationPoint(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.pageEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EvaluationPoint} evaluationPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationPoint(evaluationPoint, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEvaluationPoint(evaluationPoint, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationPointRestControllerApi.saveEvaluationPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EvaluationPointRestControllerApiFp = EvaluationPointRestControllerApiFp;
/**
 * EvaluationPointRestControllerApi - factory interface
 * @export
 */
const EvaluationPointRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EvaluationPointRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationPoint(term, showDismissed, options) {
            return localVarFp.countEvaluationPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationPoint(id, options) {
            return localVarFp.deleteOrDismissEvaluationPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationPoint(ids, options) {
            return localVarFp.deleteOrDismissInBatchEvaluationPoint(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoint(id, options) {
            return localVarFp.getEvaluationPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationPoint(term, showDismissed, options) {
            return localVarFp.listEvaluationPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationPoint(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageEvaluationPoint(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EvaluationPoint} evaluationPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationPoint(evaluationPoint, options) {
            return localVarFp.saveEvaluationPoint(evaluationPoint, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EvaluationPointRestControllerApiFactory = EvaluationPointRestControllerApiFactory;
/**
 * EvaluationPointRestControllerApi - object-oriented interface
 * @export
 * @class EvaluationPointRestControllerApi
 * @extends {BaseAPI}
 */
class EvaluationPointRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    countEvaluationPoint(term, showDismissed, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).countEvaluationPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    deleteOrDismissEvaluationPoint(id, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).deleteOrDismissEvaluationPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    deleteOrDismissInBatchEvaluationPoint(ids, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).deleteOrDismissInBatchEvaluationPoint(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    getEvaluationPoint(id, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).getEvaluationPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    listEvaluationPoint(term, showDismissed, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).listEvaluationPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    pageEvaluationPoint(page, size, sort, term, showDismissed, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).pageEvaluationPoint(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EvaluationPoint} evaluationPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    saveEvaluationPoint(evaluationPoint, options) {
        return (0, exports.EvaluationPointRestControllerApiFp)(this.configuration).saveEvaluationPoint(evaluationPoint, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EvaluationPointRestControllerApi = EvaluationPointRestControllerApi;
/**
 * EvaluationRestControllerApi - axios parameter creator
 * @export
 */
const EvaluationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluation: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluation: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissEvaluation', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluation: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchEvaluation', 'ids', ids);
            const localVarPath = `/api/admin/employee/evaluation/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluation: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getEvaluation', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluation: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluation: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluation: (evaluation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'evaluation' is not null or undefined
            (0, common_1.assertParamExists)('saveEvaluation', 'evaluation', evaluation);
            const localVarPath = `/api/admin/employee/evaluation/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(evaluation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EvaluationRestControllerApiAxiosParamCreator = EvaluationRestControllerApiAxiosParamCreator;
/**
 * EvaluationRestControllerApi - functional programming interface
 * @export
 */
const EvaluationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EvaluationRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.countEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluation(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissEvaluation(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.deleteOrDismissEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluation(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchEvaluation(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.deleteOrDismissInBatchEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluation(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEvaluation(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.getEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.listEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.pageEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluation(evaluation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEvaluation(evaluation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationRestControllerApi.saveEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EvaluationRestControllerApiFp = EvaluationRestControllerApiFp;
/**
 * EvaluationRestControllerApi - factory interface
 * @export
 */
const EvaluationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EvaluationRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluation(id, options) {
            return localVarFp.deleteOrDismissEvaluation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluation(ids, options) {
            return localVarFp.deleteOrDismissInBatchEvaluation(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluation(id, options) {
            return localVarFp.getEvaluation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluation(evaluation, options) {
            return localVarFp.saveEvaluation(evaluation, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EvaluationRestControllerApiFactory = EvaluationRestControllerApiFactory;
/**
 * EvaluationRestControllerApi - object-oriented interface
 * @export
 * @class EvaluationRestControllerApi
 * @extends {BaseAPI}
 */
class EvaluationRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    deleteOrDismissEvaluation(id, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).deleteOrDismissEvaluation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    deleteOrDismissInBatchEvaluation(ids, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).deleteOrDismissInBatchEvaluation(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    getEvaluation(id, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).getEvaluation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Evaluation} evaluation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    saveEvaluation(evaluation, options) {
        return (0, exports.EvaluationRestControllerApiFp)(this.configuration).saveEvaluation(evaluation, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EvaluationRestControllerApi = EvaluationRestControllerApi;
/**
 * EvaluationResultRestControllerApi - axios parameter creator
 * @export
 */
const EvaluationResultRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationResult: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/question/result/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationResult: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissEvaluationResult', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationResult: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchEvaluationResult', 'ids', ids);
            const localVarPath = `/api/admin/employee/evaluation/question/result/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationResult: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getEvaluationResult', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationResult: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/question/result/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationResult: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/evaluation/question/result/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EvaluationResult} evaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationResult: (evaluationResult, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'evaluationResult' is not null or undefined
            (0, common_1.assertParamExists)('saveEvaluationResult', 'evaluationResult', evaluationResult);
            const localVarPath = `/api/admin/employee/evaluation/question/result/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(evaluationResult, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EvaluationResultRestControllerApiAxiosParamCreator = EvaluationResultRestControllerApiAxiosParamCreator;
/**
 * EvaluationResultRestControllerApi - functional programming interface
 * @export
 */
const EvaluationResultRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EvaluationResultRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationResult(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countEvaluationResult(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.countEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationResult(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissEvaluationResult(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.deleteOrDismissEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationResult(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchEvaluationResult(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.deleteOrDismissInBatchEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationResult(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEvaluationResult(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.getEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationResult(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEvaluationResult(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.listEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationResult(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageEvaluationResult(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.pageEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EvaluationResult} evaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationResult(evaluationResult, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEvaluationResult(evaluationResult, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EvaluationResultRestControllerApi.saveEvaluationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EvaluationResultRestControllerApiFp = EvaluationResultRestControllerApiFp;
/**
 * EvaluationResultRestControllerApi - factory interface
 * @export
 */
const EvaluationResultRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EvaluationResultRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationResult(term, showDismissed, options) {
            return localVarFp.countEvaluationResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationResult(id, options) {
            return localVarFp.deleteOrDismissEvaluationResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationResult(ids, options) {
            return localVarFp.deleteOrDismissInBatchEvaluationResult(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationResult(id, options) {
            return localVarFp.getEvaluationResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationResult(term, showDismissed, options) {
            return localVarFp.listEvaluationResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationResult(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageEvaluationResult(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EvaluationResult} evaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationResult(evaluationResult, options) {
            return localVarFp.saveEvaluationResult(evaluationResult, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EvaluationResultRestControllerApiFactory = EvaluationResultRestControllerApiFactory;
/**
 * EvaluationResultRestControllerApi - object-oriented interface
 * @export
 * @class EvaluationResultRestControllerApi
 * @extends {BaseAPI}
 */
class EvaluationResultRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    countEvaluationResult(term, showDismissed, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).countEvaluationResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    deleteOrDismissEvaluationResult(id, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).deleteOrDismissEvaluationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    deleteOrDismissInBatchEvaluationResult(ids, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).deleteOrDismissInBatchEvaluationResult(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    getEvaluationResult(id, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).getEvaluationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    listEvaluationResult(term, showDismissed, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).listEvaluationResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    pageEvaluationResult(page, size, sort, term, showDismissed, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).pageEvaluationResult(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EvaluationResult} evaluationResult
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    saveEvaluationResult(evaluationResult, options) {
        return (0, exports.EvaluationResultRestControllerApiFp)(this.configuration).saveEvaluationResult(evaluationResult, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EvaluationResultRestControllerApi = EvaluationResultRestControllerApi;
/**
 * HolidayRestControllerApi - axios parameter creator
 * @export
 */
const HolidayRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countHoliday: (year, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/holidays/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissHoliday: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissHoliday', 'id', id);
            const localVarPath = `/api/admin/employee/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchHoliday: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchHoliday', 'ids', ids);
            const localVarPath = `/api/admin/employee/holidays/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoliday: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getHoliday', 'id', id);
            const localVarPath = `/api/admin/employee/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHoliday: (year, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/holidays/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageHoliday: (page, size, sort, year, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/holidays/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Holiday} holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHoliday: (holiday, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'holiday' is not null or undefined
            (0, common_1.assertParamExists)('saveHoliday', 'holiday', holiday);
            const localVarPath = `/api/admin/employee/holidays/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(holiday, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.HolidayRestControllerApiAxiosParamCreator = HolidayRestControllerApiAxiosParamCreator;
/**
 * HolidayRestControllerApi - functional programming interface
 * @export
 */
const HolidayRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.HolidayRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countHoliday(year, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countHoliday(year, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.countHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissHoliday(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissHoliday(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.deleteOrDismissHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchHoliday(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchHoliday(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.deleteOrDismissInBatchHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoliday(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHoliday(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.getHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHoliday(year, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listHoliday(year, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.listHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageHoliday(page, size, sort, year, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageHoliday(page, size, sort, year, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.pageHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Holiday} holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHoliday(holiday, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveHoliday(holiday, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HolidayRestControllerApi.saveHoliday']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.HolidayRestControllerApiFp = HolidayRestControllerApiFp;
/**
 * HolidayRestControllerApi - factory interface
 * @export
 */
const HolidayRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.HolidayRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countHoliday(year, term, showDismissed, options) {
            return localVarFp.countHoliday(year, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissHoliday(id, options) {
            return localVarFp.deleteOrDismissHoliday(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchHoliday(ids, options) {
            return localVarFp.deleteOrDismissInBatchHoliday(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoliday(id, options) {
            return localVarFp.getHoliday(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHoliday(year, term, showDismissed, options) {
            return localVarFp.listHoliday(year, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageHoliday(page, size, sort, year, term, showDismissed, options) {
            return localVarFp.pageHoliday(page, size, sort, year, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Holiday} holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHoliday(holiday, options) {
            return localVarFp.saveHoliday(holiday, options).then((request) => request(axios, basePath));
        },
    };
};
exports.HolidayRestControllerApiFactory = HolidayRestControllerApiFactory;
/**
 * HolidayRestControllerApi - object-oriented interface
 * @export
 * @class HolidayRestControllerApi
 * @extends {BaseAPI}
 */
class HolidayRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [year]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    countHoliday(year, term, showDismissed, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).countHoliday(year, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    deleteOrDismissHoliday(id, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).deleteOrDismissHoliday(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    deleteOrDismissInBatchHoliday(ids, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).deleteOrDismissInBatchHoliday(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    getHoliday(id, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).getHoliday(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    listHoliday(year, term, showDismissed, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).listHoliday(year, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    pageHoliday(page, size, sort, year, term, showDismissed, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).pageHoliday(page, size, sort, year, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Holiday} holiday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    saveHoliday(holiday, options) {
        return (0, exports.HolidayRestControllerApiFp)(this.configuration).saveHoliday(holiday, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HolidayRestControllerApi = HolidayRestControllerApi;
/**
 * InterviewRestControllerApi - axios parameter creator
 * @export
 */
const InterviewRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInterview: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/interview/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchInterview: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchInterview', 'ids', ids);
            const localVarPath = `/api/admin/employee/interview/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInterview: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInterview', 'id', id);
            const localVarPath = `/api/admin/employee/interview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getInterview', 'id', id);
            const localVarPath = `/api/admin/employee/interview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterview: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/interview/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageInterview: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/interview/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Interview} interview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInterview: (interview, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'interview' is not null or undefined
            (0, common_1.assertParamExists)('saveInterview', 'interview', interview);
            const localVarPath = `/api/admin/employee/interview/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(interview, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.InterviewRestControllerApiAxiosParamCreator = InterviewRestControllerApiAxiosParamCreator;
/**
 * InterviewRestControllerApi - functional programming interface
 * @export
 */
const InterviewRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InterviewRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.countInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchInterview(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchInterview(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.deleteOrDismissInBatchInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInterview(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInterview(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.deleteOrDismissInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInterview(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.getInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.listInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.pageInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Interview} interview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInterview(interview, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveInterview(interview, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InterviewRestControllerApi.saveInterview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.InterviewRestControllerApiFp = InterviewRestControllerApiFp;
/**
 * InterviewRestControllerApi - factory interface
 * @export
 */
const InterviewRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InterviewRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchInterview(ids, options) {
            return localVarFp.deleteOrDismissInBatchInterview(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInterview(id, options) {
            return localVarFp.deleteOrDismissInterview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview(id, options) {
            return localVarFp.getInterview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Interview} interview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInterview(interview, options) {
            return localVarFp.saveInterview(interview, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InterviewRestControllerApiFactory = InterviewRestControllerApiFactory;
/**
 * InterviewRestControllerApi - object-oriented interface
 * @export
 * @class InterviewRestControllerApi
 * @extends {BaseAPI}
 */
class InterviewRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    deleteOrDismissInBatchInterview(ids, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).deleteOrDismissInBatchInterview(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    deleteOrDismissInterview(id, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).deleteOrDismissInterview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    getInterview(id, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).getInterview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Interview} interview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    saveInterview(interview, options) {
        return (0, exports.InterviewRestControllerApiFp)(this.configuration).saveInterview(interview, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InterviewRestControllerApi = InterviewRestControllerApi;
/**
 * OccupationRestControllerApi - axios parameter creator
 * @export
 */
const OccupationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<number>} [personId]
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        occupation: (personId, year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/occupation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.OccupationRestControllerApiAxiosParamCreator = OccupationRestControllerApiAxiosParamCreator;
/**
 * OccupationRestControllerApi - functional programming interface
 * @export
 */
const OccupationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.OccupationRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<number>} [personId]
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        occupation(personId, year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.occupation(personId, year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OccupationRestControllerApi.occupation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.OccupationRestControllerApiFp = OccupationRestControllerApiFp;
/**
 * OccupationRestControllerApi - factory interface
 * @export
 */
const OccupationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.OccupationRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {Array<number>} [personId]
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        occupation(personId, year, options) {
            return localVarFp.occupation(personId, year, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OccupationRestControllerApiFactory = OccupationRestControllerApiFactory;
/**
 * OccupationRestControllerApi - object-oriented interface
 * @export
 * @class OccupationRestControllerApi
 * @extends {BaseAPI}
 */
class OccupationRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {Array<number>} [personId]
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OccupationRestControllerApi
     */
    occupation(personId, year, options) {
        return (0, exports.OccupationRestControllerApiFp)(this.configuration).occupation(personId, year, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OccupationRestControllerApi = OccupationRestControllerApi;
/**
 * OrganizationUnitMemberRestControllerApi - axios parameter creator
 * @export
 */
const OrganizationUnitMemberRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnitMember: (personId, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('countOrganizationUnitMember', 'personId', personId);
            const localVarPath = `/api/admin/employee/organization-unit-member/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnitMember: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchOrganizationUnitMember', 'ids', ids);
            const localVarPath = `/api/admin/employee/organization-unit-member/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnitMember: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissOrganizationUnitMember', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit-member/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnitMember: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getOrganizationUnitMember', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit-member/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnitMember: (personId, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('listOrganizationUnitMember', 'personId', personId);
            const localVarPath = `/api/admin/employee/organization-unit-member/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnitMember: (personId, page, size, sort, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('pageOrganizationUnitMember', 'personId', personId);
            const localVarPath = `/api/admin/employee/organization-unit-member/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OrganizationUnitMember} organizationUnitMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnitMember: (organizationUnitMember, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUnitMember' is not null or undefined
            (0, common_1.assertParamExists)('saveOrganizationUnitMember', 'organizationUnitMember', organizationUnitMember);
            const localVarPath = `/api/admin/employee/organization-unit-member/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationUnitMember, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.OrganizationUnitMemberRestControllerApiAxiosParamCreator = OrganizationUnitMemberRestControllerApiAxiosParamCreator;
/**
 * OrganizationUnitMemberRestControllerApi - functional programming interface
 * @export
 */
const OrganizationUnitMemberRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.OrganizationUnitMemberRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.countOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnitMember(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchOrganizationUnitMember(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.deleteOrDismissInBatchOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnitMember(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissOrganizationUnitMember(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.deleteOrDismissOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnitMember(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationUnitMember(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.getOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.listOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.pageOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OrganizationUnitMember} organizationUnitMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnitMember(organizationUnitMember, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveOrganizationUnitMember(organizationUnitMember, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitMemberRestControllerApi.saveOrganizationUnitMember']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.OrganizationUnitMemberRestControllerApiFp = OrganizationUnitMemberRestControllerApiFp;
/**
 * OrganizationUnitMemberRestControllerApi - factory interface
 * @export
 */
const OrganizationUnitMemberRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.OrganizationUnitMemberRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnitMember(ids, options) {
            return localVarFp.deleteOrDismissInBatchOrganizationUnitMember(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnitMember(id, options) {
            return localVarFp.deleteOrDismissOrganizationUnitMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnitMember(id, options) {
            return localVarFp.getOrganizationUnitMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationUnitMember} organizationUnitMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnitMember(organizationUnitMember, options) {
            return localVarFp.saveOrganizationUnitMember(organizationUnitMember, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OrganizationUnitMemberRestControllerApiFactory = OrganizationUnitMemberRestControllerApiFactory;
/**
 * OrganizationUnitMemberRestControllerApi - object-oriented interface
 * @export
 * @class OrganizationUnitMemberRestControllerApi
 * @extends {BaseAPI}
 */
class OrganizationUnitMemberRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    deleteOrDismissInBatchOrganizationUnitMember(ids, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).deleteOrDismissInBatchOrganizationUnitMember(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    deleteOrDismissOrganizationUnitMember(id, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).deleteOrDismissOrganizationUnitMember(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    getOrganizationUnitMember(id, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).getOrganizationUnitMember(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrganizationUnitMember} organizationUnitMember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    saveOrganizationUnitMember(organizationUnitMember, options) {
        return (0, exports.OrganizationUnitMemberRestControllerApiFp)(this.configuration).saveOrganizationUnitMember(organizationUnitMember, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganizationUnitMemberRestControllerApi = OrganizationUnitMemberRestControllerApi;
/**
 * OrganizationUnitRestControllerApi - axios parameter creator
 * @export
 */
const OrganizationUnitRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnit: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/organization-unit/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnit: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchOrganizationUnit', 'ids', ids);
            const localVarPath = `/api/admin/employee/organization-unit/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnit: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissOrganizationUnit', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnit: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getOrganizationUnit', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnit: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/organization-unit/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnit: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/organization-unit/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OrganizationUnit} organizationUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnit: (organizationUnit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUnit' is not null or undefined
            (0, common_1.assertParamExists)('saveOrganizationUnit', 'organizationUnit', organizationUnit);
            const localVarPath = `/api/admin/employee/organization-unit/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationUnit, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.OrganizationUnitRestControllerApiAxiosParamCreator = OrganizationUnitRestControllerApiAxiosParamCreator;
/**
 * OrganizationUnitRestControllerApi - functional programming interface
 * @export
 */
const OrganizationUnitRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.OrganizationUnitRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnit(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countOrganizationUnit(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.countOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnit(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchOrganizationUnit(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.deleteOrDismissInBatchOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnit(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissOrganizationUnit(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.deleteOrDismissOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnit(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationUnit(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.getOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnit(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOrganizationUnit(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.listOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnit(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageOrganizationUnit(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.pageOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OrganizationUnit} organizationUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnit(organizationUnit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveOrganizationUnit(organizationUnit, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationUnitRestControllerApi.saveOrganizationUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.OrganizationUnitRestControllerApiFp = OrganizationUnitRestControllerApiFp;
/**
 * OrganizationUnitRestControllerApi - factory interface
 * @export
 */
const OrganizationUnitRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.OrganizationUnitRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnit(term, showDismissed, options) {
            return localVarFp.countOrganizationUnit(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnit(ids, options) {
            return localVarFp.deleteOrDismissInBatchOrganizationUnit(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnit(id, options) {
            return localVarFp.deleteOrDismissOrganizationUnit(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnit(id, options) {
            return localVarFp.getOrganizationUnit(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnit(term, showDismissed, options) {
            return localVarFp.listOrganizationUnit(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnit(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageOrganizationUnit(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationUnit} organizationUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnit(organizationUnit, options) {
            return localVarFp.saveOrganizationUnit(organizationUnit, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OrganizationUnitRestControllerApiFactory = OrganizationUnitRestControllerApiFactory;
/**
 * OrganizationUnitRestControllerApi - object-oriented interface
 * @export
 * @class OrganizationUnitRestControllerApi
 * @extends {BaseAPI}
 */
class OrganizationUnitRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    countOrganizationUnit(term, showDismissed, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).countOrganizationUnit(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    deleteOrDismissInBatchOrganizationUnit(ids, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).deleteOrDismissInBatchOrganizationUnit(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    deleteOrDismissOrganizationUnit(id, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).deleteOrDismissOrganizationUnit(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    getOrganizationUnit(id, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).getOrganizationUnit(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    listOrganizationUnit(term, showDismissed, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).listOrganizationUnit(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    pageOrganizationUnit(page, size, sort, term, showDismissed, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).pageOrganizationUnit(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrganizationUnit} organizationUnit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    saveOrganizationUnit(organizationUnit, options) {
        return (0, exports.OrganizationUnitRestControllerApiFp)(this.configuration).saveOrganizationUnit(organizationUnit, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganizationUnitRestControllerApi = OrganizationUnitRestControllerApi;
/**
 * PayrollPackRestControllerApi - axios parameter creator
 * @export
 */
const PayrollPackRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayrollPack: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/payroll/pack/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayrollPack: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPayrollPack', 'ids', ids);
            const localVarPath = `/api/admin/employee/payroll/pack/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayrollPack: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPayrollPack', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/pack/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCostsPayrollPack: (payrollPackId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payrollPackId' is not null or undefined
            (0, common_1.assertParamExists)('downloadCostsPayrollPack', 'payrollPackId', payrollPackId);
            const localVarPath = `/api/admin/employee/payroll/pack/{payrollPackId}/costs/download`
                .replace(`{${"payrollPackId"}}`, encodeURIComponent(String(payrollPackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfsPayrollPack: (payrollPackId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payrollPackId' is not null or undefined
            (0, common_1.assertParamExists)('downloadPdfsPayrollPack', 'payrollPackId', payrollPackId);
            const localVarPath = `/api/admin/employee/payroll/pack/{payrollPackId}/payroll/download`
                .replace(`{${"payrollPackId"}}`, encodeURIComponent(String(payrollPackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollPack: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPayrollPack', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/pack/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayrollPack: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/payroll/pack/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayrollPack: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/payroll/pack/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayrollPack: (payrollPackId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payrollPackId' is not null or undefined
            (0, common_1.assertParamExists)('processPayrollPack', 'payrollPackId', payrollPackId);
            const localVarPath = `/api/admin/employee/payroll/pack/{payrollPackId}/process`
                .replace(`{${"payrollPackId"}}`, encodeURIComponent(String(payrollPackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PayrollPack} payrollPack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayrollPack: (payrollPack, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payrollPack' is not null or undefined
            (0, common_1.assertParamExists)('savePayrollPack', 'payrollPack', payrollPack);
            const localVarPath = `/api/admin/employee/payroll/pack/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payrollPack, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PayrollPackRestControllerApiAxiosParamCreator = PayrollPackRestControllerApiAxiosParamCreator;
/**
 * PayrollPackRestControllerApi - functional programming interface
 * @export
 */
const PayrollPackRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PayrollPackRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayrollPack(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPayrollPack(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.countPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayrollPack(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPayrollPack(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.deleteOrDismissInBatchPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayrollPack(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPayrollPack(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.deleteOrDismissPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCostsPayrollPack(payrollPackId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadCostsPayrollPack(payrollPackId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.downloadCostsPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfsPayrollPack(payrollPackId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadPdfsPayrollPack(payrollPackId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.downloadPdfsPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollPack(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayrollPack(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.getPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayrollPack(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPayrollPack(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.listPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayrollPack(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePayrollPack(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.pagePayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayrollPack(payrollPackId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.processPayrollPack(payrollPackId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.processPayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PayrollPack} payrollPack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayrollPack(payrollPack, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePayrollPack(payrollPack, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollPackRestControllerApi.savePayrollPack']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PayrollPackRestControllerApiFp = PayrollPackRestControllerApiFp;
/**
 * PayrollPackRestControllerApi - factory interface
 * @export
 */
const PayrollPackRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PayrollPackRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayrollPack(term, showDismissed, options) {
            return localVarFp.countPayrollPack(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayrollPack(ids, options) {
            return localVarFp.deleteOrDismissInBatchPayrollPack(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayrollPack(id, options) {
            return localVarFp.deleteOrDismissPayrollPack(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCostsPayrollPack(payrollPackId, options) {
            return localVarFp.downloadCostsPayrollPack(payrollPackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfsPayrollPack(payrollPackId, options) {
            return localVarFp.downloadPdfsPayrollPack(payrollPackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollPack(id, options) {
            return localVarFp.getPayrollPack(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayrollPack(term, showDismissed, options) {
            return localVarFp.listPayrollPack(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayrollPack(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePayrollPack(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayrollPack(payrollPackId, options) {
            return localVarFp.processPayrollPack(payrollPackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PayrollPack} payrollPack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayrollPack(payrollPack, options) {
            return localVarFp.savePayrollPack(payrollPack, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PayrollPackRestControllerApiFactory = PayrollPackRestControllerApiFactory;
/**
 * PayrollPackRestControllerApi - object-oriented interface
 * @export
 * @class PayrollPackRestControllerApi
 * @extends {BaseAPI}
 */
class PayrollPackRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    countPayrollPack(term, showDismissed, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).countPayrollPack(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    deleteOrDismissInBatchPayrollPack(ids, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPayrollPack(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    deleteOrDismissPayrollPack(id, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).deleteOrDismissPayrollPack(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollPackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    downloadCostsPayrollPack(payrollPackId, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).downloadCostsPayrollPack(payrollPackId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollPackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    downloadPdfsPayrollPack(payrollPackId, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).downloadPdfsPayrollPack(payrollPackId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    getPayrollPack(id, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).getPayrollPack(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    listPayrollPack(term, showDismissed, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).listPayrollPack(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    pagePayrollPack(page, size, sort, term, showDismissed, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).pagePayrollPack(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollPackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    processPayrollPack(payrollPackId, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).processPayrollPack(payrollPackId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PayrollPack} payrollPack
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    savePayrollPack(payrollPack, options) {
        return (0, exports.PayrollPackRestControllerApiFp)(this.configuration).savePayrollPack(payrollPack, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PayrollPackRestControllerApi = PayrollPackRestControllerApi;
/**
 * PayrollRestControllerApi - axios parameter creator
 * @export
 */
const PayrollRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryPayroll: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('annualSummaryPayroll', 'year', year);
            const localVarPath = `/api/admin/employee/payroll/annual-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayroll: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/payroll/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayroll: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPayroll', 'ids', ids);
            const localVarPath = `/api/admin/employee/payroll/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayroll: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPayroll', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPayroll: (payrollId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payrollId' is not null or undefined
            (0, common_1.assertParamExists)('downloadPayroll', 'payrollId', payrollId);
            const localVarPath = `/api/admin/employee/payroll/{payrollId}/download`
                .replace(`{${"payrollId"}}`, encodeURIComponent(String(payrollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayroll: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPayroll', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayroll: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/payroll/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayroll: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/payroll/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Payroll} payroll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayroll: (payroll, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payroll' is not null or undefined
            (0, common_1.assertParamExists)('savePayroll', 'payroll', payroll);
            const localVarPath = `/api/admin/employee/payroll/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payroll, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PayrollRestControllerApiAxiosParamCreator = PayrollRestControllerApiAxiosParamCreator;
/**
 * PayrollRestControllerApi - functional programming interface
 * @export
 */
const PayrollRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PayrollRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryPayroll(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.annualSummaryPayroll(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.annualSummaryPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayroll(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPayroll(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.countPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayroll(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPayroll(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.deleteOrDismissInBatchPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayroll(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPayroll(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.deleteOrDismissPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPayroll(payrollId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadPayroll(payrollId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.downloadPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayroll(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayroll(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.getPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayroll(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPayroll(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.listPayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayroll(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePayroll(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.pagePayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Payroll} payroll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayroll(payroll, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePayroll(payroll, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PayrollRestControllerApi.savePayroll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PayrollRestControllerApiFp = PayrollRestControllerApiFp;
/**
 * PayrollRestControllerApi - factory interface
 * @export
 */
const PayrollRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PayrollRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryPayroll(year, options) {
            return localVarFp.annualSummaryPayroll(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayroll(term, showDismissed, options) {
            return localVarFp.countPayroll(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayroll(ids, options) {
            return localVarFp.deleteOrDismissInBatchPayroll(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayroll(id, options) {
            return localVarFp.deleteOrDismissPayroll(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPayroll(payrollId, options) {
            return localVarFp.downloadPayroll(payrollId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayroll(id, options) {
            return localVarFp.getPayroll(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayroll(term, showDismissed, options) {
            return localVarFp.listPayroll(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayroll(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePayroll(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Payroll} payroll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayroll(payroll, options) {
            return localVarFp.savePayroll(payroll, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PayrollRestControllerApiFactory = PayrollRestControllerApiFactory;
/**
 * PayrollRestControllerApi - object-oriented interface
 * @export
 * @class PayrollRestControllerApi
 * @extends {BaseAPI}
 */
class PayrollRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    annualSummaryPayroll(year, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).annualSummaryPayroll(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    countPayroll(term, showDismissed, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).countPayroll(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    deleteOrDismissInBatchPayroll(ids, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPayroll(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    deleteOrDismissPayroll(id, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).deleteOrDismissPayroll(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    downloadPayroll(payrollId, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).downloadPayroll(payrollId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    getPayroll(id, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).getPayroll(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    listPayroll(term, showDismissed, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).listPayroll(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    pagePayroll(page, size, sort, term, showDismissed, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).pagePayroll(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Payroll} payroll
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    savePayroll(payroll, options) {
        return (0, exports.PayrollRestControllerApiFp)(this.configuration).savePayroll(payroll, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PayrollRestControllerApi = PayrollRestControllerApi;
/**
 * PersonDocumentRestControllerApi - axios parameter creator
 * @export
 */
const PersonDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocument: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocument: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPersonDocument', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPersonDocument', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPersonDocument: (year, type, person, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (person !== undefined) {
                localVarQueryParameter['person'] = person;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPersonDocument', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocument: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocument: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocument: (personDocument, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personDocument' is not null or undefined
            (0, common_1.assertParamExists)('savePersonDocument', 'personDocument', personDocument);
            const localVarPath = `/api/admin/employee/person/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(personDocument, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPersonDocument: (docId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'docId' is not null or undefined
            (0, common_1.assertParamExists)('viewPersonDocument', 'docId', docId);
            const localVarPath = `/api/admin/employee/person/document/view/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonDocumentRestControllerApiAxiosParamCreator = PersonDocumentRestControllerApiAxiosParamCreator;
/**
 * PersonDocumentRestControllerApi - functional programming interface
 * @export
 */
const PersonDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonDocumentRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.countPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocument(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPersonDocument(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.deleteOrDismissInBatchPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPersonDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.deleteOrDismissPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPersonDocument(year, type, person, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportPersonDocument(year, type, person, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.exportPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.getPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.listPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocument(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePersonDocument(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.pagePersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocument(personDocument, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePersonDocument(personDocument, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.savePersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPersonDocument(docId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewPersonDocument(docId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentRestControllerApi.viewPersonDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PersonDocumentRestControllerApiFp = PersonDocumentRestControllerApiFp;
/**
 * PersonDocumentRestControllerApi - factory interface
 * @export
 */
const PersonDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonDocumentRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocument(id, options) {
            return localVarFp.deleteOrDismissPersonDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPersonDocument(year, type, person, options) {
            return localVarFp.exportPersonDocument(year, type, person, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocument(id, options) {
            return localVarFp.getPersonDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocument(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pagePersonDocument(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocument(personDocument, options) {
            return localVarFp.savePersonDocument(personDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPersonDocument(docId, options) {
            return localVarFp.viewPersonDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonDocumentRestControllerApiFactory = PersonDocumentRestControllerApiFactory;
/**
 * PersonDocumentRestControllerApi - object-oriented interface
 * @export
 * @class PersonDocumentRestControllerApi
 * @extends {BaseAPI}
 */
class PersonDocumentRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    countPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).countPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    deleteOrDismissInBatchPersonDocument(ids, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPersonDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    deleteOrDismissPersonDocument(id, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).deleteOrDismissPersonDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {number} [type]
     * @param {number} [person]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    exportPersonDocument(year, type, person, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).exportPersonDocument(year, type, person, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    getPersonDocument(id, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).getPersonDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    listPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).listPersonDocument(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    pagePersonDocument(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).pagePersonDocument(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocument} personDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    savePersonDocument(personDocument, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).savePersonDocument(personDocument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    viewPersonDocument(docId, options) {
        return (0, exports.PersonDocumentRestControllerApiFp)(this.configuration).viewPersonDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonDocumentRestControllerApi = PersonDocumentRestControllerApi;
/**
 * PersonDocumentTypeRestControllerApi - axios parameter creator
 * @export
 */
const PersonDocumentTypeRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentType: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/type/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentType: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPersonDocumentType', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/document/type/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentType: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPersonDocumentType', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentType: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPersonDocumentType', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentType: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/type/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentType: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/document/type/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonDocumentType} personDocumentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentType: (personDocumentType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personDocumentType' is not null or undefined
            (0, common_1.assertParamExists)('savePersonDocumentType', 'personDocumentType', personDocumentType);
            const localVarPath = `/api/admin/employee/person/document/type/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(personDocumentType, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonDocumentTypeRestControllerApiAxiosParamCreator = PersonDocumentTypeRestControllerApiAxiosParamCreator;
/**
 * PersonDocumentTypeRestControllerApi - functional programming interface
 * @export
 */
const PersonDocumentTypeRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonDocumentTypeRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentType(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPersonDocumentType(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.countPersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentType(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPersonDocumentType(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.deleteOrDismissInBatchPersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentType(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPersonDocumentType(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.deleteOrDismissPersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentType(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonDocumentType(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.getPersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentType(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonDocumentType(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.listPersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentType(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePersonDocumentType(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.pagePersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PersonDocumentType} personDocumentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentType(personDocumentType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePersonDocumentType(personDocumentType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonDocumentTypeRestControllerApi.savePersonDocumentType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PersonDocumentTypeRestControllerApiFp = PersonDocumentTypeRestControllerApiFp;
/**
 * PersonDocumentTypeRestControllerApi - factory interface
 * @export
 */
const PersonDocumentTypeRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonDocumentTypeRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentType(term, showDismissed, options) {
            return localVarFp.countPersonDocumentType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentType(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonDocumentType(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentType(id, options) {
            return localVarFp.deleteOrDismissPersonDocumentType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentType(id, options) {
            return localVarFp.getPersonDocumentType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentType(term, showDismissed, options) {
            return localVarFp.listPersonDocumentType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentType(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePersonDocumentType(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocumentType} personDocumentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentType(personDocumentType, options) {
            return localVarFp.savePersonDocumentType(personDocumentType, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonDocumentTypeRestControllerApiFactory = PersonDocumentTypeRestControllerApiFactory;
/**
 * PersonDocumentTypeRestControllerApi - object-oriented interface
 * @export
 * @class PersonDocumentTypeRestControllerApi
 * @extends {BaseAPI}
 */
class PersonDocumentTypeRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    countPersonDocumentType(term, showDismissed, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).countPersonDocumentType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    deleteOrDismissInBatchPersonDocumentType(ids, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPersonDocumentType(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    deleteOrDismissPersonDocumentType(id, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).deleteOrDismissPersonDocumentType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    getPersonDocumentType(id, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).getPersonDocumentType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    listPersonDocumentType(term, showDismissed, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).listPersonDocumentType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    pagePersonDocumentType(page, size, sort, term, showDismissed, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).pagePersonDocumentType(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocumentType} personDocumentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    savePersonDocumentType(personDocumentType, options) {
        return (0, exports.PersonDocumentTypeRestControllerApiFp)(this.configuration).savePersonDocumentType(personDocumentType, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonDocumentTypeRestControllerApi = PersonDocumentTypeRestControllerApi;
/**
 * PersonEventRestControllerApi - axios parameter creator
 * @export
 */
const PersonEventRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonEvent: (personId, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('countPersonEvent', 'personId', personId);
            const localVarPath = `/api/admin/employee/event/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonEvent: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPersonEvent', 'ids', ids);
            const localVarPath = `/api/admin/employee/event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonEvent: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPersonEvent', 'id', id);
            const localVarPath = `/api/admin/employee/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonEvent: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPersonEvent', 'id', id);
            const localVarPath = `/api/admin/employee/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonEvent: (personId, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('listPersonEvent', 'personId', personId);
            const localVarPath = `/api/admin/employee/event/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonEvent: (personId, page, size, sort, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('pagePersonEvent', 'personId', personId);
            const localVarPath = `/api/admin/employee/event/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonEvent} personEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonEvent: (personEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personEvent' is not null or undefined
            (0, common_1.assertParamExists)('savePersonEvent', 'personEvent', personEvent);
            const localVarPath = `/api/admin/employee/event/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(personEvent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonEventRestControllerApiAxiosParamCreator = PersonEventRestControllerApiAxiosParamCreator;
/**
 * PersonEventRestControllerApi - functional programming interface
 * @export
 */
const PersonEventRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonEventRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPersonEvent(personId, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.countPersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonEvent(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPersonEvent(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.deleteOrDismissInBatchPersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonEvent(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPersonEvent(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.deleteOrDismissPersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonEvent(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonEvent(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.getPersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonEvent(personId, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.listPersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.pagePersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PersonEvent} personEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonEvent(personEvent, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePersonEvent(personEvent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonEventRestControllerApi.savePersonEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PersonEventRestControllerApiFp = PersonEventRestControllerApiFp;
/**
 * PersonEventRestControllerApi - factory interface
 * @export
 */
const PersonEventRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonEventRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonEvent(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonEvent(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonEvent(id, options) {
            return localVarFp.deleteOrDismissPersonEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonEvent(id, options) {
            return localVarFp.getPersonEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonEvent} personEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonEvent(personEvent, options) {
            return localVarFp.savePersonEvent(personEvent, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonEventRestControllerApiFactory = PersonEventRestControllerApiFactory;
/**
 * PersonEventRestControllerApi - object-oriented interface
 * @export
 * @class PersonEventRestControllerApi
 * @extends {BaseAPI}
 */
class PersonEventRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    countPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).countPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    deleteOrDismissInBatchPersonEvent(ids, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPersonEvent(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    deleteOrDismissPersonEvent(id, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).deleteOrDismissPersonEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    getPersonEvent(id, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).getPersonEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    listPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).listPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonEvent} personEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    savePersonEvent(personEvent, options) {
        return (0, exports.PersonEventRestControllerApiFp)(this.configuration).savePersonEvent(personEvent, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonEventRestControllerApi = PersonEventRestControllerApi;
/**
 * PersonReminderRestControllerApi - axios parameter creator
 * @export
 */
const PersonReminderRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonReminder: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/reminder/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonReminder: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPersonReminder', 'ids', ids);
            const localVarPath = `/api/admin/employee/reminder/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonReminder: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPersonReminder', 'id', id);
            const localVarPath = `/api/admin/employee/reminder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonReminder: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPersonReminder', 'id', id);
            const localVarPath = `/api/admin/employee/reminder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonReminder: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/reminder/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonReminder: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/reminder/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonReminder} personReminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonReminder: (personReminder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personReminder' is not null or undefined
            (0, common_1.assertParamExists)('savePersonReminder', 'personReminder', personReminder);
            const localVarPath = `/api/admin/employee/reminder/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(personReminder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonReminderRestControllerApiAxiosParamCreator = PersonReminderRestControllerApiAxiosParamCreator;
/**
 * PersonReminderRestControllerApi - functional programming interface
 * @export
 */
const PersonReminderRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonReminderRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonReminder(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPersonReminder(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.countPersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonReminder(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPersonReminder(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.deleteOrDismissInBatchPersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonReminder(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPersonReminder(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.deleteOrDismissPersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonReminder(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonReminder(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.getPersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonReminder(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonReminder(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.listPersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonReminder(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePersonReminder(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.pagePersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PersonReminder} personReminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonReminder(personReminder, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePersonReminder(personReminder, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonReminderRestControllerApi.savePersonReminder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PersonReminderRestControllerApiFp = PersonReminderRestControllerApiFp;
/**
 * PersonReminderRestControllerApi - factory interface
 * @export
 */
const PersonReminderRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonReminderRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonReminder(term, showDismissed, options) {
            return localVarFp.countPersonReminder(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonReminder(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonReminder(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonReminder(id, options) {
            return localVarFp.deleteOrDismissPersonReminder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonReminder(id, options) {
            return localVarFp.getPersonReminder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonReminder(term, showDismissed, options) {
            return localVarFp.listPersonReminder(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonReminder(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePersonReminder(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonReminder} personReminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonReminder(personReminder, options) {
            return localVarFp.savePersonReminder(personReminder, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonReminderRestControllerApiFactory = PersonReminderRestControllerApiFactory;
/**
 * PersonReminderRestControllerApi - object-oriented interface
 * @export
 * @class PersonReminderRestControllerApi
 * @extends {BaseAPI}
 */
class PersonReminderRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    countPersonReminder(term, showDismissed, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).countPersonReminder(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    deleteOrDismissInBatchPersonReminder(ids, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPersonReminder(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    deleteOrDismissPersonReminder(id, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).deleteOrDismissPersonReminder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    getPersonReminder(id, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).getPersonReminder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    listPersonReminder(term, showDismissed, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).listPersonReminder(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    pagePersonReminder(page, size, sort, term, showDismissed, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).pagePersonReminder(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonReminder} personReminder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    savePersonReminder(personReminder, options) {
        return (0, exports.PersonReminderRestControllerApiFp)(this.configuration).savePersonReminder(personReminder, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonReminderRestControllerApi = PersonReminderRestControllerApi;
/**
 * PersonRestControllerApi - axios parameter creator
 * @export
 */
const PersonRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPerson: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationHelpPerson: (personId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('dedicationHelpPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/{personId}/dedication-help`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPerson: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchPerson', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPerson: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissPerson', 'id', id);
            const localVarPath = `/api/admin/employee/person/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAbsencesPerson: (year, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'year' is not null or undefined
            (0, common_1.assertParamExists)('exportAbsencesPerson', 'year', year);
            const localVarPath = `/api/admin/employee/person/export-absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPeoplePerson: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPerson', 'id', id);
            const localVarPath = `/api/admin/employee/person/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPerson: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePerson: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/person/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Person} person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePerson: (person, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'person' is not null or undefined
            (0, common_1.assertParamExists)('savePerson', 'person', person);
            const localVarPath = `/api/admin/employee/person/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(person, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryPerson: (personId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('summaryPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/{personId}/summary`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPhotoPerson: (personId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('viewPhotoPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/photo/{personId}`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonRestControllerApiAxiosParamCreator = PersonRestControllerApiAxiosParamCreator;
/**
 * PersonRestControllerApi - functional programming interface
 * @export
 */
const PersonRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPerson(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countPerson(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.countPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationHelpPerson(personId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dedicationHelpPerson(personId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.dedicationHelpPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPerson(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchPerson(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.deleteOrDismissInBatchPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPerson(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissPerson(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.deleteOrDismissPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAbsencesPerson(year, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportAbsencesPerson(year, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.exportAbsencesPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPeoplePerson(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportPeoplePerson(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.exportPeoplePerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPerson(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.getPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPerson(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPerson(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.listPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePerson(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pagePerson(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.pagePerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Person} person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePerson(person, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePerson(person, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.savePerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryPerson(personId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.summaryPerson(personId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.summaryPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPhotoPerson(personId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewPhotoPerson(personId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PersonRestControllerApi.viewPhotoPerson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PersonRestControllerApiFp = PersonRestControllerApiFp;
/**
 * PersonRestControllerApi - factory interface
 * @export
 */
const PersonRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPerson(term, showDismissed, options) {
            return localVarFp.countPerson(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationHelpPerson(personId, options) {
            return localVarFp.dedicationHelpPerson(personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPerson(ids, options) {
            return localVarFp.deleteOrDismissInBatchPerson(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPerson(id, options) {
            return localVarFp.deleteOrDismissPerson(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAbsencesPerson(year, options) {
            return localVarFp.exportAbsencesPerson(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPeoplePerson(options) {
            return localVarFp.exportPeoplePerson(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson(id, options) {
            return localVarFp.getPerson(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPerson(term, showDismissed, options) {
            return localVarFp.listPerson(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePerson(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePerson(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Person} person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePerson(person, options) {
            return localVarFp.savePerson(person, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryPerson(personId, options) {
            return localVarFp.summaryPerson(personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPhotoPerson(personId, options) {
            return localVarFp.viewPhotoPerson(personId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonRestControllerApiFactory = PersonRestControllerApiFactory;
/**
 * PersonRestControllerApi - object-oriented interface
 * @export
 * @class PersonRestControllerApi
 * @extends {BaseAPI}
 */
class PersonRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    countPerson(term, showDismissed, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).countPerson(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    dedicationHelpPerson(personId, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).dedicationHelpPerson(personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    deleteOrDismissInBatchPerson(ids, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).deleteOrDismissInBatchPerson(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    deleteOrDismissPerson(id, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).deleteOrDismissPerson(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    exportAbsencesPerson(year, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).exportAbsencesPerson(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    exportPeoplePerson(options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).exportPeoplePerson(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    getPerson(id, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).getPerson(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    listPerson(term, showDismissed, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).listPerson(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    pagePerson(page, size, sort, term, showDismissed, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).pagePerson(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Person} person
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    savePerson(person, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).savePerson(person, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    summaryPerson(personId, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).summaryPerson(personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    viewPhotoPerson(personId, options) {
        return (0, exports.PersonRestControllerApiFp)(this.configuration).viewPhotoPerson(personId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonRestControllerApi = PersonRestControllerApi;
/**
 * PubCustomerSupportRestControllerApi - axios parameter creator
 * @export
 */
const PubCustomerSupportRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} rid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupport: (rid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rid' is not null or undefined
            (0, common_1.assertParamExists)('getEmployeeSupport', 'rid', rid);
            const localVarPath = `/api/pub/customer/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (rid !== undefined) {
                localVarQueryParameter['rid'] = rid;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} rid
         * @param {CustomerEvaluationResult} customerEvaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeSupport: (rid, customerEvaluationResult, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rid' is not null or undefined
            (0, common_1.assertParamExists)('saveEmployeeSupport', 'rid', rid);
            // verify required parameter 'customerEvaluationResult' is not null or undefined
            (0, common_1.assertParamExists)('saveEmployeeSupport', 'customerEvaluationResult', customerEvaluationResult);
            const localVarPath = `/api/pub/customer/support/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (rid !== undefined) {
                localVarQueryParameter['rid'] = rid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerEvaluationResult, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PubCustomerSupportRestControllerApiAxiosParamCreator = PubCustomerSupportRestControllerApiAxiosParamCreator;
/**
 * PubCustomerSupportRestControllerApi - functional programming interface
 * @export
 */
const PubCustomerSupportRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PubCustomerSupportRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} rid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupport(rid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmployeeSupport(rid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PubCustomerSupportRestControllerApi.getEmployeeSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} rid
         * @param {CustomerEvaluationResult} customerEvaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeSupport(rid, customerEvaluationResult, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveEmployeeSupport(rid, customerEvaluationResult, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PubCustomerSupportRestControllerApi.saveEmployeeSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PubCustomerSupportRestControllerApiFp = PubCustomerSupportRestControllerApiFp;
/**
 * PubCustomerSupportRestControllerApi - factory interface
 * @export
 */
const PubCustomerSupportRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PubCustomerSupportRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} rid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupport(rid, options) {
            return localVarFp.getEmployeeSupport(rid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} rid
         * @param {CustomerEvaluationResult} customerEvaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeSupport(rid, customerEvaluationResult, options) {
            return localVarFp.saveEmployeeSupport(rid, customerEvaluationResult, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PubCustomerSupportRestControllerApiFactory = PubCustomerSupportRestControllerApiFactory;
/**
 * PubCustomerSupportRestControllerApi - object-oriented interface
 * @export
 * @class PubCustomerSupportRestControllerApi
 * @extends {BaseAPI}
 */
class PubCustomerSupportRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} rid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PubCustomerSupportRestControllerApi
     */
    getEmployeeSupport(rid, options) {
        return (0, exports.PubCustomerSupportRestControllerApiFp)(this.configuration).getEmployeeSupport(rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} rid
     * @param {CustomerEvaluationResult} customerEvaluationResult
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PubCustomerSupportRestControllerApi
     */
    saveEmployeeSupport(rid, customerEvaluationResult, options) {
        return (0, exports.PubCustomerSupportRestControllerApiFp)(this.configuration).saveEmployeeSupport(rid, customerEvaluationResult, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PubCustomerSupportRestControllerApi = PubCustomerSupportRestControllerApi;
/**
 * PublicContactRestControllerApi - axios parameter creator
 * @export
 */
const PublicContactRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApolloContact} apolloContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apolloImport: (apolloContact, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apolloContact' is not null or undefined
            (0, common_1.assertParamExists)('apolloImport', 'apolloContact', apolloContact);
            const localVarPath = `/api/pub/contact/apollo-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(apolloContact, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TrackerLink} trackerLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLink: (trackerLink, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'trackerLink' is not null or undefined
            (0, common_1.assertParamExists)('createLink', 'trackerLink', trackerLink);
            const localVarPath = `/api/pub/contact/create-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trackerLink, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactEmail: (contactForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contactForm' is not null or undefined
            (0, common_1.assertParamExists)('sendContactEmail', 'contactForm', contactForm);
            const localVarPath = `/api/pub/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactForm, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubscribeForm} subscribeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: (subscribeForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscribeForm' is not null or undefined
            (0, common_1.assertParamExists)('subscribe', 'subscribeForm', subscribeForm);
            const localVarPath = `/api/pub/contact/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subscribeForm, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PublicContactRestControllerApiAxiosParamCreator = PublicContactRestControllerApiAxiosParamCreator;
/**
 * PublicContactRestControllerApi - functional programming interface
 * @export
 */
const PublicContactRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PublicContactRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ApolloContact} apolloContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apolloImport(apolloContact, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apolloImport(apolloContact, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PublicContactRestControllerApi.apolloImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {TrackerLink} trackerLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLink(trackerLink, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createLink(trackerLink, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PublicContactRestControllerApi.createLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactEmail(contactForm, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendContactEmail(contactForm, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PublicContactRestControllerApi.sendContactEmail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SubscribeForm} subscribeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(subscribeForm, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.subscribe(subscribeForm, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PublicContactRestControllerApi.subscribe']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PublicContactRestControllerApiFp = PublicContactRestControllerApiFp;
/**
 * PublicContactRestControllerApi - factory interface
 * @export
 */
const PublicContactRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PublicContactRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {ApolloContact} apolloContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apolloImport(apolloContact, options) {
            return localVarFp.apolloImport(apolloContact, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TrackerLink} trackerLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLink(trackerLink, options) {
            return localVarFp.createLink(trackerLink, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactEmail(contactForm, options) {
            return localVarFp.sendContactEmail(contactForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubscribeForm} subscribeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(subscribeForm, options) {
            return localVarFp.subscribe(subscribeForm, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PublicContactRestControllerApiFactory = PublicContactRestControllerApiFactory;
/**
 * PublicContactRestControllerApi - object-oriented interface
 * @export
 * @class PublicContactRestControllerApi
 * @extends {BaseAPI}
 */
class PublicContactRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApolloContact} apolloContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicContactRestControllerApi
     */
    apolloImport(apolloContact, options) {
        return (0, exports.PublicContactRestControllerApiFp)(this.configuration).apolloImport(apolloContact, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TrackerLink} trackerLink
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicContactRestControllerApi
     */
    createLink(trackerLink, options) {
        return (0, exports.PublicContactRestControllerApiFp)(this.configuration).createLink(trackerLink, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContactForm} contactForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicContactRestControllerApi
     */
    sendContactEmail(contactForm, options) {
        return (0, exports.PublicContactRestControllerApiFp)(this.configuration).sendContactEmail(contactForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SubscribeForm} subscribeForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicContactRestControllerApi
     */
    subscribe(subscribeForm, options) {
        return (0, exports.PublicContactRestControllerApiFp)(this.configuration).subscribe(subscribeForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PublicContactRestControllerApi = PublicContactRestControllerApi;
/**
 * RecruitmentDocumentRestControllerApi - axios parameter creator
 * @export
 */
const RecruitmentDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitmentDocument: (recruitmentId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recruitmentId' is not null or undefined
            (0, common_1.assertParamExists)('countRecruitmentDocument', 'recruitmentId', recruitmentId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitmentDocument: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchRecruitmentDocument', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/recruitment/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitmentDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissRecruitmentDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDocument: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRecruitmentDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitmentDocument: (recruitmentId, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recruitmentId' is not null or undefined
            (0, common_1.assertParamExists)('listRecruitmentDocument', 'recruitmentId', recruitmentId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} recruitmentId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitmentDocument: (recruitmentId, page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recruitmentId' is not null or undefined
            (0, common_1.assertParamExists)('pageRecruitmentDocument', 'recruitmentId', recruitmentId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RecruitmentDocument} recruitmentDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitmentDocument: (recruitmentDocument, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recruitmentDocument' is not null or undefined
            (0, common_1.assertParamExists)('saveRecruitmentDocument', 'recruitmentDocument', recruitmentDocument);
            const localVarPath = `/api/admin/recruitment/recruitment/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recruitmentDocument, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecruitmentDocumentRecruitmentDocument: (docId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'docId' is not null or undefined
            (0, common_1.assertParamExists)('viewRecruitmentDocumentRecruitmentDocument', 'docId', docId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/view/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RecruitmentDocumentRestControllerApiAxiosParamCreator = RecruitmentDocumentRestControllerApiAxiosParamCreator;
/**
 * RecruitmentDocumentRestControllerApi - functional programming interface
 * @export
 */
const RecruitmentDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RecruitmentDocumentRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countRecruitmentDocument(recruitmentId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.countRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitmentDocument(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchRecruitmentDocument(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.deleteOrDismissInBatchRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitmentDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissRecruitmentDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.deleteOrDismissRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDocument(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecruitmentDocument(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.getRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRecruitmentDocument(recruitmentId, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.listRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.pageRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {RecruitmentDocument} recruitmentDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitmentDocument(recruitmentDocument, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveRecruitmentDocument(recruitmentDocument, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.saveRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecruitmentDocumentRecruitmentDocument(docId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.viewRecruitmentDocumentRecruitmentDocument(docId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentDocumentRestControllerApi.viewRecruitmentDocumentRecruitmentDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.RecruitmentDocumentRestControllerApiFp = RecruitmentDocumentRestControllerApiFp;
/**
 * RecruitmentDocumentRestControllerApi - factory interface
 * @export
 */
const RecruitmentDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RecruitmentDocumentRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            return localVarFp.countRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitmentDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchRecruitmentDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitmentDocument(id, options) {
            return localVarFp.deleteOrDismissRecruitmentDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDocument(id, options) {
            return localVarFp.getRecruitmentDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            return localVarFp.listRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RecruitmentDocument} recruitmentDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitmentDocument(recruitmentDocument, options) {
            return localVarFp.saveRecruitmentDocument(recruitmentDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecruitmentDocumentRecruitmentDocument(docId, options) {
            return localVarFp.viewRecruitmentDocumentRecruitmentDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RecruitmentDocumentRestControllerApiFactory = RecruitmentDocumentRestControllerApiFactory;
/**
 * RecruitmentDocumentRestControllerApi - object-oriented interface
 * @export
 * @class RecruitmentDocumentRestControllerApi
 * @extends {BaseAPI}
 */
class RecruitmentDocumentRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} recruitmentId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    countRecruitmentDocument(recruitmentId, term, showDismissed, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).countRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    deleteOrDismissInBatchRecruitmentDocument(ids, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).deleteOrDismissInBatchRecruitmentDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    deleteOrDismissRecruitmentDocument(id, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).deleteOrDismissRecruitmentDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    getRecruitmentDocument(id, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).getRecruitmentDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} recruitmentId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    listRecruitmentDocument(recruitmentId, term, showDismissed, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).listRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} recruitmentId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RecruitmentDocument} recruitmentDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    saveRecruitmentDocument(recruitmentDocument, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).saveRecruitmentDocument(recruitmentDocument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    viewRecruitmentDocumentRecruitmentDocument(docId, options) {
        return (0, exports.RecruitmentDocumentRestControllerApiFp)(this.configuration).viewRecruitmentDocumentRecruitmentDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RecruitmentDocumentRestControllerApi = RecruitmentDocumentRestControllerApi;
/**
 * RecruitmentRestControllerApi - axios parameter creator
 * @export
 */
const RecruitmentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApplicantRecruitment: (recruitmentId, applicant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recruitmentId' is not null or undefined
            (0, common_1.assertParamExists)('addApplicantRecruitment', 'recruitmentId', recruitmentId);
            // verify required parameter 'applicant' is not null or undefined
            (0, common_1.assertParamExists)('addApplicantRecruitment', 'applicant', applicant);
            const localVarPath = `/api/admin/recruitment/recruitment/append`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applicant, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitment: (active, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/recruitment/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitment: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchRecruitment', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/recruitment/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitment: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissRecruitment', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitment: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRecruitment', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitment: (active, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/recruitment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitment: (page, size, sort, active, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/recruitment/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Recruitment} recruitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitment: (recruitment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recruitment' is not null or undefined
            (0, common_1.assertParamExists)('saveRecruitment', 'recruitment', recruitment);
            const localVarPath = `/api/admin/recruitment/recruitment/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recruitment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStateRecruitment: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/recruitment/startState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RecruitmentRestControllerApiAxiosParamCreator = RecruitmentRestControllerApiAxiosParamCreator;
/**
 * RecruitmentRestControllerApi - functional programming interface
 * @export
 */
const RecruitmentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RecruitmentRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApplicantRecruitment(recruitmentId, applicant, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addApplicantRecruitment(recruitmentId, applicant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.addApplicantRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitment(active, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countRecruitment(active, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.countRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitment(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchRecruitment(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.deleteOrDismissInBatchRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitment(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissRecruitment(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.deleteOrDismissRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitment(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecruitment(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.getRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitment(active, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRecruitment(active, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.listRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitment(page, size, sort, active, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageRecruitment(page, size, sort, active, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.pageRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Recruitment} recruitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitment(recruitment, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveRecruitment(recruitment, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.saveRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStateRecruitment(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startStateRecruitment(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentRestControllerApi.startStateRecruitment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.RecruitmentRestControllerApiFp = RecruitmentRestControllerApiFp;
/**
 * RecruitmentRestControllerApi - factory interface
 * @export
 */
const RecruitmentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RecruitmentRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApplicantRecruitment(recruitmentId, applicant, options) {
            return localVarFp.addApplicantRecruitment(recruitmentId, applicant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitment(active, term, showDismissed, options) {
            return localVarFp.countRecruitment(active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitment(ids, options) {
            return localVarFp.deleteOrDismissInBatchRecruitment(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitment(id, options) {
            return localVarFp.deleteOrDismissRecruitment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitment(id, options) {
            return localVarFp.getRecruitment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitment(active, term, showDismissed, options) {
            return localVarFp.listRecruitment(active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitment(page, size, sort, active, term, showDismissed, options) {
            return localVarFp.pageRecruitment(page, size, sort, active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Recruitment} recruitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitment(recruitment, options) {
            return localVarFp.saveRecruitment(recruitment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStateRecruitment(options) {
            return localVarFp.startStateRecruitment(options).then((request) => request(axios, basePath));
        },
    };
};
exports.RecruitmentRestControllerApiFactory = RecruitmentRestControllerApiFactory;
/**
 * RecruitmentRestControllerApi - object-oriented interface
 * @export
 * @class RecruitmentRestControllerApi
 * @extends {BaseAPI}
 */
class RecruitmentRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} recruitmentId
     * @param {Applicant} applicant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    addApplicantRecruitment(recruitmentId, applicant, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).addApplicantRecruitment(recruitmentId, applicant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    countRecruitment(active, term, showDismissed, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).countRecruitment(active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    deleteOrDismissInBatchRecruitment(ids, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).deleteOrDismissInBatchRecruitment(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    deleteOrDismissRecruitment(id, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).deleteOrDismissRecruitment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    getRecruitment(id, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).getRecruitment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    listRecruitment(active, term, showDismissed, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).listRecruitment(active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    pageRecruitment(page, size, sort, active, term, showDismissed, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).pageRecruitment(page, size, sort, active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Recruitment} recruitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    saveRecruitment(recruitment, options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).saveRecruitment(recruitment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    startStateRecruitment(options) {
        return (0, exports.RecruitmentRestControllerApiFp)(this.configuration).startStateRecruitment(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RecruitmentRestControllerApi = RecruitmentRestControllerApi;
/**
 * RecruitmentStatsRestControllerApi - axios parameter creator
 * @export
 */
const RecruitmentStatsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RecruitmentStatsRestControllerApiAxiosParamCreator = RecruitmentStatsRestControllerApiAxiosParamCreator;
/**
 * RecruitmentStatsRestControllerApi - functional programming interface
 * @export
 */
const RecruitmentStatsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RecruitmentStatsRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecruitmentStats(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecruitmentStatsRestControllerApi.getRecruitmentStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.RecruitmentStatsRestControllerApiFp = RecruitmentStatsRestControllerApiFp;
/**
 * RecruitmentStatsRestControllerApi - factory interface
 * @export
 */
const RecruitmentStatsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RecruitmentStatsRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats(options) {
            return localVarFp.getRecruitmentStats(options).then((request) => request(axios, basePath));
        },
    };
};
exports.RecruitmentStatsRestControllerApiFactory = RecruitmentStatsRestControllerApiFactory;
/**
 * RecruitmentStatsRestControllerApi - object-oriented interface
 * @export
 * @class RecruitmentStatsRestControllerApi
 * @extends {BaseAPI}
 */
class RecruitmentStatsRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentStatsRestControllerApi
     */
    getRecruitmentStats(options) {
        return (0, exports.RecruitmentStatsRestControllerApiFp)(this.configuration).getRecruitmentStats(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RecruitmentStatsRestControllerApi = RecruitmentStatsRestControllerApi;
/**
 * RedmineMappingRestControllerApi - axios parameter creator
 * @export
 */
const RedmineMappingRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRedmineMapping: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/mapping/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRedmineMapping: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchRedmineMapping', 'ids', ids);
            const localVarPath = `/api/admin/billing/mapping/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRedmineMapping: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissRedmineMapping', 'id', id);
            const localVarPath = `/api/admin/billing/mapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineMapping: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRedmineMapping', 'id', id);
            const localVarPath = `/api/admin/billing/mapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRedmineMapping: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/mapping/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRedmineMapping: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/billing/mapping/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RedmineMapping} redmineMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRedmineMapping: (redmineMapping, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'redmineMapping' is not null or undefined
            (0, common_1.assertParamExists)('saveRedmineMapping', 'redmineMapping', redmineMapping);
            const localVarPath = `/api/admin/billing/mapping/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(redmineMapping, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RedmineMappingRestControllerApiAxiosParamCreator = RedmineMappingRestControllerApiAxiosParamCreator;
/**
 * RedmineMappingRestControllerApi - functional programming interface
 * @export
 */
const RedmineMappingRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RedmineMappingRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRedmineMapping(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countRedmineMapping(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.countRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRedmineMapping(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchRedmineMapping(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.deleteOrDismissInBatchRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRedmineMapping(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissRedmineMapping(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.deleteOrDismissRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineMapping(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRedmineMapping(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.getRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRedmineMapping(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRedmineMapping(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.listRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRedmineMapping(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageRedmineMapping(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.pageRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {RedmineMapping} redmineMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRedmineMapping(redmineMapping, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveRedmineMapping(redmineMapping, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RedmineMappingRestControllerApi.saveRedmineMapping']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.RedmineMappingRestControllerApiFp = RedmineMappingRestControllerApiFp;
/**
 * RedmineMappingRestControllerApi - factory interface
 * @export
 */
const RedmineMappingRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RedmineMappingRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRedmineMapping(term, showDismissed, options) {
            return localVarFp.countRedmineMapping(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRedmineMapping(ids, options) {
            return localVarFp.deleteOrDismissInBatchRedmineMapping(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRedmineMapping(id, options) {
            return localVarFp.deleteOrDismissRedmineMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineMapping(id, options) {
            return localVarFp.getRedmineMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRedmineMapping(term, showDismissed, options) {
            return localVarFp.listRedmineMapping(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRedmineMapping(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageRedmineMapping(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RedmineMapping} redmineMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRedmineMapping(redmineMapping, options) {
            return localVarFp.saveRedmineMapping(redmineMapping, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RedmineMappingRestControllerApiFactory = RedmineMappingRestControllerApiFactory;
/**
 * RedmineMappingRestControllerApi - object-oriented interface
 * @export
 * @class RedmineMappingRestControllerApi
 * @extends {BaseAPI}
 */
class RedmineMappingRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    countRedmineMapping(term, showDismissed, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).countRedmineMapping(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    deleteOrDismissInBatchRedmineMapping(ids, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).deleteOrDismissInBatchRedmineMapping(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    deleteOrDismissRedmineMapping(id, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).deleteOrDismissRedmineMapping(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    getRedmineMapping(id, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).getRedmineMapping(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    listRedmineMapping(term, showDismissed, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).listRedmineMapping(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    pageRedmineMapping(page, size, sort, term, showDismissed, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).pageRedmineMapping(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RedmineMapping} redmineMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedmineMappingRestControllerApi
     */
    saveRedmineMapping(redmineMapping, options) {
        return (0, exports.RedmineMappingRestControllerApiFp)(this.configuration).saveRedmineMapping(redmineMapping, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RedmineMappingRestControllerApi = RedmineMappingRestControllerApi;
/**
 * SalaryRestControllerApi - axios parameter creator
 * @export
 */
const SalaryRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSalary: (personId, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('countSalary', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/salaries/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSalary: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSalary', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/salaries/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSalary: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSalary', 'id', id);
            const localVarPath = `/api/admin/employee/person/salaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} salaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalary: (salaryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'salaryId' is not null or undefined
            (0, common_1.assertParamExists)('duplicateSalary', 'salaryId', salaryId);
            const localVarPath = `/api/admin/employee/person/salaries/duplicate/{salaryId}`
                .replace(`{${"salaryId"}}`, encodeURIComponent(String(salaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalary: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSalary', 'id', id);
            const localVarPath = `/api/admin/employee/person/salaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalary: (personId, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('listSalary', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/salaries/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSalary: (personId, page, size, sort, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personId' is not null or undefined
            (0, common_1.assertParamExists)('pageSalary', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/salaries/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Salary} salary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSalary: (salary, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'salary' is not null or undefined
            (0, common_1.assertParamExists)('saveSalary', 'salary', salary);
            const localVarPath = `/api/admin/employee/person/salaries/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(salary, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SalaryRestControllerApiAxiosParamCreator = SalaryRestControllerApiAxiosParamCreator;
/**
 * SalaryRestControllerApi - functional programming interface
 * @export
 */
const SalaryRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SalaryRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSalary(personId, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSalary(personId, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.countSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSalary(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSalary(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.deleteOrDismissInBatchSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSalary(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSalary(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.deleteOrDismissSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} salaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalary(salaryId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.duplicateSalary(salaryId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.duplicateSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalary(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSalary(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.getSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalary(personId, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSalary(personId, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.listSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.pageSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Salary} salary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSalary(salary, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSalary(salary, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SalaryRestControllerApi.saveSalary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SalaryRestControllerApiFp = SalaryRestControllerApiFp;
/**
 * SalaryRestControllerApi - factory interface
 * @export
 */
const SalaryRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SalaryRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSalary(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSalary(ids, options) {
            return localVarFp.deleteOrDismissInBatchSalary(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSalary(id, options) {
            return localVarFp.deleteOrDismissSalary(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} salaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalary(salaryId, options) {
            return localVarFp.duplicateSalary(salaryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalary(id, options) {
            return localVarFp.getSalary(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalary(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Salary} salary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSalary(salary, options) {
            return localVarFp.saveSalary(salary, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SalaryRestControllerApiFactory = SalaryRestControllerApiFactory;
/**
 * SalaryRestControllerApi - object-oriented interface
 * @export
 * @class SalaryRestControllerApi
 * @extends {BaseAPI}
 */
class SalaryRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    countSalary(personId, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).countSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    deleteOrDismissInBatchSalary(ids, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSalary(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    deleteOrDismissSalary(id, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).deleteOrDismissSalary(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} salaryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    duplicateSalary(salaryId, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).duplicateSalary(salaryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    getSalary(id, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).getSalary(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    listSalary(personId, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).listSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Salary} salary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    saveSalary(salary, options) {
        return (0, exports.SalaryRestControllerApiFp)(this.configuration).saveSalary(salary, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SalaryRestControllerApi = SalaryRestControllerApi;
/**
 * SkillLevelRestControllerApi - axios parameter creator
 * @export
 */
const SkillLevelRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkillLevel: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/skilllevel/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkillLevel: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSkillLevel', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/skilllevel/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkillLevel: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSkillLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/skilllevel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSkillLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/skilllevel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevel: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/skilllevel/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkillLevel: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/skilllevel/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SkillLevel} skillLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillLevel: (skillLevel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'skillLevel' is not null or undefined
            (0, common_1.assertParamExists)('saveSkillLevel', 'skillLevel', skillLevel);
            const localVarPath = `/api/admin/recruitment/skilllevel/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(skillLevel, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SkillLevelRestControllerApiAxiosParamCreator = SkillLevelRestControllerApiAxiosParamCreator;
/**
 * SkillLevelRestControllerApi - functional programming interface
 * @export
 */
const SkillLevelRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SkillLevelRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkillLevel(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSkillLevel(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.countSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkillLevel(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSkillLevel(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.deleteOrDismissInBatchSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkillLevel(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSkillLevel(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.deleteOrDismissSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSkillLevel(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.getSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevel(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSkillLevel(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.listSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkillLevel(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSkillLevel(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.pageSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SkillLevel} skillLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillLevel(skillLevel, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSkillLevel(skillLevel, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillLevelRestControllerApi.saveSkillLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SkillLevelRestControllerApiFp = SkillLevelRestControllerApiFp;
/**
 * SkillLevelRestControllerApi - factory interface
 * @export
 */
const SkillLevelRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SkillLevelRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkillLevel(term, showDismissed, options) {
            return localVarFp.countSkillLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkillLevel(ids, options) {
            return localVarFp.deleteOrDismissInBatchSkillLevel(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkillLevel(id, options) {
            return localVarFp.deleteOrDismissSkillLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel(id, options) {
            return localVarFp.getSkillLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevel(term, showDismissed, options) {
            return localVarFp.listSkillLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkillLevel(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSkillLevel(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SkillLevel} skillLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillLevel(skillLevel, options) {
            return localVarFp.saveSkillLevel(skillLevel, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SkillLevelRestControllerApiFactory = SkillLevelRestControllerApiFactory;
/**
 * SkillLevelRestControllerApi - object-oriented interface
 * @export
 * @class SkillLevelRestControllerApi
 * @extends {BaseAPI}
 */
class SkillLevelRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    countSkillLevel(term, showDismissed, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).countSkillLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    deleteOrDismissInBatchSkillLevel(ids, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSkillLevel(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    deleteOrDismissSkillLevel(id, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).deleteOrDismissSkillLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    getSkillLevel(id, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).getSkillLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    listSkillLevel(term, showDismissed, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).listSkillLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    pageSkillLevel(page, size, sort, term, showDismissed, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).pageSkillLevel(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SkillLevel} skillLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    saveSkillLevel(skillLevel, options) {
        return (0, exports.SkillLevelRestControllerApiFp)(this.configuration).saveSkillLevel(skillLevel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SkillLevelRestControllerApi = SkillLevelRestControllerApi;
/**
 * SkillRestControllerApi - axios parameter creator
 * @export
 */
const SkillRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkill: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/skill/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkill: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSkill', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/skill/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkill: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSkill', 'id', id);
            const localVarPath = `/api/admin/recruitment/skill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSkill', 'id', id);
            const localVarPath = `/api/admin/recruitment/skill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkill: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/skill/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkill: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/skill/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Skill} skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill: (skill, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'skill' is not null or undefined
            (0, common_1.assertParamExists)('saveSkill', 'skill', skill);
            const localVarPath = `/api/admin/recruitment/skill/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(skill, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SkillRestControllerApiAxiosParamCreator = SkillRestControllerApiAxiosParamCreator;
/**
 * SkillRestControllerApi - functional programming interface
 * @export
 */
const SkillRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SkillRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkill(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSkill(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.countSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkill(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSkill(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.deleteOrDismissInBatchSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkill(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSkill(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.deleteOrDismissSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSkill(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.getSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkill(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSkill(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.listSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkill(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSkill(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.pageSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Skill} skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill(skill, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSkill(skill, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SkillRestControllerApi.saveSkill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SkillRestControllerApiFp = SkillRestControllerApiFp;
/**
 * SkillRestControllerApi - factory interface
 * @export
 */
const SkillRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SkillRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkill(term, showDismissed, options) {
            return localVarFp.countSkill(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkill(ids, options) {
            return localVarFp.deleteOrDismissInBatchSkill(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkill(id, options) {
            return localVarFp.deleteOrDismissSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill(id, options) {
            return localVarFp.getSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkill(term, showDismissed, options) {
            return localVarFp.listSkill(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkill(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSkill(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Skill} skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill(skill, options) {
            return localVarFp.saveSkill(skill, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SkillRestControllerApiFactory = SkillRestControllerApiFactory;
/**
 * SkillRestControllerApi - object-oriented interface
 * @export
 * @class SkillRestControllerApi
 * @extends {BaseAPI}
 */
class SkillRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    countSkill(term, showDismissed, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).countSkill(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    deleteOrDismissInBatchSkill(ids, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSkill(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    deleteOrDismissSkill(id, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).deleteOrDismissSkill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    getSkill(id, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).getSkill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    listSkill(term, showDismissed, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).listSkill(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    pageSkill(page, size, sort, term, showDismissed, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).pageSkill(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Skill} skill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    saveSkill(skill, options) {
        return (0, exports.SkillRestControllerApiFp)(this.configuration).saveSkill(skill, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SkillRestControllerApi = SkillRestControllerApi;
/**
 * SuperParamRestControllerApi - axios parameter creator
 * @export
 */
const SuperParamRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countParameter: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/super/param/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchParameter: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchParameter', 'ids', ids);
            const localVarPath = `/api/super/param/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissParameter: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissParameter', 'id', id);
            const localVarPath = `/api/super/param/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getParameter', 'id', id);
            const localVarPath = `/api/super/param/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameter: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/super/param/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageParameter: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/super/param/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveParameter: (parameter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'parameter' is not null or undefined
            (0, common_1.assertParamExists)('saveParameter', 'parameter', parameter);
            const localVarPath = `/api/super/param/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(parameter, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SuperParamRestControllerApiAxiosParamCreator = SuperParamRestControllerApiAxiosParamCreator;
/**
 * SuperParamRestControllerApi - functional programming interface
 * @export
 */
const SuperParamRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SuperParamRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countParameter(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countParameter(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.countParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchParameter(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchParameter(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.deleteOrDismissInBatchParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissParameter(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissParameter(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.deleteOrDismissParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getParameter(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.getParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameter(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listParameter(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.listParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageParameter(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageParameter(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.pageParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveParameter(parameter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveParameter(parameter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperParamRestControllerApi.saveParameter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SuperParamRestControllerApiFp = SuperParamRestControllerApiFp;
/**
 * SuperParamRestControllerApi - factory interface
 * @export
 */
const SuperParamRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SuperParamRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countParameter(term, showDismissed, options) {
            return localVarFp.countParameter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchParameter(ids, options) {
            return localVarFp.deleteOrDismissInBatchParameter(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissParameter(id, options) {
            return localVarFp.deleteOrDismissParameter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter(id, options) {
            return localVarFp.getParameter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameter(term, showDismissed, options) {
            return localVarFp.listParameter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageParameter(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageParameter(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveParameter(parameter, options) {
            return localVarFp.saveParameter(parameter, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SuperParamRestControllerApiFactory = SuperParamRestControllerApiFactory;
/**
 * SuperParamRestControllerApi - object-oriented interface
 * @export
 * @class SuperParamRestControllerApi
 * @extends {BaseAPI}
 */
class SuperParamRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    countParameter(term, showDismissed, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).countParameter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    deleteOrDismissInBatchParameter(ids, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).deleteOrDismissInBatchParameter(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    deleteOrDismissParameter(id, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).deleteOrDismissParameter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    getParameter(id, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).getParameter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    listParameter(term, showDismissed, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).listParameter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    pageParameter(page, size, sort, term, showDismissed, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).pageParameter(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Parameter} parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperParamRestControllerApi
     */
    saveParameter(parameter, options) {
        return (0, exports.SuperParamRestControllerApiFp)(this.configuration).saveParameter(parameter, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SuperParamRestControllerApi = SuperParamRestControllerApi;
/**
 * SuperUserRestControllerApi - axios parameter creator
 * @export
 */
const SuperUserRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/super/user/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchUser: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchUser', 'ids', ids);
            const localVarPath = `/api/super/user/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissUser: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissUser', 'id', id);
            const localVarPath = `/api/super/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionUser: (permissionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'permissionId' is not null or undefined
            (0, common_1.assertParamExists)('deletePermissionUser', 'permissionId', permissionId);
            const localVarPath = `/api/super/user/permission/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (permissionId !== undefined) {
                localVarQueryParameter['permissionId'] = permissionId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getUser', 'id', id);
            const localVarPath = `/api/super/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUser: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/super/user/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUser: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/super/user/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser: (user, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'user' is not null or undefined
            (0, common_1.assertParamExists)('saveUser', 'user', user);
            const localVarPath = `/api/super/user/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SuperUserRestControllerApiAxiosParamCreator = SuperUserRestControllerApiAxiosParamCreator;
/**
 * SuperUserRestControllerApi - functional programming interface
 * @export
 */
const SuperUserRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SuperUserRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countUser(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.countUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchUser(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchUser(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.deleteOrDismissInBatchUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissUser(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissUser(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.deleteOrDismissUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionUser(permissionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePermissionUser(permissionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.deletePermissionUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUser(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.getUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUser(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUser(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.listUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUser(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageUser(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.pageUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser(user, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveUser(user, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperUserRestControllerApi.saveUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SuperUserRestControllerApiFp = SuperUserRestControllerApiFp;
/**
 * SuperUserRestControllerApi - factory interface
 * @export
 */
const SuperUserRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SuperUserRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser(term, showDismissed, options) {
            return localVarFp.countUser(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchUser(ids, options) {
            return localVarFp.deleteOrDismissInBatchUser(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissUser(id, options) {
            return localVarFp.deleteOrDismissUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionUser(permissionId, options) {
            return localVarFp.deletePermissionUser(permissionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, options) {
            return localVarFp.getUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUser(term, showDismissed, options) {
            return localVarFp.listUser(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUser(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageUser(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser(user, options) {
            return localVarFp.saveUser(user, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SuperUserRestControllerApiFactory = SuperUserRestControllerApiFactory;
/**
 * SuperUserRestControllerApi - object-oriented interface
 * @export
 * @class SuperUserRestControllerApi
 * @extends {BaseAPI}
 */
class SuperUserRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    countUser(term, showDismissed, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).countUser(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    deleteOrDismissInBatchUser(ids, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).deleteOrDismissInBatchUser(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    deleteOrDismissUser(id, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).deleteOrDismissUser(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} permissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    deletePermissionUser(permissionId, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).deletePermissionUser(permissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    getUser(id, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).getUser(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    listUser(term, showDismissed, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).listUser(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    pageUser(page, size, sort, term, showDismissed, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).pageUser(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperUserRestControllerApi
     */
    saveUser(user, options) {
        return (0, exports.SuperUserRestControllerApiFp)(this.configuration).saveUser(user, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SuperUserRestControllerApi = SuperUserRestControllerApi;
/**
 * SupportGroupRestControllerApi - axios parameter creator
 * @export
 */
const SupportGroupRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportGroup: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support-group/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportGroup: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSupportGroup', 'ids', ids);
            const localVarPath = `/api/admin/employee/support-group/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportGroup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSupportGroup', 'id', id);
            const localVarPath = `/api/admin/employee/support-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportGroup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSupportGroup', 'id', id);
            const localVarPath = `/api/admin/employee/support-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportGroup: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support-group/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportGroup: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support-group/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SupportGroup} supportGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportGroup: (supportGroup, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supportGroup' is not null or undefined
            (0, common_1.assertParamExists)('saveSupportGroup', 'supportGroup', supportGroup);
            const localVarPath = `/api/admin/employee/support-group/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supportGroup, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SupportGroupRestControllerApiAxiosParamCreator = SupportGroupRestControllerApiAxiosParamCreator;
/**
 * SupportGroupRestControllerApi - functional programming interface
 * @export
 */
const SupportGroupRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SupportGroupRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.countSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportGroup(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSupportGroup(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.deleteOrDismissInBatchSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportGroup(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSupportGroup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.deleteOrDismissSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportGroup(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupportGroup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.getSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.listSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.pageSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SupportGroup} supportGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportGroup(supportGroup, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSupportGroup(supportGroup, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportGroupRestControllerApi.saveSupportGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SupportGroupRestControllerApiFp = SupportGroupRestControllerApiFp;
/**
 * SupportGroupRestControllerApi - factory interface
 * @export
 */
const SupportGroupRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SupportGroupRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportGroup(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportGroup(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportGroup(id, options) {
            return localVarFp.deleteOrDismissSupportGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportGroup(id, options) {
            return localVarFp.getSupportGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportGroup} supportGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportGroup(supportGroup, options) {
            return localVarFp.saveSupportGroup(supportGroup, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SupportGroupRestControllerApiFactory = SupportGroupRestControllerApiFactory;
/**
 * SupportGroupRestControllerApi - object-oriented interface
 * @export
 * @class SupportGroupRestControllerApi
 * @extends {BaseAPI}
 */
class SupportGroupRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    deleteOrDismissInBatchSupportGroup(ids, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSupportGroup(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    deleteOrDismissSupportGroup(id, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).deleteOrDismissSupportGroup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    getSupportGroup(id, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).getSupportGroup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportGroup} supportGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    saveSupportGroup(supportGroup, options) {
        return (0, exports.SupportGroupRestControllerApiFp)(this.configuration).saveSupportGroup(supportGroup, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SupportGroupRestControllerApi = SupportGroupRestControllerApi;
/**
 * SupportLinkRestControllerApi - axios parameter creator
 * @export
 */
const SupportLinkRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportLink: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support-link/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportLink: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSupportLink', 'ids', ids);
            const localVarPath = `/api/admin/employee/support-link/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportLink: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSupportLink', 'id', id);
            const localVarPath = `/api/admin/employee/support-link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportLink: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSupportLink', 'id', id);
            const localVarPath = `/api/admin/employee/support-link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportLink: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support-link/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportLink: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support-link/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SupportLink} supportLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportLink: (supportLink, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supportLink' is not null or undefined
            (0, common_1.assertParamExists)('saveSupportLink', 'supportLink', supportLink);
            const localVarPath = `/api/admin/employee/support-link/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supportLink, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SupportLinkRestControllerApiAxiosParamCreator = SupportLinkRestControllerApiAxiosParamCreator;
/**
 * SupportLinkRestControllerApi - functional programming interface
 * @export
 */
const SupportLinkRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SupportLinkRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportLink(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSupportLink(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.countSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportLink(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSupportLink(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.deleteOrDismissInBatchSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportLink(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSupportLink(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.deleteOrDismissSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportLink(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupportLink(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.getSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportLink(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSupportLink(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.listSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportLink(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSupportLink(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.pageSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SupportLink} supportLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportLink(supportLink, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSupportLink(supportLink, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportLinkRestControllerApi.saveSupportLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SupportLinkRestControllerApiFp = SupportLinkRestControllerApiFp;
/**
 * SupportLinkRestControllerApi - factory interface
 * @export
 */
const SupportLinkRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SupportLinkRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportLink(term, showDismissed, options) {
            return localVarFp.countSupportLink(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportLink(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportLink(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportLink(id, options) {
            return localVarFp.deleteOrDismissSupportLink(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportLink(id, options) {
            return localVarFp.getSupportLink(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportLink(term, showDismissed, options) {
            return localVarFp.listSupportLink(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportLink(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSupportLink(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportLink} supportLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportLink(supportLink, options) {
            return localVarFp.saveSupportLink(supportLink, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SupportLinkRestControllerApiFactory = SupportLinkRestControllerApiFactory;
/**
 * SupportLinkRestControllerApi - object-oriented interface
 * @export
 * @class SupportLinkRestControllerApi
 * @extends {BaseAPI}
 */
class SupportLinkRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    countSupportLink(term, showDismissed, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).countSupportLink(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    deleteOrDismissInBatchSupportLink(ids, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSupportLink(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    deleteOrDismissSupportLink(id, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).deleteOrDismissSupportLink(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    getSupportLink(id, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).getSupportLink(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    listSupportLink(term, showDismissed, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).listSupportLink(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    pageSupportLink(page, size, sort, term, showDismissed, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).pageSupportLink(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportLink} supportLink
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    saveSupportLink(supportLink, options) {
        return (0, exports.SupportLinkRestControllerApiFp)(this.configuration).saveSupportLink(supportLink, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SupportLinkRestControllerApi = SupportLinkRestControllerApi;
/**
 * SupportPointRestControllerApi - axios parameter creator
 * @export
 */
const SupportPointRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportPoint: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/question/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportPoint: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSupportPoint', 'ids', ids);
            const localVarPath = `/api/admin/employee/support/question/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportPoint: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSupportPoint', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportPoint: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSupportPoint', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportPoint: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/question/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportPoint: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/question/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SupportPoint} supportPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportPoint: (supportPoint, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supportPoint' is not null or undefined
            (0, common_1.assertParamExists)('saveSupportPoint', 'supportPoint', supportPoint);
            const localVarPath = `/api/admin/employee/support/question/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supportPoint, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SupportPointRestControllerApiAxiosParamCreator = SupportPointRestControllerApiAxiosParamCreator;
/**
 * SupportPointRestControllerApi - functional programming interface
 * @export
 */
const SupportPointRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SupportPointRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportPoint(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSupportPoint(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.countSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportPoint(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSupportPoint(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.deleteOrDismissInBatchSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportPoint(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSupportPoint(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.deleteOrDismissSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportPoint(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupportPoint(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.getSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportPoint(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSupportPoint(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.listSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportPoint(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSupportPoint(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.pageSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SupportPoint} supportPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportPoint(supportPoint, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSupportPoint(supportPoint, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportPointRestControllerApi.saveSupportPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SupportPointRestControllerApiFp = SupportPointRestControllerApiFp;
/**
 * SupportPointRestControllerApi - factory interface
 * @export
 */
const SupportPointRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SupportPointRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportPoint(term, showDismissed, options) {
            return localVarFp.countSupportPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportPoint(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportPoint(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportPoint(id, options) {
            return localVarFp.deleteOrDismissSupportPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportPoint(id, options) {
            return localVarFp.getSupportPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportPoint(term, showDismissed, options) {
            return localVarFp.listSupportPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportPoint(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSupportPoint(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportPoint} supportPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportPoint(supportPoint, options) {
            return localVarFp.saveSupportPoint(supportPoint, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SupportPointRestControllerApiFactory = SupportPointRestControllerApiFactory;
/**
 * SupportPointRestControllerApi - object-oriented interface
 * @export
 * @class SupportPointRestControllerApi
 * @extends {BaseAPI}
 */
class SupportPointRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    countSupportPoint(term, showDismissed, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).countSupportPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    deleteOrDismissInBatchSupportPoint(ids, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSupportPoint(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    deleteOrDismissSupportPoint(id, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).deleteOrDismissSupportPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    getSupportPoint(id, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).getSupportPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    listSupportPoint(term, showDismissed, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).listSupportPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    pageSupportPoint(page, size, sort, term, showDismissed, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).pageSupportPoint(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportPoint} supportPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    saveSupportPoint(supportPoint, options) {
        return (0, exports.SupportPointRestControllerApiFp)(this.configuration).saveSupportPoint(supportPoint, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SupportPointRestControllerApi = SupportPointRestControllerApi;
/**
 * SupportRestControllerApi - axios parameter creator
 * @export
 */
const SupportRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupport: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupport: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSupport', 'ids', ids);
            const localVarPath = `/api/admin/employee/support/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupport: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSupport', 'id', id);
            const localVarPath = `/api/admin/employee/support/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupport: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSupport', 'id', id);
            const localVarPath = `/api/admin/employee/support/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupport: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupport: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Support} support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupport: (support, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'support' is not null or undefined
            (0, common_1.assertParamExists)('saveSupport', 'support', support);
            const localVarPath = `/api/admin/employee/support/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(support, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SupportRestControllerApiAxiosParamCreator = SupportRestControllerApiAxiosParamCreator;
/**
 * SupportRestControllerApi - functional programming interface
 * @export
 */
const SupportRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SupportRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.countSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupport(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSupport(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.deleteOrDismissInBatchSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupport(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSupport(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.deleteOrDismissSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupport(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupport(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.getSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.listSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.pageSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Support} support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupport(support, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSupport(support, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportRestControllerApi.saveSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SupportRestControllerApiFp = SupportRestControllerApiFp;
/**
 * SupportRestControllerApi - factory interface
 * @export
 */
const SupportRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SupportRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupport(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupport(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupport(id, options) {
            return localVarFp.deleteOrDismissSupport(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupport(id, options) {
            return localVarFp.getSupport(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Support} support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupport(support, options) {
            return localVarFp.saveSupport(support, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SupportRestControllerApiFactory = SupportRestControllerApiFactory;
/**
 * SupportRestControllerApi - object-oriented interface
 * @export
 * @class SupportRestControllerApi
 * @extends {BaseAPI}
 */
class SupportRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    deleteOrDismissInBatchSupport(ids, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSupport(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    deleteOrDismissSupport(id, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).deleteOrDismissSupport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    getSupport(id, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).getSupport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Support} support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    saveSupport(support, options) {
        return (0, exports.SupportRestControllerApiFp)(this.configuration).saveSupport(support, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SupportRestControllerApi = SupportRestControllerApi;
/**
 * SupportResultRestControllerApi - axios parameter creator
 * @export
 */
const SupportResultRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportResult: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/question/result/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportResult: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchSupportResult', 'ids', ids);
            const localVarPath = `/api/admin/employee/support/question/result/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportResult: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissSupportResult', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportResult: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSupportResult', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportResult: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/question/result/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportResult: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/support/question/result/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SupportResult} supportResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportResult: (supportResult, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supportResult' is not null or undefined
            (0, common_1.assertParamExists)('saveSupportResult', 'supportResult', supportResult);
            const localVarPath = `/api/admin/employee/support/question/result/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supportResult, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SupportResultRestControllerApiAxiosParamCreator = SupportResultRestControllerApiAxiosParamCreator;
/**
 * SupportResultRestControllerApi - functional programming interface
 * @export
 */
const SupportResultRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SupportResultRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportResult(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countSupportResult(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.countSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportResult(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchSupportResult(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.deleteOrDismissInBatchSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportResult(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissSupportResult(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.deleteOrDismissSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportResult(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupportResult(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.getSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportResult(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSupportResult(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.listSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportResult(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageSupportResult(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.pageSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SupportResult} supportResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportResult(supportResult, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSupportResult(supportResult, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupportResultRestControllerApi.saveSupportResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SupportResultRestControllerApiFp = SupportResultRestControllerApiFp;
/**
 * SupportResultRestControllerApi - factory interface
 * @export
 */
const SupportResultRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SupportResultRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportResult(term, showDismissed, options) {
            return localVarFp.countSupportResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportResult(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportResult(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportResult(id, options) {
            return localVarFp.deleteOrDismissSupportResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportResult(id, options) {
            return localVarFp.getSupportResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportResult(term, showDismissed, options) {
            return localVarFp.listSupportResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportResult(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSupportResult(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportResult} supportResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportResult(supportResult, options) {
            return localVarFp.saveSupportResult(supportResult, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SupportResultRestControllerApiFactory = SupportResultRestControllerApiFactory;
/**
 * SupportResultRestControllerApi - object-oriented interface
 * @export
 * @class SupportResultRestControllerApi
 * @extends {BaseAPI}
 */
class SupportResultRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    countSupportResult(term, showDismissed, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).countSupportResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    deleteOrDismissInBatchSupportResult(ids, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).deleteOrDismissInBatchSupportResult(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    deleteOrDismissSupportResult(id, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).deleteOrDismissSupportResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    getSupportResult(id, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).getSupportResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    listSupportResult(term, showDismissed, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).listSupportResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    pageSupportResult(page, size, sort, term, showDismissed, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).pageSupportResult(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportResult} supportResult
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    saveSupportResult(supportResult, options) {
        return (0, exports.SupportResultRestControllerApiFp)(this.configuration).saveSupportResult(supportResult, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SupportResultRestControllerApi = SupportResultRestControllerApi;
/**
 * TemplateRestControllerApi - axios parameter creator
 * @export
 */
const TemplateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplate: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/system/template/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTemplate: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchTemplate', 'ids', ids);
            const localVarPath = `/api/admin/system/template/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTemplate: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissTemplate', 'id', id);
            const localVarPath = `/api/admin/system/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getTemplate', 'id', id);
            const localVarPath = `/api/admin/system/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplate: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/system/template/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTemplate: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/system/template/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Template} template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTemplate: (template, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'template' is not null or undefined
            (0, common_1.assertParamExists)('saveTemplate', 'template', template);
            const localVarPath = `/api/admin/system/template/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(template, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TemplateRestControllerApiAxiosParamCreator = TemplateRestControllerApiAxiosParamCreator;
/**
 * TemplateRestControllerApi - functional programming interface
 * @export
 */
const TemplateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TemplateRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplate(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countTemplate(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.countTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTemplate(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchTemplate(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.deleteOrDismissInBatchTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTemplate(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissTemplate(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.deleteOrDismissTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTemplate(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.getTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplate(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTemplate(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.listTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTemplate(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageTemplate(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.pageTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Template} template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTemplate(template, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveTemplate(template, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateRestControllerApi.saveTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.TemplateRestControllerApiFp = TemplateRestControllerApiFp;
/**
 * TemplateRestControllerApi - factory interface
 * @export
 */
const TemplateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TemplateRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplate(term, showDismissed, options) {
            return localVarFp.countTemplate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTemplate(ids, options) {
            return localVarFp.deleteOrDismissInBatchTemplate(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTemplate(id, options) {
            return localVarFp.deleteOrDismissTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(id, options) {
            return localVarFp.getTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplate(term, showDismissed, options) {
            return localVarFp.listTemplate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTemplate(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageTemplate(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Template} template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTemplate(template, options) {
            return localVarFp.saveTemplate(template, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TemplateRestControllerApiFactory = TemplateRestControllerApiFactory;
/**
 * TemplateRestControllerApi - object-oriented interface
 * @export
 * @class TemplateRestControllerApi
 * @extends {BaseAPI}
 */
class TemplateRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    countTemplate(term, showDismissed, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).countTemplate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    deleteOrDismissInBatchTemplate(ids, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).deleteOrDismissInBatchTemplate(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    deleteOrDismissTemplate(id, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).deleteOrDismissTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    getTemplate(id, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).getTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    listTemplate(term, showDismissed, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).listTemplate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    pageTemplate(page, size, sort, term, showDismissed, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).pageTemplate(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Template} template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    saveTemplate(template, options) {
        return (0, exports.TemplateRestControllerApiFp)(this.configuration).saveTemplate(template, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TemplateRestControllerApi = TemplateRestControllerApi;
/**
 * TrainingLevelRestControllerApi - axios parameter creator
 * @export
 */
const TrainingLevelRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingLevel: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/training-level/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingLevel: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchTrainingLevel', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/training-level/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingLevel: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissTrainingLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/training-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingLevel: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getTrainingLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/training-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingLevel: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/training-level/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingLevel: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/recruitment/training-level/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TrainingLevel} trainingLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingLevel: (trainingLevel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'trainingLevel' is not null or undefined
            (0, common_1.assertParamExists)('saveTrainingLevel', 'trainingLevel', trainingLevel);
            const localVarPath = `/api/admin/recruitment/training-level/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trainingLevel, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TrainingLevelRestControllerApiAxiosParamCreator = TrainingLevelRestControllerApiAxiosParamCreator;
/**
 * TrainingLevelRestControllerApi - functional programming interface
 * @export
 */
const TrainingLevelRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TrainingLevelRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingLevel(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countTrainingLevel(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.countTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingLevel(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchTrainingLevel(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.deleteOrDismissInBatchTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingLevel(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissTrainingLevel(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.deleteOrDismissTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingLevel(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTrainingLevel(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.getTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingLevel(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTrainingLevel(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.listTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingLevel(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageTrainingLevel(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.pageTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {TrainingLevel} trainingLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingLevel(trainingLevel, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveTrainingLevel(trainingLevel, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrainingLevelRestControllerApi.saveTrainingLevel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.TrainingLevelRestControllerApiFp = TrainingLevelRestControllerApiFp;
/**
 * TrainingLevelRestControllerApi - factory interface
 * @export
 */
const TrainingLevelRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TrainingLevelRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingLevel(term, showDismissed, options) {
            return localVarFp.countTrainingLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingLevel(ids, options) {
            return localVarFp.deleteOrDismissInBatchTrainingLevel(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingLevel(id, options) {
            return localVarFp.deleteOrDismissTrainingLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingLevel(id, options) {
            return localVarFp.getTrainingLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingLevel(term, showDismissed, options) {
            return localVarFp.listTrainingLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingLevel(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageTrainingLevel(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TrainingLevel} trainingLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingLevel(trainingLevel, options) {
            return localVarFp.saveTrainingLevel(trainingLevel, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TrainingLevelRestControllerApiFactory = TrainingLevelRestControllerApiFactory;
/**
 * TrainingLevelRestControllerApi - object-oriented interface
 * @export
 * @class TrainingLevelRestControllerApi
 * @extends {BaseAPI}
 */
class TrainingLevelRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    countTrainingLevel(term, showDismissed, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).countTrainingLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    deleteOrDismissInBatchTrainingLevel(ids, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).deleteOrDismissInBatchTrainingLevel(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    deleteOrDismissTrainingLevel(id, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).deleteOrDismissTrainingLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    getTrainingLevel(id, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).getTrainingLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    listTrainingLevel(term, showDismissed, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).listTrainingLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    pageTrainingLevel(page, size, sort, term, showDismissed, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).pageTrainingLevel(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TrainingLevel} trainingLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    saveTrainingLevel(trainingLevel, options) {
        return (0, exports.TrainingLevelRestControllerApiFp)(this.configuration).saveTrainingLevel(trainingLevel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TrainingLevelRestControllerApi = TrainingLevelRestControllerApi;
/**
 * UserRestControllerApi - axios parameter creator
 * @export
 */
const UserRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/user/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recover: (email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            (0, common_1.assertParamExists)('recover', 'email', email);
            const localVarPath = `/api/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} token
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redefine: (token, password, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('redefine', 'token', token);
            // verify required parameter 'password' is not null or undefined
            (0, common_1.assertParamExists)('redefine', 'password', password);
            const localVarPath = `/api/redefine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} email
         * @param {string} username
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: (email, username, password, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            (0, common_1.assertParamExists)('signup', 'email', email);
            // verify required parameter 'username' is not null or undefined
            (0, common_1.assertParamExists)('signup', 'username', username);
            // verify required parameter 'password' is not null or undefined
            (0, common_1.assertParamExists)('signup', 'password', password);
            const localVarPath = `/api/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('validate', 'token', token);
            const localVarPath = `/api/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserRestControllerApiAxiosParamCreator = UserRestControllerApiAxiosParamCreator;
/**
 * UserRestControllerApi - functional programming interface
 * @export
 */
const UserRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.info(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserRestControllerApi.info']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recover(email, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recover(email, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserRestControllerApi.recover']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} token
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redefine(token, password, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redefine(token, password, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserRestControllerApi.redefine']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} email
         * @param {string} username
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(email, username, password, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.signup(email, username, password, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserRestControllerApi.signup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validate(token, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserRestControllerApi.validate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.UserRestControllerApiFp = UserRestControllerApiFp;
/**
 * UserRestControllerApi - factory interface
 * @export
 */
const UserRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(options) {
            return localVarFp.info(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recover(email, options) {
            return localVarFp.recover(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} token
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redefine(token, password, options) {
            return localVarFp.redefine(token, password, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {string} username
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(email, username, password, options) {
            return localVarFp.signup(email, username, password, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(token, options) {
            return localVarFp.validate(token, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserRestControllerApiFactory = UserRestControllerApiFactory;
/**
 * UserRestControllerApi - object-oriented interface
 * @export
 * @class UserRestControllerApi
 * @extends {BaseAPI}
 */
class UserRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    info(options) {
        return (0, exports.UserRestControllerApiFp)(this.configuration).info(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    recover(email, options) {
        return (0, exports.UserRestControllerApiFp)(this.configuration).recover(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} token
     * @param {string} password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    redefine(token, password, options) {
        return (0, exports.UserRestControllerApiFp)(this.configuration).redefine(token, password, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {string} username
     * @param {string} password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    signup(email, username, password, options) {
        return (0, exports.UserRestControllerApiFp)(this.configuration).signup(email, username, password, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    validate(token, options) {
        return (0, exports.UserRestControllerApiFp)(this.configuration).validate(token, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserRestControllerApi = UserRestControllerApi;
/**
 * VacationRestControllerApi - axios parameter creator
 * @export
 */
const VacationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVacation: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/vacations/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVacation: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchVacation', 'ids', ids);
            const localVarPath = `/api/admin/employee/vacations/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVacation: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissVacation', 'id', id);
            const localVarPath = `/api/admin/employee/vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayCalendarVacation: (startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('getHolidayCalendarVacation', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('getHolidayCalendarVacation', 'endDate', endDate);
            const localVarPath = `/api/admin/employee/vacations/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacation: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getVacation', 'id', id);
            const localVarPath = `/api/admin/employee/vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVacation: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/vacations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVacation: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/vacations/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Vacation} vacation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVacation: (vacation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vacation' is not null or undefined
            (0, common_1.assertParamExists)('saveVacation', 'vacation', vacation);
            const localVarPath = `/api/admin/employee/vacations/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vacation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.VacationRestControllerApiAxiosParamCreator = VacationRestControllerApiAxiosParamCreator;
/**
 * VacationRestControllerApi - functional programming interface
 * @export
 */
const VacationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.VacationRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.countVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVacation(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchVacation(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.deleteOrDismissInBatchVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVacation(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissVacation(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.deleteOrDismissVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayCalendarVacation(startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHolidayCalendarVacation(startDate, endDate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.getHolidayCalendarVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacation(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVacation(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.getVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.listVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.pageVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Vacation} vacation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVacation(vacation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveVacation(vacation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VacationRestControllerApi.saveVacation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.VacationRestControllerApiFp = VacationRestControllerApiFp;
/**
 * VacationRestControllerApi - factory interface
 * @export
 */
const VacationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.VacationRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVacation(ids, options) {
            return localVarFp.deleteOrDismissInBatchVacation(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVacation(id, options) {
            return localVarFp.deleteOrDismissVacation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayCalendarVacation(startDate, endDate, options) {
            return localVarFp.getHolidayCalendarVacation(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacation(id, options) {
            return localVarFp.getVacation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Vacation} vacation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVacation(vacation, options) {
            return localVarFp.saveVacation(vacation, options).then((request) => request(axios, basePath));
        },
    };
};
exports.VacationRestControllerApiFactory = VacationRestControllerApiFactory;
/**
 * VacationRestControllerApi - object-oriented interface
 * @export
 * @class VacationRestControllerApi
 * @extends {BaseAPI}
 */
class VacationRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    deleteOrDismissInBatchVacation(ids, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).deleteOrDismissInBatchVacation(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    deleteOrDismissVacation(id, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).deleteOrDismissVacation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    getHolidayCalendarVacation(startDate, endDate, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).getHolidayCalendarVacation(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    getVacation(id, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).getVacation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Vacation} vacation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    saveVacation(vacation, options) {
        return (0, exports.VacationRestControllerApiFp)(this.configuration).saveVacation(vacation, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VacationRestControllerApi = VacationRestControllerApi;
/**
 * WikiPageRestControllerApi - axios parameter creator
 * @export
 */
const WikiPageRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWikiPage: (section, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'section' is not null or undefined
            (0, common_1.assertParamExists)('countWikiPage', 'section', section);
            const localVarPath = `/api/admin/employee/wiki/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWikiPage: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchWikiPage', 'ids', ids);
            const localVarPath = `/api/admin/employee/wiki/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWikiPage: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissWikiPage', 'id', id);
            const localVarPath = `/api/admin/employee/wiki/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} wikiId
         * @param {number} num
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachmentWikiPage: (wikiId, num, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wikiId' is not null or undefined
            (0, common_1.assertParamExists)('downloadAttachmentWikiPage', 'wikiId', wikiId);
            // verify required parameter 'num' is not null or undefined
            (0, common_1.assertParamExists)('downloadAttachmentWikiPage', 'num', num);
            const localVarPath = `/api/admin/employee/wiki/{wikiId}/document/{num}`
                .replace(`{${"wikiId"}}`, encodeURIComponent(String(wikiId)))
                .replace(`{${"num"}}`, encodeURIComponent(String(num)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWikiPage: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getWikiPage', 'id', id);
            const localVarPath = `/api/admin/employee/wiki/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWikiPage: (section, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'section' is not null or undefined
            (0, common_1.assertParamExists)('listWikiPage', 'section', section);
            const localVarPath = `/api/admin/employee/wiki/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} section
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWikiPage: (section, page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'section' is not null or undefined
            (0, common_1.assertParamExists)('pageWikiPage', 'section', section);
            const localVarPath = `/api/admin/employee/wiki/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {WikiPage} wikiPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWikiPage: (wikiPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wikiPage' is not null or undefined
            (0, common_1.assertParamExists)('saveWikiPage', 'wikiPage', wikiPage);
            const localVarPath = `/api/admin/employee/wiki/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wikiPage, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WikiPageRestControllerApiAxiosParamCreator = WikiPageRestControllerApiAxiosParamCreator;
/**
 * WikiPageRestControllerApi - functional programming interface
 * @export
 */
const WikiPageRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WikiPageRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWikiPage(section, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countWikiPage(section, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.countWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWikiPage(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchWikiPage(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.deleteOrDismissInBatchWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWikiPage(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissWikiPage(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.deleteOrDismissWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} wikiId
         * @param {number} num
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachmentWikiPage(wikiId, num, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadAttachmentWikiPage(wikiId, num, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.downloadAttachmentWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWikiPage(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWikiPage(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.getWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWikiPage(section, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWikiPage(section, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.listWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} section
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWikiPage(section, page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageWikiPage(section, page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.pageWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {WikiPage} wikiPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWikiPage(wikiPage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveWikiPage(wikiPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WikiPageRestControllerApi.saveWikiPage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.WikiPageRestControllerApiFp = WikiPageRestControllerApiFp;
/**
 * WikiPageRestControllerApi - factory interface
 * @export
 */
const WikiPageRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WikiPageRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWikiPage(section, term, showDismissed, options) {
            return localVarFp.countWikiPage(section, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWikiPage(ids, options) {
            return localVarFp.deleteOrDismissInBatchWikiPage(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWikiPage(id, options) {
            return localVarFp.deleteOrDismissWikiPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} wikiId
         * @param {number} num
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachmentWikiPage(wikiId, num, options) {
            return localVarFp.downloadAttachmentWikiPage(wikiId, num, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWikiPage(id, options) {
            return localVarFp.getWikiPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWikiPage(section, term, showDismissed, options) {
            return localVarFp.listWikiPage(section, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} section
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWikiPage(section, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageWikiPage(section, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WikiPage} wikiPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWikiPage(wikiPage, options) {
            return localVarFp.saveWikiPage(wikiPage, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WikiPageRestControllerApiFactory = WikiPageRestControllerApiFactory;
/**
 * WikiPageRestControllerApi - object-oriented interface
 * @export
 * @class WikiPageRestControllerApi
 * @extends {BaseAPI}
 */
class WikiPageRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} section
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    countWikiPage(section, term, showDismissed, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).countWikiPage(section, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    deleteOrDismissInBatchWikiPage(ids, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).deleteOrDismissInBatchWikiPage(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    deleteOrDismissWikiPage(id, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).deleteOrDismissWikiPage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} wikiId
     * @param {number} num
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    downloadAttachmentWikiPage(wikiId, num, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).downloadAttachmentWikiPage(wikiId, num, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    getWikiPage(id, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).getWikiPage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} section
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    listWikiPage(section, term, showDismissed, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).listWikiPage(section, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} section
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    pageWikiPage(section, page, size, sort, term, showDismissed, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).pageWikiPage(section, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WikiPage} wikiPage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    saveWikiPage(wikiPage, options) {
        return (0, exports.WikiPageRestControllerApiFp)(this.configuration).saveWikiPage(wikiPage, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WikiPageRestControllerApi = WikiPageRestControllerApi;
/**
 * WorkAuditControllerApi - axios parameter creator
 * @export
 */
const WorkAuditControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [start]
         * @param {string} [end]
         * @param {Array<number>} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkAudits: (start, end, person, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/controlling/work-audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = (start instanceof Date) ?
                    start.toISOString() :
                    start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = (end instanceof Date) ?
                    end.toISOString() :
                    end;
            }
            if (person) {
                localVarQueryParameter['person'] = person;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WorkAuditControllerApiAxiosParamCreator = WorkAuditControllerApiAxiosParamCreator;
/**
 * WorkAuditControllerApi - functional programming interface
 * @export
 */
const WorkAuditControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WorkAuditControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [start]
         * @param {string} [end]
         * @param {Array<number>} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkAudits(start, end, person, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkAudits(start, end, person, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkAuditControllerApi.getWorkAudits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.WorkAuditControllerApiFp = WorkAuditControllerApiFp;
/**
 * WorkAuditControllerApi - factory interface
 * @export
 */
const WorkAuditControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WorkAuditControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [start]
         * @param {string} [end]
         * @param {Array<number>} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkAudits(start, end, person, options) {
            return localVarFp.getWorkAudits(start, end, person, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WorkAuditControllerApiFactory = WorkAuditControllerApiFactory;
/**
 * WorkAuditControllerApi - object-oriented interface
 * @export
 * @class WorkAuditControllerApi
 * @extends {BaseAPI}
 */
class WorkAuditControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [start]
     * @param {string} [end]
     * @param {Array<number>} [person]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkAuditControllerApi
     */
    getWorkAudits(start, end, person, options) {
        return (0, exports.WorkAuditControllerApiFp)(this.configuration).getWorkAudits(start, end, person, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WorkAuditControllerApi = WorkAuditControllerApi;
/**
 * WorkBookingRestControllerApi - axios parameter creator
 * @export
 */
const WorkBookingRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkBooking: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/booking/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkBooking: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchWorkBooking', 'ids', ids);
            const localVarPath = `/api/admin/employee/booking/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkBooking: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissWorkBooking', 'id', id);
            const localVarPath = `/api/admin/employee/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkBooking: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getWorkBooking', 'id', id);
            const localVarPath = `/api/admin/employee/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkBooking: (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/booking/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkBooking: (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/booking/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {WorkBooking} workBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkBooking: (workBooking, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workBooking' is not null or undefined
            (0, common_1.assertParamExists)('saveWorkBooking', 'workBooking', workBooking);
            const localVarPath = `/api/admin/employee/booking/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workBooking, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WorkBookingRestControllerApiAxiosParamCreator = WorkBookingRestControllerApiAxiosParamCreator;
/**
 * WorkBookingRestControllerApi - functional programming interface
 * @export
 */
const WorkBookingRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WorkBookingRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.countWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkBooking(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchWorkBooking(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.deleteOrDismissInBatchWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkBooking(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissWorkBooking(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.deleteOrDismissWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkBooking(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkBooking(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.getWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.listWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.pageWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {WorkBooking} workBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkBooking(workBooking, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveWorkBooking(workBooking, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkBookingRestControllerApi.saveWorkBooking']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.WorkBookingRestControllerApiFp = WorkBookingRestControllerApiFp;
/**
 * WorkBookingRestControllerApi - factory interface
 * @export
 */
const WorkBookingRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WorkBookingRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkBooking(ids, options) {
            return localVarFp.deleteOrDismissInBatchWorkBooking(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkBooking(id, options) {
            return localVarFp.deleteOrDismissWorkBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkBooking(id, options) {
            return localVarFp.getWorkBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WorkBooking} workBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkBooking(workBooking, options) {
            return localVarFp.saveWorkBooking(workBooking, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WorkBookingRestControllerApiFactory = WorkBookingRestControllerApiFactory;
/**
 * WorkBookingRestControllerApi - object-oriented interface
 * @export
 * @class WorkBookingRestControllerApi
 * @extends {BaseAPI}
 */
class WorkBookingRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    deleteOrDismissInBatchWorkBooking(ids, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).deleteOrDismissInBatchWorkBooking(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    deleteOrDismissWorkBooking(id, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).deleteOrDismissWorkBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    getWorkBooking(id, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).getWorkBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkBooking} workBooking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    saveWorkBooking(workBooking, options) {
        return (0, exports.WorkBookingRestControllerApiFp)(this.configuration).saveWorkBooking(workBooking, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WorkBookingRestControllerApi = WorkBookingRestControllerApi;
/**
 * WorkCenterRestControllerApi - axios parameter creator
 * @export
 */
const WorkCenterRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkCenter: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/center/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkCenter: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissInBatchWorkCenter', 'ids', ids);
            const localVarPath = `/api/admin/employee/center/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkCenter: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrDismissWorkCenter', 'id', id);
            const localVarPath = `/api/admin/employee/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCenter: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getWorkCenter', 'id', id);
            const localVarPath = `/api/admin/employee/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkCenter: (term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/center/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkCenter: (page, size, sort, term, showDismissed, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/employee/center/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {WorkCenter} workCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkCenter: (workCenter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workCenter' is not null or undefined
            (0, common_1.assertParamExists)('saveWorkCenter', 'workCenter', workCenter);
            const localVarPath = `/api/admin/employee/center/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workCenter, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WorkCenterRestControllerApiAxiosParamCreator = WorkCenterRestControllerApiAxiosParamCreator;
/**
 * WorkCenterRestControllerApi - functional programming interface
 * @export
 */
const WorkCenterRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WorkCenterRestControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkCenter(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countWorkCenter(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.countWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkCenter(ids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissInBatchWorkCenter(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.deleteOrDismissInBatchWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkCenter(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrDismissWorkCenter(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.deleteOrDismissWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCenter(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkCenter(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.getWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkCenter(term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkCenter(term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.listWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkCenter(page, size, sort, term, showDismissed, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pageWorkCenter(page, size, sort, term, showDismissed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.pageWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {WorkCenter} workCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkCenter(workCenter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveWorkCenter(workCenter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WorkCenterRestControllerApi.saveWorkCenter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.WorkCenterRestControllerApiFp = WorkCenterRestControllerApiFp;
/**
 * WorkCenterRestControllerApi - factory interface
 * @export
 */
const WorkCenterRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WorkCenterRestControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkCenter(term, showDismissed, options) {
            return localVarFp.countWorkCenter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkCenter(ids, options) {
            return localVarFp.deleteOrDismissInBatchWorkCenter(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkCenter(id, options) {
            return localVarFp.deleteOrDismissWorkCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCenter(id, options) {
            return localVarFp.getWorkCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkCenter(term, showDismissed, options) {
            return localVarFp.listWorkCenter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkCenter(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageWorkCenter(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WorkCenter} workCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkCenter(workCenter, options) {
            return localVarFp.saveWorkCenter(workCenter, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WorkCenterRestControllerApiFactory = WorkCenterRestControllerApiFactory;
/**
 * WorkCenterRestControllerApi - object-oriented interface
 * @export
 * @class WorkCenterRestControllerApi
 * @extends {BaseAPI}
 */
class WorkCenterRestControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    countWorkCenter(term, showDismissed, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).countWorkCenter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    deleteOrDismissInBatchWorkCenter(ids, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).deleteOrDismissInBatchWorkCenter(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    deleteOrDismissWorkCenter(id, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).deleteOrDismissWorkCenter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    getWorkCenter(id, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).getWorkCenter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    listWorkCenter(term, showDismissed, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).listWorkCenter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    pageWorkCenter(page, size, sort, term, showDismissed, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).pageWorkCenter(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkCenter} workCenter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    saveWorkCenter(workCenter, options) {
        return (0, exports.WorkCenterRestControllerApiFp)(this.configuration).saveWorkCenter(workCenter, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WorkCenterRestControllerApi = WorkCenterRestControllerApi;
